webpackJsonp([16],{

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ErrorPage = __webpack_require__(621);

module.exports = {
  componentDidMount: function componentDidMount() {
    this.errorPage = new ErrorPage('.error-page-wrapper', this.props.page_type, this.props.template);
    this.errorPage.initialize();
    if (!!this.props.page_code && this.props.has_status_page === 'customer') {
      this.fetch(this.props.page_code, this.props.page_type);
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.page_code != nextProps.page_code) {
      this.fetch(nextProps.page_code, this.props.page_type);
    } else if (nextProps.has_status_page != this.props.has_status_page && nextProps.has_status_page === 'customer' && !!this.props.page_code) {
      this.fetch(this.props.page_code, this.props.page_type);
    }
  },
  fetch: function fetch(code, type) {
    var url = this.props.hosted_host.replace('hosted', code);
    this.errorPage.fetchStatus(url, type);
  }
};

/***/ }),

/***/ 1133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _component_loader = __webpack_require__(102);

var _component_loader2 = _interopRequireDefault(_component_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(79);

window.ConsentHub = __webpack_require__(1134);

(0, _component_loader2.default)({
  ConfirmModal: __webpack_require__(84),
  AccessControlSearch: __webpack_require__(1135),
  BetterErrorPagesGetStarted: __webpack_require__(1136),
  ComponentToggler: __webpack_require__(1172),
  HostHelper: __webpack_require__(1177),
  ExceedingAllocationsDashboard: __webpack_require__(1180),
  ImportSubscriberForm: __webpack_require__(1181),
  IncidentsSearchField: __webpack_require__(1182),
  IncidentTemplates: __webpack_require__(1245),
  IncidentTemplateForm: __webpack_require__(1249),
  ItemsSelector: __webpack_require__(170),
  ModifyUser: __webpack_require__(1252),
  OrganizationPages: __webpack_require__(1255),
  PageAccessUsersForm: __webpack_require__(1259),
  PageAccessSearchField: __webpack_require__(1261),
  PageSubscription: __webpack_require__(1263),
  NotificationsSubscriberManager: __webpack_require__(1264),
  ResendConfirmationLink: __webpack_require__(1276),
  SingleSignOnForm: __webpack_require__(1277),
  SsoMetrics: __webpack_require__(1278),
  StrideConversations: __webpack_require__(1279),
  StrideConversationsAdminInfo: __webpack_require__(1280),
  SubscribersSearchField: __webpack_require__(1281),
  UnsubscribeButton: __webpack_require__(1282),
  ManageSubscription: __webpack_require__(1283),
  BackfillDateTimePicker: __webpack_require__(1287)
});

/***/ }),

/***/ 1134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchLocale"] = fetchLocale;
/* harmony export (immutable) */ __webpack_exports__["doesLocaleRequireGeneralMarketingConsent"] = doesLocaleRequireGeneralMarketingConsent;
/* harmony export (immutable) */ __webpack_exports__["fetchConsentState"] = fetchConsentState;
/* harmony export (immutable) */ __webpack_exports__["setConsentState"] = setConsentState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

/**
 * Fetch the GEORGRAPHIC locale of this IP from ConsentHub.
 * This is NOT a language locale; this returns a best guess for a LEGAL, GEOGRAPHICAL entity to which the IP belongs.
 *
 * @param basePreferencesUrl The base url for the locale endpoint. This is environment-specific.
 * @param done The callback when the request has finished. If there is a locale, the locale is passed; otherwise, including if there was an error, locale is null.
 */
function fetchLocale(basePreferencesUrl, done) {
    __WEBPACK_IMPORTED_MODULE_0_jquery__["get"](basePreferencesUrl + "/rest/forms/locale").
        done(function (body) { return done(body['locale']); }).
        fail(function () { return done(null); });
}
/**
 * Fetch whether the locale requires we collect consent from an endpoint we maintain in our own app, /marketing-consent-required.
 *
 * @param locale The locale to check for consent requirements.
 * @param done The callback on conclusion of the request. Called with 'required' reflecting whether or not the checkbox is required.
 */
function doesLocaleRequireGeneralMarketingConsent(locale, done) {
    __WEBPACK_IMPORTED_MODULE_0_jquery__["get"]('/marketing-consent-required?locale=' + locale)
        .done(function (body) {
        done(body.should_display_general_marketing_consent_checkbox);
    })
        .fail(function () { return done(true); }); // err on the side of caution and display it anyway; if it's unnecessary it's ignored anyway.
}
/**
 * Fetch whether the locale requires we collect consent from an endpoint we maintain in our own app, /marketing-consent.
 * This may also possibly auto-consent a user, in which case we can hide the banner.
 *
 * @param locale  The locale to check for consent requirements.
 * @param done The callback when the request completes successfully.
 */
function fetchConsentState(locale, done) {
    __WEBPACK_IMPORTED_MODULE_0_jquery__["get"]('/marketing-consent?locale=' + locale)
        .done(function (body) { return done(body.should_display_general_marketing_consent_banner); })
        .fail(function () { return done(true); }); // err on the side of caution and display it anyway; if it's unnecessary it's ignored anyway.
}
/**
 * Give a decsion whether to grant the generalMarketingOptIn consent or not.
 *
 * @param locale The geographic locale of the user.
 * @param general_marketing_opt_in_result true means the user is giving their consent, false means they are not.
 * @param done The callback when the request has completed successfully.
 */
function setConsentState(locale, general_marketing_opt_in_result, done) {
    __WEBPACK_IMPORTED_MODULE_0_jquery__["post"]('/marketing-consent', { locale: locale, general_marketing_opt_in_result: general_marketing_opt_in_result })
        .done(function (_body) {
        done(true);
    })
        .fail(function (_error) { return done(true); });
}


/***/ }),

/***/ 1135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var inflect = __webpack_require__(141).inflect;
var _ = __webpack_require__(47);

var AccessControlSearch = function (_React$Component) {
  _inherits(AccessControlSearch, _React$Component);

  function AccessControlSearch(props) {
    _classCallCheck(this, AccessControlSearch);

    var _this = _possibleConstructorReturn(this, (AccessControlSearch.__proto__ || Object.getPrototypeOf(AccessControlSearch)).call(this, props));

    _this.searchSource = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: window.location.href.split('?')[0] + '/search?q=%QUERY',
        wildcard: '%QUERY',
        transform: function (response) {

          var groupResults = response.page_access_groups.map(function (group) {
            return {
              id: group.id,
              type: 'group',
              name: group.name,
              link: window.location.href.split('#')[0].replace('access-control', 'page-access-groups/') + group.id + '/edit',
              metadata: this.humanizedMetadata(group)
            };
          }.bind(this));

          var userResults = response.page_access_users.map(function (user) {
            return {
              id: user.id,
              type: 'user',
              name: user.email,
              link: window.location.href.split('#')[0].replace('access-control', 'page-access-users/') + user.id + (props.read_only ? '' : '/edit'),
              metadata: this.humanizedMetadata(user)
            };
          }.bind(this));

          // console.log(groupResults.concat(userResults));
          return groupResults.concat(userResults);
        }.bind(_this)
      }
    });
    return _this;
  }

  _createClass(AccessControlSearch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $(this.refs.input).typeahead(null, {
        name: 'access-control',
        display: 'name',
        source: this.searchSource,
        templates: {
          suggestion: _.template('<div class="item search-result" data-js-hook="page-access-<%= type %>-<%= id %>" onClick="window.location = \'<%= link %>\'">' + '<div class="main">' + '<% if (type === "group") { %>' + '<i class="fa fa-users"></i>' + '<% } else { %>' + '<i class="fa fa-user"></i>' + '<% } %>' + '<span class="name"><%= name %></span>' + '</div>' + '<div class="secondary small">' + '<span><%= metadata %></span>' + '</div>' + '</div>')
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      $(this.refs.input).typeahead('destroy');
    }
  }, {
    key: 'humanizedMetadata',
    value: function humanizedMetadata(actor) {
      if (actor.group) {
        return 'Belongs to ' + actor.group;
      }
      var list = [];
      _.each(['component', 'metric'], function (field) {
        if (actor[field + 's_list'] === undefined) return;
        var count = actor[field + 's_list'].length;
        if (count > 0) {
          list.push(count + ' ' + inflect(field, count));
        }
      });
      if (list.length > 0) {
        return 'Has access to ' + list.join(' and ');
      } else {
        return 'Has no access to any components or metrics';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'search-bar', style: { position: 'relative' } },
        React.createElement('i', { className: 'mag-glass fa fa-search' }),
        React.createElement('i', { className: 'fa fa-times-circle', style: { display: 'none' } }),
        React.createElement('input', { type: 'text',
          ref: 'input',
          className: 'typeahead form-control full-width',
          id: 'access-control-search',
          placeholder: 'search by name, email, group or id' })
      );
    }
  }]);

  return AccessControlSearch;
}(React.Component);

module.exports = AccessControlSearch;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var _ = __webpack_require__(47);
var Preview = __webpack_require__(1137);
var Header = __webpack_require__(1157);
var Buttons = __webpack_require__(1158);
var PageToggler = __webpack_require__(1159);
var ErrorPage = __webpack_require__(621);

// Questions
var Welcome = __webpack_require__(1160); // Step 0
var HaveStatusPage = __webpack_require__(1161); // Step 1
var UrlsForm = __webpack_require__(1163); // Step 2
var ChooseTemplate = __webpack_require__(1164); // Step 3
var Personalize = __webpack_require__(1165); // Step 4
var Download = __webpack_require__(1170); // Step 5
var ThankYou = __webpack_require__(1171); // Step 6

var GetStarted = function (_React$Component) {
  _inherits(GetStarted, _React$Component);

  function GetStarted(props) {
    _classCallCheck(this, GetStarted);

    var newProps = Object.assign({}, props);
    newProps = props.bep;
    newProps.reddit_link = props.reddit_link || '';
    newProps.hacker_news_link = props.hacker_news_link || '';
    newProps.product_hunt_link = props.product_hunt_link || '';
    newProps.thumbnails = props.thumbnails;
    newProps.defaults = props.defaults;

    var _this = _possibleConstructorReturn(this, (GetStarted.__proto__ || Object.getPrototypeOf(GetStarted)).call(this, props));

    var state = props.bep;
    state.loggedIn = window.loggedIn;
    state.page_type = '503';
    state.subscribe_to_news_letter = true;
    state.step = 0;
    state.downloadRequestSent = false;

    _this.state = state;
    _this.cache = {};

    _this.pushStateToServer = _.debounce(function () {
      // If there's nothing to update, don't push an update!
      if (Object.keys(_this.cache).length === 0) return;
      $.ajax({
        url: '/customize/' + _this.props.bep.id,
        type: 'PUT',
        data: { bep: _this.cache }
      }).always(function () {
        this.cache = {};
      }.bind(_this));
    }, 200);

    _this.getCodeFromUrl = _.debounce(function (value) {
      $.ajax({
        type: "GET",
        url: '/page_code?q=' + value
      }).success(function (response) {
        this.update('page_code', response.page.id);
      }.bind(_this)).fail(function () {
        ErrorPage.prototype.handleStatusFetchFail();
        this.triggerAlert('The Statuspage URL or code you entered was invalid.  Please try again.', 'error');
        this.setState({ page_code: null });
      }.bind(_this));
    }, 1000);
    return _this;
  }

  _createClass(GetStarted, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setWalkthroughHeight();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setWalkthroughHeight();
      $(window).on('resize', this.setWalkthroughHeight);

      this.preloadImages();
    }
  }, {
    key: 'preloadImages',
    value: function preloadImages() {
      // preloads template images to prevent need to resize after the step is shown
      var img1 = new Image(),
          img2 = new Image(),
          img3 = new Image();

      img1.src = this.props.thumbnails.plain;
      img2.src = this.props.thumbnails.background;
      img3.src = this.props.thumbnails.sign;
    }
  }, {
    key: 'setWalkthroughHeight',
    value: function setWalkthroughHeight() {
      var $elem = $('.step-container'),
          $wkHeader = $('.walkthrough-header'),
          $wkButtons = $('.walkthrough-buttons'),
          difference = ($(window).innerHeight() - $elem.outerHeight() - $wkHeader.outerHeight() - $wkButtons.outerHeight()) / 2;

      $elem.css('max-height', $(window).innerHeight() - $wkHeader.outerHeight() - $wkButtons.outerHeight());

      if (difference > 0) {
        $elem.css('margin-top', difference).css('margin-bottom', difference);
      } else {
        $elem.css('margin-top', 0).css('margin-bottom', 0);
      }
    }
  }, {
    key: 'resetDefaultValues',
    value: function resetDefaultValues(template) {
      var defaults = this.props.defaults[template];

      for (var prop in defaults) {
        if (prop == 'template') {
          return;
        }

        this.update(prop, defaults[prop]);
      }
    }
  }, {
    key: 'update',
    value: function update(key, value) {
      var _this2 = this;

      var newState = {};
      newState[key] = value;

      if (key === 'has_status_page') {
        newState.page_code = null;
      }

      // We need to cache our updates so the debounced server update posts everything
      this.cache[key] = value;

      this.setState(newState, function (state) {

        if (key === 'template') _this2.resetDefaultValues(value);

        if (key === 'status_page_url' && _this2.state.has_status_page === 'customer' && !!_this2.state.status_page_url) {
          _this2.getCodeFromUrl(value);
        }

        _this2.pushStateToServer();
      });
    }
  }, {
    key: 'renderQuestion',
    value: function renderQuestion() {
      switch (this.state.step) {
        case 0:
          return React.createElement(Welcome, null);
        case 1:
          return React.createElement(HaveStatusPage, _extends({}, this.state, { onChange: this.update.bind(this) }));
        case 2:
          return React.createElement(UrlsForm, _extends({}, this.state, { onChange: this.update.bind(this) }));
        case 3:
          return React.createElement(ChooseTemplate, _extends({}, this.state, { onChange: this.update.bind(this) }));
        case 4:
          return React.createElement(Personalize, _extends({}, this.state, { onChange: this.update.bind(this),
            resetDefaultValues: this.resetDefaultValues.bind(this) }));
        case 5:
          return React.createElement(Download, _extends({}, this.state, { onChange: this.update.bind(this) }));
        case 6:
          return React.createElement(ThankYou, _extends({}, this.state, { onChange: this.update.bind(this) }));
        default:
          return React.createElement(Welcome, _extends({}, this.state, { onChange: this.update.bind(this) }));
      }
    }
  }, {
    key: 'triggerAlert',
    value: function triggerAlert(text, type) {
      HRB.utils.notify(text, { cssClass: type });
    }
  }, {
    key: 'canContinue',
    value: function canContinue() {
      if (this.state.step === 5 && this.state.send_to_email_address && this.state.send_to_email_address.indexOf('@') > 1) {
        return true;
      } else if (this.state.step === 2 && this.state.has_status_page === 'customer' && !this.state.page_code) {
        return false;
      }
      return this.state.step <= 4 && this.state !== 6;
    }
  }, {
    key: 'canGoBack',
    value: function canGoBack() {
      return this.state.step !== 0;
    }
  }, {
    key: 'continue',
    value: function _continue() {
      if (this.canContinue()) {
        if (this.state.step === 1 && this.state.has_status_page === 'customer' && !!this.state.status_page_url && !this.state.page_code) {
          // If customer is selected, and a status page url is defined and page code is not, pull the page code
          this.getCodeFromUrl(this.state.status_page_url);
        }

        if (this.state.step === 5 && this.state.downloadRequestSent === false) {
          this.submitDownloadRequest();
        }
        this.setState({ step: this.state.step + 1 });
      }
    }
  }, {
    key: 'back',
    value: function back() {
      if (this.canGoBack()) {
        this.setState({ step: this.state.step - 1 });
      }
    }
  }, {
    key: 'continueText',
    value: function continueText() {
      if (this.state.step === 6) return null;
      return this.state.step === 5 ? 'Get Error Pages' : 'Continue';
    }
  }, {
    key: 'backText',
    value: function backText() {
      return this.state.step <= 1 ? null : 'Back';
    }
  }, {
    key: 'submitDownloadRequest',
    value: function submitDownloadRequest() {
      $.ajax({
        type: 'POST',
        url: '/request_download',
        data: {
          download_request: {
            send_to_email_address: this.state.send_to_email_address,
            bep_id: this.props.bep.id,
            subscribe_to_news_letter: this.state.subscribe_to_news_letter
          }
        },
        success: function success(response) {}
      });
      this.state.downloadRequestSent = true;
    }
  }, {
    key: 'setPageType',
    value: function setPageType(type) {
      this.update('page_type', type);
    }
  }, {
    key: 'preview',
    value: function preview() {
      if (this.state.step > 2 && this.state.step !== 6) {
        return React.createElement(
          'div',
          { className: 'preview-container' },
          React.createElement(PageToggler, _extends({}, this.state, { onChange: this.setPageType.bind(this) })),
          React.createElement(Preview, this.state)
        );
      }
      var height = $(window).outerHeight() + 'px';
      return React.createElement(
        'div',
        { className: 'preview-container', style: { display: 'table' } },
        React.createElement(
          'div',
          {
            style: { height: height, width: '100%', background: '#ddd', textAlign: 'center', display: 'table-cell', verticalAlign: 'middle' } },
          React.createElement('img', { src: this.props.logo_url, style: { width: '25%' } })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'walkthrough-container' },
          React.createElement(Header, { logoUrl: this.props.logo_url }),
          this.renderQuestion(),
          React.createElement(Buttons, {
            'continue': this.continue.bind(this),
            back: this.back.bind(this),
            continueText: this.continueText(),
            backText: this.backText()
          })
        ),
        this.preview()
      );
    }
  }]);

  return GetStarted;
}(React.Component);

module.exports = GetStarted;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var React = __webpack_require__(0);
var Templates = __webpack_require__(1138);
var CustomStylesMixin = __webpack_require__(85);

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({

  displayName: 'Preview',

  mixins: [CustomStylesMixin],

  componentDidMount: function componentDidMount() {
    this.has_status_page_value = this.props.has_status_page;
    this.setPreviewHeight();
    $(window).on('resize.setPreviewHeight', this.setPreviewHeight);
  },

  componentWillUnmount: function componentWillUnmount() {
    $(window).off('resize.setPreviewHeight');
  },

  componentDidUpdate: function componentDidUpdate() {
    if (this.has_status_page_value !== this.props.has_status_page) {
      $(this.refs.errorPageWrapper).trigger('resize');
    }
  },

  setPreviewHeight: function setPreviewHeight() {
    var $header = $('.bep-customize-header'),
        remainingHeight = window.innerHeight - $header.outerHeight(),
        optionSetHeight = $('.option-set').filter(':visible').outerHeight();

    var element = this.refs.errorPageWrapper;
    $(element).css('height', Math.max(remainingHeight, optionSetHeight) + 'px').trigger('resize');
  },

  templateByName: function templateByName(template, page_type) {
    var Template = Templates[template];
    var FourOhFour = Template.FourOhFour;
    var FiveOhThree = Template.FiveOhThree;
    var Maintenance = Template.Maintenance;
    switch (page_type) {
      case '404':
        return React.createElement(FourOhFour, this.props);
      case '503':
        return React.createElement(FiveOhThree, this.props);
      case 'maintenance':
        return React.createElement(Maintenance, this.props);
      default:
        new Error('Unknown template requested in preview_component.jsx');
    }
  },

  render: function render() {

    var classes = ['preview', 'error-page-wrapper', this.props.template];

    return React.createElement(
      'div',
      { className: classes.join(' '), ref: 'errorPageWrapper', style: this.background() },
      this.templateByName(this.props.template, this.props.page_type)
    );
  }

});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

module.exports = {
  plain: {
    FourOhFour: __webpack_require__(1139),
    FiveOhThree: __webpack_require__(1143),
    Maintenance: __webpack_require__(1144)
  },
  sign: {
    FourOhFour: __webpack_require__(1145),
    FiveOhThree: __webpack_require__(1146),
    Maintenance: __webpack_require__(1153)
  },
  background: {
    FourOhFour: __webpack_require__(1154),
    FiveOhThree: __webpack_require__(1155),
    Maintenance: __webpack_require__(1156)
  }
};

/***/ }),

/***/ 1139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var RevealMixin = __webpack_require__(106);
var CustomStylesMixin = __webpack_require__(85);

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({

  displayName: '404',

  mixins: [CustomStylesMixin, RevealMixin],

  render: function render() {
    return React.createElement(
      'div',
      { className: 'content-container' },
      React.createElement(
        'div',
        { className: 'head-line', style: this.secondary_text_color() },
        '404'
      ),
      React.createElement(
        'div',
        { className: 'subheader', style: this.primary_text_color() },
        'Oops, the page you\'re looking for does not exist.'
      ),
      React.createElement('hr', { style: this.hrBackgroundColor() }),
      React.createElement('div', { className: 'clearfix' }),
      React.createElement(
        'div',
        { className: 'context', style: this.primary_text_color() },
        React.createElement(
          'p',
          null,
          'You may want to head back to the homepage.',
          React.createElement('br', null),
          'If you think something is broken, report a problem.'
        )
      ),
      React.createElement(
        'div',
        { className: 'buttons-container' },
        React.createElement(
          'a',
          { href: this.href(this.props.homepage_url), style: this.borderButton(), target: '_blank' },
          'Go To Homepage'
        ),
        React.createElement(
          'a',
          { href: this.support_email_address(), style: this.borderButton(), target: '_blank' },
          'Report A Problem'
        )
      )
    );
  }
});

/***/ }),

/***/ 1140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(184);

var emptyObject = __webpack_require__(1141);
var _invariant = __webpack_require__(1142);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),

/***/ 1141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),

/***/ 1142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ 1143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

var ContextContentMixin = __webpack_require__(168);
var CustomStylesMixin = __webpack_require__(85);
var RevealMixin = __webpack_require__(106);

var createReactClass = __webpack_require__(51);

module.exports = createReactClass({

  displayName: '503',

  mixins: [ContextContentMixin, RevealMixin, CustomStylesMixin],

  render: function render() {
    return React.createElement(
      'div',
      { className: 'content-container' },
      React.createElement(
        'div',
        { className: 'head-line', style: this.secondary_text_color() },
        '503'
      ),
      React.createElement(
        'div',
        { className: 'subheader', style: this.primary_text_color() },
        'Looks like we\'re having some server issues.'
      ),
      React.createElement('hr', { style: this.hrBackgroundColor() }),
      React.createElement('div', { className: 'clearfix' }),
      React.createElement(
        'div',
        { className: 'context', style: this.primary_text_color() },
        this.contextContent()
      ),
      React.createElement(
        'div',
        { className: 'buttons-container' },
        React.createElement(
          'a',
          { href: this.href(this.props.status_page_url), style: this.mergeStyles(this.has_status_page(), this.borderButton()), target: '_blank' },
          'View Status page'
        ),
        React.createElement(
          'a',
          { href: this.support_email_address(), style: this.borderButton(), target: '_blank' },
          'Report A Problem'
        )
      )
    );
  }
});

/***/ }),

/***/ 1144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

var ContextContentMixin = __webpack_require__(168);
var CustomStylesMixin = __webpack_require__(85);
var RevealMixin = __webpack_require__(106);

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({

  mixins: [ContextContentMixin, CustomStylesMixin, RevealMixin],

  displayName: 'Maintenance',

  render: function render() {
    return React.createElement(
      'div',
      { className: 'content-container' },
      React.createElement(
        'div',
        { className: 'head-line', style: this.secondary_text_color() },
        'Maintenance'
      ),
      React.createElement(
        'div',
        { className: 'subheader', style: this.primary_text_color() },
        'We\'re undergoing a bit of scheduled maintenance.'
      ),
      React.createElement('hr', { style: this.hrBackgroundColor() }),
      React.createElement('div', { className: 'clearfix' }),
      React.createElement(
        'div',
        { className: 'context', style: this.primary_text_color() },
        this.contextContent()
      ),
      React.createElement(
        'div',
        { className: 'buttons-container' },
        React.createElement(
          'a',
          { href: this.href(this.props.status_page_url),
            style: this.mergeStyles(this.has_status_page(), this.borderButton()), target: '_blank' },
          'View Statuspage'
        )
      )
    );
  }

});

/***/ }),

/***/ 1145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var RevealMixin = __webpack_require__(106);
var CustomStylesMixin = __webpack_require__(85);

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({
  displayName: 'exports',


  mixins: [RevealMixin, CustomStylesMixin],

  render: function render() {
    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'sign-container' },
        React.createElement('div', { className: 'nob', style: this.mergeStyles(this.borderColor(this.props.sign_frame_color), this.background_color(this.props.background_color)) }),
        React.createElement('div', { className: 'post left', style: this.background_color(this.props.sign_frame_color) }),
        React.createElement('div', { className: 'post right', style: this.background_color(this.props.sign_frame_color) }),
        React.createElement(
          'div',
          { className: 'pane', style: this.mergeStyles(this.borderColor(this.props.sign_frame_color), this.background_color(this.props.sign_background_color)) },
          React.createElement(
            'div',
            { className: 'headline', style: this.color(this.props.sign_text_color) },
            '404'
          ),
          React.createElement(
            'div',
            { className: 'context', style: this.color(this.props.sign_text_color) },
            'Oops, the page you\'re ',
            React.createElement('br', null),
            'looking for does not exist.'
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'text-container' },
        React.createElement(
          'div',
          { className: 'headline', style: this.secondary_text_color() },
          '404'
        ),
        React.createElement(
          'div',
          { className: 'context', style: this.primary_text_color() },
          React.createElement(
            'p',
            null,
            'You may want to head back to the homepage. ',
            React.createElement('br', null),
            'If you think something is broken, report a problem.'
          )
        ),
        React.createElement(
          'div',
          { className: 'buttons-container' },
          React.createElement(
            'a',
            { href: this.href(this.props.homepage_url), style: this.borderButton(), target: '_blank' },
            React.createElement('span', { className: 'fa fa-home' }),
            'Home Page'
          ),
          React.createElement(
            'a',
            { href: this.support_email_address(), style: this.borderButton(), target: '_blank' },
            React.createElement('span', { className: 'fa fa-warning' }),
            'Report Problem'
          )
        )
      )
    );
  }
});

/***/ }),

/***/ 1146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _color = __webpack_require__(1147);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(0);

var ContextContentMixin = __webpack_require__(168);
var CustomStylesMixin = __webpack_require__(85);
var RevealMixin = __webpack_require__(106);


var createReactClass = __webpack_require__(51);
module.exports = createReactClass({
  displayName: 'exports',


  mixins: [ContextContentMixin, CustomStylesMixin, RevealMixin],

  buttonsClass: function buttonsClass() {
    var className = "buttons-container";
    if (this.props.has_status_page == 'no') {
      className += " single-button";
    }
    return className;
  },

  render: function render() {
    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'sign-container' },
        React.createElement('div', { className: 'nob', style: this.mergeStyles(this.borderColor(this.props.sign_frame_color), this.background_color(this.props.background_color)) }),
        React.createElement('div', { className: 'post left', style: this.background_color(this.props.sign_frame_color) }),
        React.createElement('div', { className: 'post right', style: this.background_color(this.props.sign_frame_color) }),
        React.createElement(
          'div',
          { className: 'pane', style: this.mergeStyles(this.borderColor(this.props.sign_frame_color), this.background_color(this.props.sign_background_color)) },
          React.createElement(
            'div',
            { className: 'headline', style: this.color(this.props.sign_text_color) },
            '503'
          ),
          React.createElement(
            'div',
            { className: 'context', style: this.color(this.props.sign_text_color) },
            'Looks like we\'re having',
            React.createElement('br', null),
            'some server issues.'
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'text-container' },
        React.createElement(
          'div',
          { className: 'headline', style: this.secondary_text_color() },
          '503'
        ),
        React.createElement(
          'div',
          { className: 'context', style: this.primary_text_color() },
          this.contextContent()
        ),
        React.createElement(
          'div',
          { className: this.buttonsClass() },
          React.createElement(
            'a',
            { href: this.href(this.props.status_page_url), style: this.mergeStyles(this.borderButton(), this.has_status_page()), target: '_blank' },
            React.createElement('span', { className: 'fa fa-power-off' }),
            'View Statuspage'
          ),
          React.createElement(
            'a',
            { href: this.support_email_address(), style: this.borderButton(), target: '_blank' },
            React.createElement('span', { className: 'fa fa-warning' }),
            'Report A Problem'
          )
        )
      )
    );
  }
});

/***/ }),

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var colorString = __webpack_require__(1148);
var convert = __webpack_require__(1151);

var _slice = [].slice;

var skippedModels = [
	// to be honest, I don't really feel like keyword belongs in color convert, but eh.
	'keyword',

	// gray conflicts with some method names, and has its own method defined.
	'gray',

	// shouldn't really be in color-convert either...
	'hex'
];

var hashedModelKeys = {};
Object.keys(convert).forEach(function (model) {
	hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
});

var limiters = {};

function Color(obj, model) {
	if (!(this instanceof Color)) {
		return new Color(obj, model);
	}

	if (model && model in skippedModels) {
		model = null;
	}

	if (model && !(model in convert)) {
		throw new Error('Unknown model: ' + model);
	}

	var i;
	var channels;

	if (!obj) {
		this.model = 'rgb';
		this.color = [0, 0, 0];
		this.valpha = 1;
	} else if (obj instanceof Color) {
		this.model = obj.model;
		this.color = obj.color.slice();
		this.valpha = obj.valpha;
	} else if (typeof obj === 'string') {
		var result = colorString.get(obj);
		if (result === null) {
			throw new Error('Unable to parse color from string: ' + obj);
		}

		this.model = result.model;
		channels = convert[this.model].channels;
		this.color = result.value.slice(0, channels);
		this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
	} else if (obj.length) {
		this.model = model || 'rgb';
		channels = convert[this.model].channels;
		var newArr = _slice.call(obj, 0, channels);
		this.color = zeroArray(newArr, channels);
		this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
	} else if (typeof obj === 'number') {
		// this is always RGB - can be converted later on.
		obj &= 0xFFFFFF;
		this.model = 'rgb';
		this.color = [
			(obj >> 16) & 0xFF,
			(obj >> 8) & 0xFF,
			obj & 0xFF
		];
		this.valpha = 1;
	} else {
		this.valpha = 1;

		var keys = Object.keys(obj);
		if ('alpha' in obj) {
			keys.splice(keys.indexOf('alpha'), 1);
			this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
		}

		var hashedKeys = keys.sort().join('');
		if (!(hashedKeys in hashedModelKeys)) {
			throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
		}

		this.model = hashedModelKeys[hashedKeys];

		var labels = convert[this.model].labels;
		var color = [];
		for (i = 0; i < labels.length; i++) {
			color.push(obj[labels[i]]);
		}

		this.color = zeroArray(color);
	}

	// perform limitations (clamping, etc.)
	if (limiters[this.model]) {
		channels = convert[this.model].channels;
		for (i = 0; i < channels; i++) {
			var limit = limiters[this.model][i];
			if (limit) {
				this.color[i] = limit(this.color[i]);
			}
		}
	}

	this.valpha = Math.max(0, Math.min(1, this.valpha));

	if (Object.freeze) {
		Object.freeze(this);
	}
}

Color.prototype = {
	toString: function () {
		return this.string();
	},

	toJSON: function () {
		return this[this.model]();
	},

	string: function (places) {
		var self = this.model in colorString.to ? this : this.rgb();
		self = self.round(typeof places === 'number' ? places : 1);
		var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
		return colorString.to[self.model](args);
	},

	percentString: function (places) {
		var self = this.rgb().round(typeof places === 'number' ? places : 1);
		var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
		return colorString.to.rgb.percent(args);
	},

	array: function () {
		return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
	},

	object: function () {
		var result = {};
		var channels = convert[this.model].channels;
		var labels = convert[this.model].labels;

		for (var i = 0; i < channels; i++) {
			result[labels[i]] = this.color[i];
		}

		if (this.valpha !== 1) {
			result.alpha = this.valpha;
		}

		return result;
	},

	unitArray: function () {
		var rgb = this.rgb().color;
		rgb[0] /= 255;
		rgb[1] /= 255;
		rgb[2] /= 255;

		if (this.valpha !== 1) {
			rgb.push(this.valpha);
		}

		return rgb;
	},

	unitObject: function () {
		var rgb = this.rgb().object();
		rgb.r /= 255;
		rgb.g /= 255;
		rgb.b /= 255;

		if (this.valpha !== 1) {
			rgb.alpha = this.valpha;
		}

		return rgb;
	},

	round: function (places) {
		places = Math.max(places || 0, 0);
		return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
	},

	alpha: function (val) {
		if (arguments.length) {
			return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
		}

		return this.valpha;
	},

	// rgb
	red: getset('rgb', 0, maxfn(255)),
	green: getset('rgb', 1, maxfn(255)),
	blue: getset('rgb', 2, maxfn(255)),

	hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) { return ((val % 360) + 360) % 360; }), // eslint-disable-line brace-style

	saturationl: getset('hsl', 1, maxfn(100)),
	lightness: getset('hsl', 2, maxfn(100)),

	saturationv: getset('hsv', 1, maxfn(100)),
	value: getset('hsv', 2, maxfn(100)),

	chroma: getset('hcg', 1, maxfn(100)),
	gray: getset('hcg', 2, maxfn(100)),

	white: getset('hwb', 1, maxfn(100)),
	wblack: getset('hwb', 2, maxfn(100)),

	cyan: getset('cmyk', 0, maxfn(100)),
	magenta: getset('cmyk', 1, maxfn(100)),
	yellow: getset('cmyk', 2, maxfn(100)),
	black: getset('cmyk', 3, maxfn(100)),

	x: getset('xyz', 0, maxfn(100)),
	y: getset('xyz', 1, maxfn(100)),
	z: getset('xyz', 2, maxfn(100)),

	l: getset('lab', 0, maxfn(100)),
	a: getset('lab', 1),
	b: getset('lab', 2),

	keyword: function (val) {
		if (arguments.length) {
			return new Color(val);
		}

		return convert[this.model].keyword(this.color);
	},

	hex: function (val) {
		if (arguments.length) {
			return new Color(val);
		}

		return colorString.to.hex(this.rgb().round().color);
	},

	rgbNumber: function () {
		var rgb = this.rgb().color;
		return ((rgb[0] & 0xFF) << 16) | ((rgb[1] & 0xFF) << 8) | (rgb[2] & 0xFF);
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.rgb().color;

		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}

		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();

		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}

		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.rgb().color;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = this.rgb();
		for (var i = 0; i < 3; i++) {
			rgb.color[i] = 255 - rgb.color[i];
		}
		return rgb;
	},

	lighten: function (ratio) {
		var hsl = this.hsl();
		hsl.color[2] += hsl.color[2] * ratio;
		return hsl;
	},

	darken: function (ratio) {
		var hsl = this.hsl();
		hsl.color[2] -= hsl.color[2] * ratio;
		return hsl;
	},

	saturate: function (ratio) {
		var hsl = this.hsl();
		hsl.color[1] += hsl.color[1] * ratio;
		return hsl;
	},

	desaturate: function (ratio) {
		var hsl = this.hsl();
		hsl.color[1] -= hsl.color[1] * ratio;
		return hsl;
	},

	whiten: function (ratio) {
		var hwb = this.hwb();
		hwb.color[1] += hwb.color[1] * ratio;
		return hwb;
	},

	blacken: function (ratio) {
		var hwb = this.hwb();
		hwb.color[2] += hwb.color[2] * ratio;
		return hwb;
	},

	grayscale: function () {
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var rgb = this.rgb().color;
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		return Color.rgb(val, val, val);
	},

	fade: function (ratio) {
		return this.alpha(this.valpha - (this.valpha * ratio));
	},

	opaquer: function (ratio) {
		return this.alpha(this.valpha + (this.valpha * ratio));
	},

	rotate: function (degrees) {
		var hsl = this.hsl();
		var hue = hsl.color[0];
		hue = (hue + degrees) % 360;
		hue = hue < 0 ? 360 + hue : hue;
		hsl.color[0] = hue;
		return hsl;
	},

	mix: function (mixinColor, weight) {
		// ported from sass implementation in C
		// https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		var color1 = this.rgb();
		var color2 = mixinColor.rgb();
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return Color.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue(),
				color1.alpha() * p + color2.alpha() * (1 - p));
	}
};

// model conversion methods and static constructors
Object.keys(convert).forEach(function (model) {
	if (skippedModels.indexOf(model) !== -1) {
		return;
	}

	var channels = convert[model].channels;

	// conversion methods
	Color.prototype[model] = function () {
		if (this.model === model) {
			return new Color(this);
		}

		if (arguments.length) {
			return new Color(arguments, model);
		}

		var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
		return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
	};

	// 'static' construction methods
	Color[model] = function (color) {
		if (typeof color === 'number') {
			color = zeroArray(_slice.call(arguments), channels);
		}
		return new Color(color, model);
	};
});

function roundTo(num, places) {
	return Number(num.toFixed(places));
}

function roundToPlace(places) {
	return function (num) {
		return roundTo(num, places);
	};
}

function getset(model, channel, modifier) {
	model = Array.isArray(model) ? model : [model];

	model.forEach(function (m) {
		(limiters[m] || (limiters[m] = []))[channel] = modifier;
	});

	model = model[0];

	return function (val) {
		var result;

		if (arguments.length) {
			if (modifier) {
				val = modifier(val);
			}

			result = this[model]();
			result.color[channel] = val;
			return result;
		}

		result = this[model]().color[channel];
		if (modifier) {
			result = modifier(result);
		}

		return result;
	};
}

function maxfn(max) {
	return function (v) {
		return Math.max(0, Math.min(max, v));
	};
}

function assertArray(val) {
	return Array.isArray(val) ? val : [val];
}

function zeroArray(arr, length) {
	for (var i = 0; i < length; i++) {
		if (typeof arr[i] !== 'number') {
			arr[i] = 0;
		}
	}

	return arr;
}

module.exports = Color;


/***/ }),

/***/ 1148:
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var colorNames = __webpack_require__(622);
var swizzle = __webpack_require__(1149);

var reverseNames = {};

// create a list of reverse color names
for (var name in colorNames) {
	if (colorNames.hasOwnProperty(name)) {
		reverseNames[colorNames[name]] = name;
	}
}

var cs = module.exports = {
	to: {}
};

cs.get = function (string) {
	var prefix = string.substring(0, 3).toLowerCase();
	var val;
	var model;
	switch (prefix) {
		case 'hsl':
			val = cs.get.hsl(string);
			model = 'hsl';
			break;
		case 'hwb':
			val = cs.get.hwb(string);
			model = 'hwb';
			break;
		default:
			val = cs.get.rgb(string);
			model = 'rgb';
			break;
	}

	if (!val) {
		return null;
	}

	return {model: model, value: val};
};

cs.get.rgb = function (string) {
	if (!string) {
		return null;
	}

	var abbr = /^#([a-f0-9]{3,4})$/i;
	var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
	var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var keyword = /(\D+)/;

	var rgb = [0, 0, 0, 1];
	var match;
	var i;
	var hexAlpha;

	if (match = string.match(hex)) {
		hexAlpha = match[2];
		match = match[1];

		for (i = 0; i < 3; i++) {
			// https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
			var i2 = i * 2;
			rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
		}

		if (hexAlpha) {
			rgb[3] = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
		}
	} else if (match = string.match(abbr)) {
		match = match[1];
		hexAlpha = match[3];

		for (i = 0; i < 3; i++) {
			rgb[i] = parseInt(match[i] + match[i], 16);
		}

		if (hexAlpha) {
			rgb[3] = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
		}
	} else if (match = string.match(rgba)) {
		for (i = 0; i < 3; i++) {
			rgb[i] = parseInt(match[i + 1], 0);
		}

		if (match[4]) {
			rgb[3] = parseFloat(match[4]);
		}
	} else if (match = string.match(per)) {
		for (i = 0; i < 3; i++) {
			rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
		}

		if (match[4]) {
			rgb[3] = parseFloat(match[4]);
		}
	} else if (match = string.match(keyword)) {
		if (match[1] === 'transparent') {
			return [0, 0, 0, 0];
		}

		rgb = colorNames[match[1]];

		if (!rgb) {
			return null;
		}

		rgb[3] = 1;

		return rgb;
	} else {
		return null;
	}

	for (i = 0; i < 3; i++) {
		rgb[i] = clamp(rgb[i], 0, 255);
	}
	rgb[3] = clamp(rgb[3], 0, 1);

	return rgb;
};

cs.get.hsl = function (string) {
	if (!string) {
		return null;
	}

	var hsl = /^hsla?\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var match = string.match(hsl);

	if (match) {
		var alpha = parseFloat(match[4]);
		var h = ((parseFloat(match[1]) % 360) + 360) % 360;
		var s = clamp(parseFloat(match[2]), 0, 100);
		var l = clamp(parseFloat(match[3]), 0, 100);
		var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);

		return [h, s, l, a];
	}

	return null;
};

cs.get.hwb = function (string) {
	if (!string) {
		return null;
	}

	var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var match = string.match(hwb);

	if (match) {
		var alpha = parseFloat(match[4]);
		var h = ((parseFloat(match[1]) % 360) + 360) % 360;
		var w = clamp(parseFloat(match[2]), 0, 100);
		var b = clamp(parseFloat(match[3]), 0, 100);
		var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
		return [h, w, b, a];
	}

	return null;
};

cs.to.hex = function () {
	var rgba = swizzle(arguments);

	return (
		'#' +
		hexDouble(rgba[0]) +
		hexDouble(rgba[1]) +
		hexDouble(rgba[2]) +
		(rgba[3] < 1
			? (hexDouble(Math.round(rgba[3] * 255)))
			: '')
	);
};

cs.to.rgb = function () {
	var rgba = swizzle(arguments);

	return rgba.length < 4 || rgba[3] === 1
		? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
		: 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};

cs.to.rgb.percent = function () {
	var rgba = swizzle(arguments);

	var r = Math.round(rgba[0] / 255 * 100);
	var g = Math.round(rgba[1] / 255 * 100);
	var b = Math.round(rgba[2] / 255 * 100);

	return rgba.length < 4 || rgba[3] === 1
		? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
		: 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};

cs.to.hsl = function () {
	var hsla = swizzle(arguments);
	return hsla.length < 4 || hsla[3] === 1
		? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
		: 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
};

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
cs.to.hwb = function () {
	var hwba = swizzle(arguments);

	var a = '';
	if (hwba.length >= 4 && hwba[3] !== 1) {
		a = ', ' + hwba[3];
	}

	return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};

cs.to.keyword = function (rgb) {
	return reverseNames[rgb.slice(0, 3)];
};

// helpers
function clamp(num, min, max) {
	return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
	var str = num.toString(16).toUpperCase();
	return (str.length < 2) ? '0' + str : str;
}


/***/ }),

/***/ 1149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArrayish = __webpack_require__(1150);

var concat = Array.prototype.concat;
var slice = Array.prototype.slice;

var swizzle = module.exports = function swizzle(args) {
	var results = [];

	for (var i = 0, len = args.length; i < len; i++) {
		var arg = args[i];

		if (isArrayish(arg)) {
			// http://jsperf.com/javascript-array-concat-vs-push/98
			results = concat.call(results, slice.call(arg));
		} else {
			results.push(arg);
		}
	}

	return results;
};

swizzle.wrap = function (fn) {
	return function () {
		return fn(swizzle(arguments));
	};
};


/***/ }),

/***/ 1150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isArrayish(obj) {
	if (!obj || typeof obj === 'string') {
		return false;
	}

	return obj instanceof Array || Array.isArray(obj) ||
		(obj.length >= 0 && (obj.splice instanceof Function ||
			(Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
};


/***/ }),

/***/ 1151:
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(623);
var route = __webpack_require__(1152);

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

module.exports = convert;


/***/ }),

/***/ 1152:
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(623);

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

// https://jsperf.com/object-keys-vs-for-in-with-closure/3
var models = Object.keys(conversions);

function buildGraph() {
	var graph = {};

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

module.exports = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};



/***/ }),

/***/ 1153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

var ContextContentMixin = __webpack_require__(168);
var CustomStylesMixin = __webpack_require__(85);
var RevealMixin = __webpack_require__(106);

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({
  displayName: 'exports',


  mixins: [ContextContentMixin, CustomStylesMixin, RevealMixin],
  render: function render() {
    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'sign-container' },
        React.createElement('div', { className: 'nob', style: this.mergeStyles(this.borderColor(this.props.sign_frame_color), this.background_color(this.props.background_color)) }),
        React.createElement('div', { className: 'post left', style: this.background_color(this.props.sign_frame_color) }),
        React.createElement('div', { className: 'post right', style: this.background_color(this.props.sign_frame_color) }),
        React.createElement(
          'div',
          { className: 'pane just-header', style: this.mergeStyles(this.borderColor(this.props.sign_frame_color), this.background_color(this.props.sign_background_color)) },
          React.createElement(
            'div',
            { className: 'headline', style: this.color(this.props.sign_text_color) },
            'Be Right Back'
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'text-container' },
        React.createElement(
          'div',
          { className: 'headline', style: this.secondary_text_color() },
          'Maintenance'
        ),
        React.createElement(
          'div',
          { className: 'context', style: this.primary_text_color() },
          this.contextContent()
        ),
        React.createElement(
          'div',
          { className: 'buttons-container' },
          React.createElement(
            'a',
            { href: this.href(this.props.status_page_url), style: this.mergeStyles(this.borderButton(), this.has_status_page()), target: '_blank' },
            React.createElement('span', { className: 'fa fa-power-off' }),
            'View Statuspage'
          )
        )
      )
    );
  }
});

/***/ }),

/***/ 1154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

var CustomStylesMixin = __webpack_require__(85);
var RevealMixin = __webpack_require__(106);

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({

  displayName: 'Background404',

  mixins: [CustomStylesMixin, RevealMixin],

  render: function render() {
    return React.createElement(
      'div',
      { className: 'content-container', style: this.shadow() },
      React.createElement(
        'div',
        { className: 'head-line secondary-text', style: this.secondary_text_color() },
        '404'
      ),
      React.createElement(
        'div',
        { className: 'subheader', style: this.primary_text_color() },
        'Oops, the page you\'re',
        React.createElement('br', null),
        'looking for does not exist.'
      ),
      React.createElement('div', { className: 'hr' }),
      React.createElement('div', { className: 'clearfix' }),
      React.createElement(
        'div',
        { className: 'context', style: this.secondary_text_color() },
        'You may want to head back to the homepage. If you think something is broken, report a problem.'
      ),
      React.createElement(
        'div',
        { className: 'buttons-container' },
        React.createElement(
          'a',
          { href: this.href(this.props.homepage_url), style: this.button(), target: '_blank' },
          React.createElement('span', { className: 'fa fa-home' }),
          'Go To Homepage'
        ),
        React.createElement(
          'a',
          { href: this.support_email_address(), style: this.button(), target: '_blank' },
          React.createElement('span', { className: 'fa fa-warning' }),
          'Report A Problem'
        )
      )
    );
  }
});

/***/ }),

/***/ 1155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var ContextContentMixin = __webpack_require__(168);
var CustomStylesMixin = __webpack_require__(85);
var RevealMixin = __webpack_require__(106);

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({

  displayName: 'Background503',

  mixins: [ContextContentMixin, CustomStylesMixin, RevealMixin],

  buttonsClass: function buttonsClass() {
    var ret = "buttons-container";
    if (this.props.has_status_page == 'no') {
      ret += " single-button";
    }
    return ret;
  },

  render: function render() {
    return React.createElement(
      'div',
      { className: 'content-container', style: this.shadow() },
      React.createElement(
        'div',
        { className: 'head-line', style: this.secondary_text_color() },
        '503'
      ),
      React.createElement(
        'div',
        { className: 'subheader', style: this.primary_text_color() },
        'Looks like we\'re having',
        React.createElement('br', null),
        'some server issues.'
      ),
      React.createElement('div', { className: 'hr' }),
      React.createElement('div', { className: 'clearfix' }),
      React.createElement(
        'div',
        { className: 'context', style: this.secondary_text_color() },
        this.contextContent()
      ),
      React.createElement(
        'div',
        { className: this.buttonsClass() },
        React.createElement(
          'a',
          { href: this.href(this.props.status_page_url), style: this.mergeStyles(this.button(), this.has_status_page()), target: '_blank' },
          React.createElement('span', { className: 'fa fa-power-off' }),
          'View Statuspage'
        ),
        React.createElement(
          'a',
          { href: this.support_email_address(), style: this.button(), target: '_blank' },
          React.createElement('span', { className: 'fa fa-warning' }),
          'Report A Problem'
        )
      )
    );
  }

});

/***/ }),

/***/ 1156:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

var ContextContentMixin = __webpack_require__(168);
var CustomStylesMixin = __webpack_require__(85);
var RevealMixin = __webpack_require__(106);

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({

  displayName: 'BackgroundMaintenance',

  mixins: [ContextContentMixin, CustomStylesMixin, RevealMixin],

  render: function render() {
    return React.createElement(
      'div',
      { className: 'content-container', style: this.shadow() },
      React.createElement(
        'div',
        { className: 'head-line', style: this.secondary_text_color() },
        'Maintenance'
      ),
      React.createElement(
        'div',
        { className: 'subheader', style: this.primary_text_color() },
        'We\'re undergoing a bit of scheduled maintenance.'
      ),
      React.createElement('div', { className: 'hr' }),
      React.createElement('div', { className: 'clearfix' }),
      React.createElement(
        'div',
        { className: 'context', style: this.secondary_text_color() },
        this.contextContent()
      ),
      React.createElement(
        'div',
        { className: 'buttons-container single-button', style: this.has_status_page() },
        React.createElement(
          'a',
          { href: this.href(this.props.status_page_url), style: this.mergeStyles(this.button(), this.has_status_page()), target: '_blank' },
          React.createElement('span', { className: 'fa fa-power-off' }),
          'View Statuspage'
        )
      )
    );
  }
});

/***/ }),

/***/ 1157:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(_ref) {
  var logoUrl = _ref.logoUrl;
  return _react2.default.createElement(
    "div",
    { className: "walkthrough-header" },
    _react2.default.createElement(
      "a",
      { className: "logo", href: "/" },
      _react2.default.createElement("img", { src: logoUrl, alt: "Statuspage Logo" }),
      _react2.default.createElement(
        "span",
        { className: "bep" },
        "Better Error Pages"
      )
    ),
    _react2.default.createElement(
      "span",
      { className: "powered-by" },
      _react2.default.createElement(
        "a",
        { href: "http://statuspage.io/powered-by", target: "_blank", rel: "noopener noreferrer nofollow" },
        "Powered by Statuspage"
      )
    )
  );
};

module.exports = Header;

/***/ }),

/***/ 1158:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var Buttons = function (_React$Component) {
  _inherits(Buttons, _React$Component);

  function Buttons() {
    _classCallCheck(this, Buttons);

    return _possibleConstructorReturn(this, (Buttons.__proto__ || Object.getPrototypeOf(Buttons)).apply(this, arguments));
  }

  _createClass(Buttons, [{
    key: "render",
    value: function render() {

      return React.createElement(
        "div",
        { className: "walkthrough-buttons" },
        React.createElement(
          "a",
          { href: "#",
            onClick: this.props.back,
            className: "cpt-button pull-left",
            style: { display: !this.props.backText ? 'none' : null } },
          this.props.backText
        ),
        React.createElement(
          "a",
          { href: "#",
            onClick: this.props.continue,
            className: "cpt-button pull-right style-primary",
            style: { display: !this.props.continueText ? 'none' : null } },
          this.props.continueText
        )
      );
    }
  }]);

  return Buttons;
}(React.Component);

module.exports = Buttons;

/***/ }),

/***/ 1159:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var CustomStylesMixin = __webpack_require__(85);

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({

  displayName: 'PageToggler',

  mixins: [CustomStylesMixin],

  setPageType: function setPageType(event) {
    event.preventDefault();
    this.props.onChange(event.target.dataset.type);
  },

  activeTab: function activeTab(name) {
    return this.props.page_type === name ? 'active' : null;
  },

  togglerColor: function togglerColor(name) {
    return this.props.page_type === name ? this.mergeStyles(this.primary_text_color(), this.primaryBorderColor()) : this.secondary_text_color();
  },

  render: function render() {
    var type = this.props.page_type || '503';
    return React.createElement(
      'div',
      { className: 'page-toggler' },
      React.createElement(
        'a',
        { href: '#', className: this.activeTab('503'), style: this.togglerColor('503'), onClick: this.setPageType, 'data-type': '503' },
        '503'
      ),
      React.createElement(
        'a',
        { href: '#', className: this.activeTab('404'), style: this.togglerColor('404'), onClick: this.setPageType, 'data-type': '404' },
        '404'
      ),
      React.createElement(
        'a',
        { href: '#', className: this.activeTab('maintenance'), style: this.togglerColor('maintenance'), onClick: this.setPageType, 'data-type': 'maintenance' },
        'Maintenance'
      )
    );
  }

});

/***/ }),

/***/ 1160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var ThankYou = function (_React$Component) {
  _inherits(ThankYou, _React$Component);

  function ThankYou(props) {
    _classCallCheck(this, ThankYou);

    return _possibleConstructorReturn(this, (ThankYou.__proto__ || Object.getPrototypeOf(ThankYou)).call(this, props));
  }

  _createClass(ThankYou, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: "step-container step-zero" },
        React.createElement(
          "h2",
          null,
          "Welcome To Better Error Pages!"
        ),
        React.createElement(
          "p",
          { className: "works-header" },
          React.createElement(
            "strong",
            null,
            "Here's how this thing works:"
          )
        ),
        React.createElement(
          "ul",
          { className: "styled" },
          React.createElement(
            "li",
            null,
            "We're going to ask you a few questions about your company."
          ),
          React.createElement(
            "li",
            null,
            "You're going to have the opportunity to customize what your error pages look like."
          ),
          React.createElement(
            "li",
            null,
            "When you're done, you'll be able to download the flat HTML files for your shiny new 404, 503 and Maintenance pages."
          )
        ),
        React.createElement(
          "p",
          null,
          "Let's get started!"
        )
      );
    }
  }]);

  return ThankYou;
}(React.Component);

module.exports = ThankYou;

/***/ }),

/***/ 1161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Radio = __webpack_require__(1162);

var Welcome = function (_React$Component) {
  _inherits(Welcome, _React$Component);

  function Welcome() {
    _classCallCheck(this, Welcome);

    return _possibleConstructorReturn(this, (Welcome.__proto__ || Object.getPrototypeOf(Welcome)).apply(this, arguments));
  }

  _createClass(Welcome, [{
    key: 'handleChange',
    value: function handleChange(event) {
      this.props.onChange('has_status_page', event.target.value);
    }
  }, {
    key: 'contextText',
    value: function contextText() {
      if (this.props.has_status_page === 'customer') {
        return 'Great news! As a Statuspage customer, your error pages will include a javascript snippet that pulls in information from your status page via the API.';
      } else if (this.props.has_status_page === 'non-customer') {
        return "Cool! We'll be able to include links to your status page on your error pages.";
      }
      if (this.props.has_status_page === 'no') {
        return React.createElement(
          'span',
          null,
          'Need a status page? ',
          React.createElement(
            'a',
            { href: 'https://www.statuspage.io', target: '_blank' },
            'We can help you with that.'
          ),
          '.'
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var values = [{ label: 'Yes I have a status page AND I\'m a Statuspage  customer.', value: 'customer' }, { label: 'Yes I have a status page BUT I\'m not a Statuspage customer.', value: 'non-customer' }, { label: 'No, I don\'t have a status page.', value: 'no' }];
      return React.createElement(
        'div',
        { className: 'step-container step-one' },
        React.createElement(
          'div',
          null,
          React.createElement(
            'h2',
            null,
            'First off, do you have a status page?'
          ),
          React.createElement(
            'p',
            null,
            'We need to know if your company has a status page because if you do, we\'ll include a link to it on your error pages.'
          ),
          React.createElement(
            'div',
            { className: 'controls' },
            values.map(function (value, index) {
              return React.createElement(Radio, {
                key: index,
                label: value.label,
                value: value.value,
                name: 'has-status-page',
                checked: value.value === _this2.props.has_status_page,
                onChange: _this2.handleChange.bind(_this2) });
            })
          ),
          React.createElement(
            'small',
            null,
            this.contextText()
          )
        )
      );
    }
  }]);

  return Welcome;
}(React.Component);

module.exports = Welcome;

/***/ }),

/***/ 1162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({
  displayName: 'exports',

  render: function render() {
    return React.createElement(
      'label',
      { className: 'radio' },
      React.createElement('input', { type: 'radio',
        name: this.props.name,
        value: this.props.value,
        defaultChecked: this.props.checked,
        onChange: this.props.onChange }),
      ' ',
      this.props.label
    );
  }
});

/***/ }),

/***/ 1163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Input = __webpack_require__(86);

var URLsForm = function (_React$Component) {
  _inherits(URLsForm, _React$Component);

  function URLsForm() {
    _classCallCheck(this, URLsForm);

    return _possibleConstructorReturn(this, (URLsForm.__proto__ || Object.getPrototypeOf(URLsForm)).apply(this, arguments));
  }

  _createClass(URLsForm, [{
    key: 'change',
    value: function change(key, event) {
      this.props.onChange(key, event.target.value);
    }
  }, {
    key: 'greeting',
    value: function greeting() {
      if (this.props.has_status_page === 'customer') {
        if (this.props.loggedIn) {
          return React.createElement(
            'p',
            null,
            'Since you\'re logged in, we were able to pull the following information from your Statuspage account.  Verify that this is correct and proceed to the next step.'
          );
        }
        return React.createElement(
          'p',
          null,
          'If you ',
          React.createElement(
            'a',
            { href: 'https://manage.statuspage.io/login' },
            'login'
          ),
          ', we can pull this information in automatically.  No worries, though, if you don\'t want to.'
        );
      } else {
        return React.createElement(
          'p',
          null,
          'We\'re making good progress! Now we need some info about your website and support channels.'
        );
      }
    }
  }, {
    key: 'minimumFields',
    value: function minimumFields() {
      return React.createElement(
        'div',
        null,
        React.createElement(Input, {
          label: 'Homepage URL',
          name: 'homepage_url',
          defaultValue: this.props.homepage_url,
          onChange: this.change.bind(this, 'homepage_url') }),
        React.createElement(Input, {
          label: 'Support Email Address or URL',
          name: 'support_email_address',
          defaultValue: this.props.support_email_address,
          onChange: this.change.bind(this, 'support_email_address') })
      );
    }
  }, {
    key: 'requiredInputs',
    value: function requiredInputs() {
      if (this.props.has_status_page === 'customer' || this.props.has_status_page === 'non-customer') {
        return React.createElement(
          'div',
          { className: 'urls-form' },
          React.createElement(Input, {
            label: 'Statuspage URL',
            name: 'status_page_url',
            defaultValue: this.props.status_page_url,
            onChange: this.change.bind(this, 'status_page_url') }),
          this.minimumFields()
        );
      } else if (this.props.has_status_page === 'no') {
        return React.createElement(
          'div',
          { className: 'urls-form' },
          this.minimumFields()
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'step-container step-two' },
          React.createElement(
            'h2',
            null,
            'Awesome!'
          ),
          this.greeting(),
          this.requiredInputs(),
          React.createElement(
            'small',
            null,
            'We\'ll use this information to add helpful links to your error pages.'
          )
        )
      );
    }
  }]);

  return URLsForm;
}(React.Component);

module.exports = URLsForm;

/***/ }),

/***/ 1164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChooseATemplate = function (_React$Component) {
  _inherits(ChooseATemplate, _React$Component);

  function ChooseATemplate() {
    _classCallCheck(this, ChooseATemplate);

    return _possibleConstructorReturn(this, (ChooseATemplate.__proto__ || Object.getPrototypeOf(ChooseATemplate)).apply(this, arguments));
  }

  _createClass(ChooseATemplate, [{
    key: 'change',
    value: function change(template) {
      this.props.onChange('template', template);
    }
  }, {
    key: 'render',
    value: function render() {
      var template = this.props.template;
      var _props$thumbnails = this.props.thumbnails,
          plain = _props$thumbnails.plain,
          background = _props$thumbnails.background,
          sign = _props$thumbnails.sign;


      return _react2.default.createElement(
        'div',
        { className: 'step-container step-three' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h2',
            null,
            'Choose A Template'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Use one of these templates as a jumping off point. You\'ll be able to customize your error pages further on the next page.'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              { onClick: this.change.bind(this, 'plain'), className: template === 'plain' ? 'selected' : null },
              _react2.default.createElement('img', { src: plain, alt: 'Plain Template' })
            ),
            _react2.default.createElement(
              'li',
              { onClick: this.change.bind(this, 'background'), className: template === 'background' ? 'selected' : null },
              _react2.default.createElement('img', { src: background, alt: 'Background Template' })
            ),
            _react2.default.createElement(
              'li',
              { onClick: this.change.bind(this, 'sign'), className: template === 'sign' ? 'selected' : null },
              _react2.default.createElement('img', { src: sign, alt: 'Sign Template' })
            )
          )
        )
      );
    }
  }]);

  return ChooseATemplate;
}(_react2.default.Component);

ChooseATemplate.propTypes = {
  template: _propTypes2.default.string
};

module.exports = ChooseATemplate;

/***/ }),

/***/ 1165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var BackgroundControls = __webpack_require__(1166);
var PlainControls = __webpack_require__(1168);
var SignControls = __webpack_require__(1169);

var Personalize = function (_React$Component) {
  _inherits(Personalize, _React$Component);

  function Personalize(props) {
    _classCallCheck(this, Personalize);

    var _this = _possibleConstructorReturn(this, (Personalize.__proto__ || Object.getPrototypeOf(Personalize)).call(this, props));

    _this.props = props;

    _this.onChange = _this.onChange.bind(_this);
    _this.resetDefaultValues = _this.resetDefaultValues.bind(_this);
    return _this;
  }

  _createClass(Personalize, [{
    key: 'onChange',
    value: function onChange(name, event) {
      this.props.onChange(name, event.target.value);
      event.preventDefault();
    }
  }, {
    key: 'controls',
    value: function controls() {
      switch (this.props.template) {
        case 'background':
          return React.createElement(BackgroundControls, _extends({}, this.props, { onChange: this.onChange }));
        case 'plain':
          return React.createElement(PlainControls, _extends({}, this.props, { onChange: this.onChange }));
        case 'sign':
          return React.createElement(SignControls, _extends({}, this.props, { onChange: this.onChange }));
        default:
          throw new Error('Invalid template name');
      }
    }
  }, {
    key: 'resetDefaultValues',
    value: function resetDefaultValues() {
      var _this2 = this;

      $('.color-control input').each(function (index, $control) {
        $($control).minicolors('value', _this2.props.defaults[_this2.props.template][$control.name]); // #shame.js @TMD
      });
      this.props.resetDefaultValues();
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'step-container step-four' },
        React.createElement(
          'div',
          null,
          React.createElement(
            'h2',
            null,
            'Make Them Your Own'
          ),
          this.controls(),
          React.createElement(
            'small',
            null,
            'If you get a little too adventurous with your customizations, you can always ',
            React.createElement(
              'a',
              { href: '#reset-default', onClick: this.resetDefaultValues },
              'go back to using the default colors'
            ),
            '.'
          )
        )
      );
    }
  }]);

  return Personalize;
}(React.Component);

module.exports = Personalize;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var Input = __webpack_require__(86);
var Range = __webpack_require__(1167);
var Color = __webpack_require__(343);

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({

  displayName: 'BackgroundControls',

  render: function render() {
    return React.createElement(
      'div',
      { className: 'customization-controls' },
      React.createElement(Input, {
        label: 'Background Image',
        name: 'background_image',
        type: 'text',
        defaultValue: this.props.background_image,
        onChange: this.props.onChange.bind(null, 'background_image') }),
      React.createElement(Color, {
        label: 'Primary Text Color',
        name: 'primary_text_color',
        defaultValue: this.props.primary_text_color,
        onChange: this.props.onChange.bind(null, 'primary_text_color') }),
      React.createElement(Color, {
        label: 'Secondary Text Color',
        name: 'secondary_text_color',
        defaultValue: this.props.secondary_text_color,
        onChange: this.props.onChange.bind(null, 'secondary_text_color') }),
      React.createElement(Color, {
        label: 'Button Color',
        name: 'button_color',
        defaultValue: this.props.button_color,
        onChange: this.props.onChange.bind(null, 'button_color') }),
      React.createElement(Color, {
        label: 'Button Text Color',
        name: 'button_text_color',
        defaultValue: this.props.button_text_color,
        onChange: this.props.onChange.bind(null, 'button_text_color') }),
      React.createElement(Color, {
        label: 'Shadow Color',
        name: 'shadow_color',
        defaultValue: this.props.shadow_color,
        onChange: this.props.onChange.bind(null, 'shadow_color') }),
      React.createElement(Range, {
        label: 'Shadow Distance',
        min: '1',
        max: '75',
        defaultValue: this.props.shadow_distance,
        onChange: this.props.onChange.bind(null, 'shadow_distance') })
    );
  }

});

/***/ }),

/***/ 1167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var React = __webpack_require__(0);

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({
  displayName: 'exports',


  componentDidMount: function componentDidMount() {
    var self = this;
    $(this.refs.slider).noUiSlider({
      start: parseInt(this.props.defaultValue),
      range: {
        min: parseInt(this.props.min),
        max: parseInt(this.props.max)
      }
    }).on('slide', function (event) {
      event.target = { value: parseInt($(this).val()) };
      self.props.onChange(event);
    });
  },

  componentWillUnmount: function componentWillUnmount() {},

  render: function render() {
    var classes = ['control-group'];
    if (this.props.className) {
      classes.push(this.props.className);
    }
    return React.createElement(
      'div',
      { className: classes.join(' '), style: this.props.style },
      React.createElement(
        'label',
        null,
        this.props.label
      ),
      React.createElement(
        'div',
        { className: 'controls' },
        React.createElement('div', { ref: 'slider', className: 'slider' })
      )
    );
  }

});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var Input = __webpack_require__(86);
var Color = __webpack_require__(343);

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({

  displayName: 'PlainControls',

  render: function render() {
    return React.createElement(
      'div',
      { className: 'customization-controls' },
      React.createElement(Color, {
        label: 'Background Color',
        name: 'background_color',
        defaultValue: this.props.background_color,
        onChange: this.props.onChange.bind(null, 'background_color') }),
      React.createElement(Color, {
        label: 'Primary Text Color',
        name: 'primary_text_color',
        defaultValue: this.props.primary_text_color,
        onChange: this.props.onChange.bind(null, 'primary_text_color') }),
      React.createElement(Color, {
        label: 'Secondary Text Color',
        name: 'secondary_text_color',
        defaultValue: this.props.secondary_text_color,
        onChange: this.props.onChange.bind(null, 'secondary_text_color') }),
      React.createElement(Color, {
        label: 'Button Color',
        name: 'button_color',
        defaultValue: this.props.button_color,
        onChange: this.props.onChange.bind(null, 'button_color') })
    );
  }

});

/***/ }),

/***/ 1169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var Input = __webpack_require__(86);
var Color = __webpack_require__(343);

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({

  displayName: 'SignControls',

  render: function render() {
    return React.createElement(
      'div',
      { className: 'customization-controls' },
      React.createElement(Color, {
        label: 'Background Color',
        name: 'background_color',
        defaultValue: this.props.background_color,
        onChange: this.props.onChange.bind(null, 'background_color') }),
      React.createElement(Color, {
        label: 'Primary Text Color',
        name: 'primary_text_color',
        defaultValue: this.props.primary_text_color,
        onChange: this.props.onChange.bind(null, 'primary_text_color') }),
      React.createElement(Color, {
        label: 'Secondary Text Color',
        name: 'secondary_text_color',
        defaultValue: this.props.secondary_text_color,
        onChange: this.props.onChange.bind(null, 'secondary_text_color') }),
      React.createElement(Color, {
        label: 'Sign Frame Color',
        name: 'sign_frame_color',
        defaultValue: this.props.sign_frame_color,
        onChange: this.props.onChange.bind(null, 'sign_frame_color') }),
      React.createElement(Color, {
        label: 'Sign Text Color',
        name: 'sign_text_color',
        defaultValue: this.props.sign_text_color,
        onChange: this.props.onChange.bind(null, 'sign_text_color') }),
      React.createElement(Color, {
        label: 'Sign Background Color',
        name: 'sign_background_color',
        defaultValue: this.props.sign_background_color,
        onChange: this.props.onChange.bind(null, 'sign_background_color') }),
      React.createElement(Color, {
        label: 'Button Color',
        name: 'button_color',
        type: 'text',
        defaultValue: this.props.button_color,
        onChange: this.props.onChange.bind(null, 'button_color') })
    );
  }

});

/***/ }),

/***/ 1170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _checkbox = __webpack_require__(193);

var _checkbox2 = _interopRequireDefault(_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Input = __webpack_require__(86);

var Download = function (_React$Component) {
  _inherits(Download, _React$Component);

  function Download() {
    _classCallCheck(this, Download);

    return _possibleConstructorReturn(this, (Download.__proto__ || Object.getPrototypeOf(Download)).apply(this, arguments));
  }

  _createClass(Download, [{
    key: 'onChange',
    value: function onChange(name, event) {
      this.props.onChange(name, name === 'subscribe_to_news_letter' ? event.target.checked : event.target.value);
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'step-container step-five' },
        React.createElement(
          'h2',
          null,
          'Almost Done!'
        ),
        React.createElement(
          'p',
          null,
          'All we need now is your email address so we can email you the HTML files for your error pages.'
        ),
        React.createElement(Input, { label: 'Email Address',
          name: 'emailAddress',
          defaultValue: this.props.send_to_email_address,
          onChange: this.onChange.bind(this, 'send_to_email_address') }),
        React.createElement(
          'div',
          { className: 'checkbox-container' },
          React.createElement(_checkbox2.default, { label: 'Yes! Send me news and offers from Statuspage about products, events, and more.', onChange: this.onChange.bind(this, 'subscribe_to_news_letter'), defaultChecked: this.props.subscribe_to_news_letter })
        ),
        React.createElement(
          'p',
          { style: { marginTop: '1.5rem' } },
          React.createElement(
            'small',
            null,
            'By continuing, you agree to our ',
            React.createElement(
              'a',
              { href: 'https://dr-wac.atlassian.com/legal/privacy-policy', target: '_blank' },
              'Privacy Policy'
            ),
            '.'
          )
        )
      );
    }
  }]);

  return Download;
}(React.Component);

module.exports = Download;

/***/ }),

/***/ 1171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var ThankYou = function (_React$Component) {
  _inherits(ThankYou, _React$Component);

  function ThankYou(props) {
    _classCallCheck(this, ThankYou);

    return _possibleConstructorReturn(this, (ThankYou.__proto__ || Object.getPrototypeOf(ThankYou)).call(this, props));
  }

  _createClass(ThankYou, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var twttr = window.twttr || { widgets: { load: function load() {} } };
      twttr.widgets.load();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: "step-container step-six" },
        React.createElement(
          "h2",
          null,
          "Thanks!"
        ),
        React.createElement(
          "p",
          null,
          "Check your inbox for a link to your Better Error Pages download!"
        ),
        React.createElement(
          "p",
          null,
          "Think Better Error Pages is a nifty little tool? Share it on Twitter."
        ),
        React.createElement(
          "a",
          { href: "https://twitter.com/share", className: "twitter-share-button", "data-url": "https://better-error-pages.statuspage.io/", "data-text": "Better Error Pages: build free 404, 500-level, and maintenance pages in 60 seconds.", "data-via": "statuspageio", "data-size": "large" },
          "Tweet"
        )
      );
    }
  }]);

  return ThankYou;
}(React.Component);

module.exports = ThankYou;

/***/ }),

/***/ 1172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _confirm = __webpack_require__(84);

var _confirm2 = _interopRequireDefault(_confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ = __webpack_require__(47);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(26);
var ItemsSelector = __webpack_require__(170);

var _require = __webpack_require__(249),
    MODAL_PREFIX = _require.MODAL_PREFIX;

var UNSUBSCRIBE_MODAL = 'unsubscribe-user';
var UNSUBSCRIBE_MODAL_TRIGGER = MODAL_PREFIX + UNSUBSCRIBE_MODAL;

var ComponentToggler = function (_React$Component) {
  _inherits(ComponentToggler, _React$Component);

  function ComponentToggler() {
    _classCallCheck(this, ComponentToggler);

    return _possibleConstructorReturn(this, (ComponentToggler.__proto__ || Object.getPrototypeOf(ComponentToggler)).apply(this, arguments));
  }

  _createClass(ComponentToggler, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      $(ReactDOM.findDOMNode(this)).parents('form').submit(function (e) {
        if (_this2._allUntoggled()) {
          _this2._triggerModal(UNSUBSCRIBE_MODAL_TRIGGER, e);
        }
      });
    }
  }, {
    key: '_allUntoggled',
    value: function _allUntoggled() {
      return _.every($('.grouped-item'), function (item) {
        return !$(item).hasClass('active');
      });
    }
  }, {
    key: '_triggerModal',
    value: function _triggerModal(modalId, e) {
      e.preventDefault();
      e.stopPropagation();
      $(ReactDOM.findDOMNode(this)).find('#' + modalId).modal();
    }
  }, {
    key: '_submit',
    value: function _submit() {
      var $form = $(ReactDOM.findDOMNode(this)).parents('form');
      $form.unbind();
      $form.submit();
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(ItemsSelector, this.props),
        React.createElement(_confirm2.default, { id: UNSUBSCRIBE_MODAL,
          title: 'Hey! Just so you know...',
          message: 'This will unsubscribe this user from all updates. Are you sure you want to do that?',
          onConfirm: this._submit.bind(this),
          confirm_text: 'Unsubscribe User'
        })
      );
    }
  }]);

  return ComponentToggler;
}(React.Component);

module.exports = ComponentToggler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var DnsRecordSet = __webpack_require__(1178);

/*
 * This component displays the current state of host dns records for a given domain.
 *
 * @param {string} props.domain - The domain to provide help for.
 * @param {string} props.subdomain - the subdomain of the page, if any.
 * @param {bool}   props.subdomain_forced - true iff one cannot modify or use the vanity subdomain.
 * @param {bool}   props.active - false iff we should display a notice that the domain is not active until the person activates.
 * @param {string} props.page_code - the code of the page; used to generate the page-specific json url.
 * @param {string} props.expected_endpoint - the ideal endpoint the user should CNAME to.
 * @param {int}    props.expected_ttl - the suggested TTL for a new DNS record.
 * @param {string} props.status - unset, deprecated, invalid, or valid.
 * @param {bool}   props.detailed_view - true to force the detailed view of the domain status.
 * @param {array}  props.actual_records - A list of dns records with the fields 'type', 'ttl', 'value', and 'hints'.
 */

var HostHelper = function (_React$Component) {
  _inherits(HostHelper, _React$Component);

  function HostHelper(props) {
    _classCallCheck(this, HostHelper);

    var _this = _possibleConstructorReturn(this, (HostHelper.__proto__ || Object.getPrototypeOf(HostHelper)).call(this, props));

    _this.state = {
      'page_code': _this.props.page_code,
      'domain': _this.props.domain,
      'expected_endpoint': _this.props.expected_endpoint,
      'expected_ttl': _this.props.expected_ttl,
      'actual_records': _this.props.actual_records,
      'status': _this.props.status,
      'folded': _this.props.status === 'unset' || _this.props.status == 'valid',
      'detailed_view': _this.props.detailed_view,
      'subdomain': _this.props.subdomain,
      'subdomain_forced': _this.props.subdomain_forced,
      'active': _this.props.active
    };
    return _this;
  }

  // On hitting the revalidate button or link, pull the new state as a json and set local state to that.


  _createClass(HostHelper, [{
    key: '_submit',
    value: function _submit() {
      var _this2 = this;

      $.ajax({
        type: "GET",
        url: Routes.domain_state_page_url(this.state.page_code)
      }).success(function (msg) {
        // If we do not notify and nothing changes, it looks like nothing happened.
        HRB.utils.notify('Current DNS state refreshed successfully.');
        _this2.setState(msg);
      }).fail(function () {
        HRB.utils.basicFailAndReload();
      });
    }

    // Switch between folded and unfolded

  }, {
    key: '_toggleFolding',
    value: function _toggleFolding() {
      this.setState({ folded: !this.state.folded });
    }
  }, {
    key: '_foldedClass',
    value: function _foldedClass() {
      return this.state.folded ? 'folded' : 'unfolded';
    }
  }, {
    key: '_statusClass',
    value: function _statusClass() {
      return 'domain-' + this.state.status;
    }

    // This is the view that most clients see.
    // It does not display anything about the inbound DNS but the expected DNS row
    // and whether or not the actual endpoint matches it exactly.

  }, {
    key: '_renderLegacyView',
    value: function _renderLegacyView() {
      var contents = void 0;
      var configUrl = Routes.edit_page_url(this.props.page_code, { 'anchor': 'tab-dns-config' });
      if (this.state.status === 'unset') {
        contents = React.createElement(
          'span',
          null,
          React.createElement(
            'strong',
            null,
            'Directions'
          ),
          ': create a CNAME DNS record and point it at ',
          React.createElement(
            'em',
            null,
            this.state.expected_endpoint
          ),
          '.'
        );
      } else if (this.state.status === 'valid') {
        contents = React.createElement(
          'span',
          { className: 'checkmark-inline' },
          ' DNS is correctly configured! ',
          React.createElement(
            'span',
            { className: 'monospace' },
            this.state.domain
          ),
          ' points at ',
          React.createElement(
            'span',
            { className: 'monospace' },
            this.state.expected_endpoint
          )
        );
      } else {
        contents = React.createElement(
          'span',
          { className: 'alert-inline' },
          '\xA0Please ensure your DNS entry for ',
          React.createElement(
            'span',
            { className: 'monospace' },
            this.state.domain
          ),
          ' is a ',
          React.createElement(
            'span',
            { className: 'monospace' },
            'CNAME'
          ),
          ' entry pointing at ',
          React.createElement(
            'span',
            { className: 'monospace' },
            this.state.expected_endpoint
          ),
          '.'
        );
      }

      var activeMessage = this.state.active ? null : React.createElement(
        'span',
        null,
        React.createElement('br', null),
        React.createElement(
          'strong',
          null,
          'Note:'
        ),
        ' your status page will redirect to your unique subdomain ',
        React.createElement(
          'em',
          null,
          '(',
          this.state.subdomain,
          ')'
        ),
        ' until your page launches.'
      );

      var revalidate_link = this.state.status === 'unset' ? null : React.createElement(
        'a',
        { id: 'dns-revalidation-button', href: '#', onClick: this._submit.bind(this) },
        'Revalidate DNS'
      );

      return React.createElement(
        'p',
        { className: 'help-block' },
        contents,
        '\xA0',
        revalidate_link,
        activeMessage
      );
    }

    // Returns a DnsRecordSet representing the expected set of records at the custom domain.

  }, {
    key: '_expectedCname',
    value: function _expectedCname() {
      return React.createElement(DnsRecordSet, { domain: this.state.domain ? this.state.domain : 'Expected Domain', show_header: true, show_ttl: true, records: [{
          type: 'CNAME',
          ttl: this.state.expected_ttl,
          value: this.state.expected_endpoint,
          hints: []
        }] });
    }

    // This is the detailed view.
    // The header contains the status and a 'folder' button to show more detail.
    // The detail contains all the records found at the custom domain, hints to resolve an invalid record,
    //   explanations of deprecation, the expected CNAME record, and a button to revalidate without refreshing.

  }, {
    key: '_renderDetailedView',
    value: function _renderDetailedView() {
      // The funky &nbsp; insertions are to correct for odd spacing before and after spans.
      // We only revalidate if we expect a DNS entry, so we can short-cut this case.
      var contents,
          header = React.createElement(
        'span',
        null,
        this.state.status
      );
      if (this.state.status === 'unset') {
        contents = React.createElement(
          'div',
          null,
          'To prepare to serve from a custom domain immediately, insert the following record at that domain: ',
          this._expectedCname()
        );
      } else {
        var revalidate_button = React.createElement(
          'a',
          { id: 'dns-revalidation-button',
            className: 'cpt-button style-primary size-small',
            onClick: this._submit.bind(this),
            href: '#' },
          'Revalidate DNS'
        );

        // Do not show the TTL on the records here. This is the TTL in the DNS cache we use, not the TTL of the record
        // on the authoritative server.
        var actual_records = this.state.actual_records.length > 0 ? React.createElement(
          'div',
          null,
          'We found the following records at ',
          React.createElement(
            'span',
            { className: 'monospace' },
            this.state.domain
          ),
          ':',
          React.createElement(DnsRecordSet, { domain: this.state.domain, show_header: true, show_ttl: false, records: this.state.actual_records })
        ) : React.createElement(
          'div',
          null,
          'We were unable to find any records at ',
          React.createElement(
            'span',
            { className: 'monospace' },
            this.state.domain
          ),
          '.'
        );

        // Only show the actual records if they are different than expected.
        if (this.state.status === 'valid') {
          contents = React.createElement(
            'div',
            null,
            actual_records,
            revalidate_button
          );
        } else {
          contents = React.createElement(
            'div',
            null,
            React.createElement(
              'div',
              null,
              'We require this DNS record: ',
              this._expectedCname()
            ),
            actual_records,
            revalidate_button
          );
        }
      }

      return React.createElement(
        'div',
        null,
        this._renderLegacyView(),
        React.createElement(
          'div',
          { className: 'domain-helper' },
          React.createElement(
            'div',
            { className: 'domain-header ' + this._statusClass() + ' ' + this._foldedClass() },
            React.createElement('a', { id: 'domain-folder', className: this._foldedClass(), onClick: this._toggleFolding.bind(this), href: '#' }),
            React.createElement(
              'div',
              { className: 'domain-helper-title' },
              this.state.status.toUpperCase()
            ),
            React.createElement('i', { className: 'domain-status-icon' })
          ),
          React.createElement(
            'div',
            { className: 'domain-content ' + this._statusClass() + ' ' + this._foldedClass() },
            contents,
            React.createElement('div', { style: { display: 'block', clear: 'both', float: 'none' } })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.subdomain_forced) {
        return React.createElement(
          'p',
          { className: 'help-block' },
          'This field is disabled because the privacy feature you are using requires you to use the subdomain URL.'
        );
      } else if (this.state.detailed_view) {
        return this._renderDetailedView();
      } else {
        return this._renderLegacyView();
      }
    }
  }]);

  return HostHelper;
}(React.Component);

module.exports = HostHelper;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DnsRecord = __webpack_require__(1179);

/*
 * A table of DNS records, complete with headers and hints.
 *
 * @param {string} props.domain - The domain to provide help for.
 * @param {array}  props.records - the records in the set, each as {type, value, hints}.
 * @param {bool}   props.show_ttl - true iff you want to display the ttl column.
 * @param {bool}   props.show_header - true iff you want to display the header row.
 */

var DnsRecordSet = function (_React$Component) {
  _inherits(DnsRecordSet, _React$Component);

  function DnsRecordSet() {
    _classCallCheck(this, DnsRecordSet);

    return _possibleConstructorReturn(this, (DnsRecordSet.__proto__ || Object.getPrototypeOf(DnsRecordSet)).apply(this, arguments));
  }

  _createClass(DnsRecordSet, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var header;
      if (this.props.show_header) {
        var ttl_header = this.props.show_ttl ? _react2.default.createElement(
          'div',
          { className: 'dns-ttl' },
          'TTL'
        ) : _react2.default.createElement('div', null);
        header = _react2.default.createElement(
          'div',
          { className: 'dns-records-header' },
          _react2.default.createElement(
            'div',
            { className: 'dns-domain' },
            'Domain'
          ),
          _react2.default.createElement(
            'div',
            { className: 'dns-type' },
            'Type'
          ),
          ttl_header,
          _react2.default.createElement(
            'div',
            { className: 'dns-value' },
            'Value'
          ),
          _react2.default.createElement('div', { style: { display: 'block', clear: 'both', float: 'none' } })
        );
      }
      var key = 0;
      var records = _.map(this.props.records, function (record) {
        return _react2.default.createElement(DnsRecord, { key: key++, domain: _this2.props.domain, type: record['type'], ttl: record['ttl'], value: record['value'], hints: record['hints'], show_ttl: _this2.props.show_ttl });
      });

      return _react2.default.createElement(
        'div',
        { className: 'dns-records' },
        header,
        records
      );
    }
  }]);

  return DnsRecordSet;
}(_react2.default.Component);

module.exports = DnsRecordSet;

/***/ }),

/***/ 1179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// A single row in a DNS records table.
// Show the TTL cell iff show_ttl.
/*
 * A table of DNS records, complete with headers and hints.
 *
 * @param {string} props.domain - The domain to provide help for.
 * @param {array}  props.type - The type of the DNS record.
 * @param {bool}   props.show_ttl - true iff you want to display the ttl column.
 * @param {bool}   props.value - The value of the DNS record, e.g. a target name for a CNAME or an IP for an A record.
 */
var DnsRecord = function (_React$Component) {
  _inherits(DnsRecord, _React$Component);

  function DnsRecord() {
    _classCallCheck(this, DnsRecord);

    return _possibleConstructorReturn(this, (DnsRecord.__proto__ || Object.getPrototypeOf(DnsRecord)).apply(this, arguments));
  }

  _createClass(DnsRecord, [{
    key: "render",
    value: function render() {
      var ttl = this.props.show_ttl ? _react2.default.createElement(
        "div",
        { className: "dns-ttl" },
        this.props.ttl
      ) : _react2.default.createElement("div", null);
      var hint_items = [];
      if (this.props.hints) {
        for (var j = 0; j < this.props.hints.length; j++) {
          hint_items.push(_react2.default.createElement(
            "li",
            { key: j },
            this.props.hints[j]
          ));
        }
      }

      return _react2.default.createElement(
        "div",
        { className: "dns-records-row" },
        _react2.default.createElement(
          "div",
          { className: "dns-records-entry" },
          _react2.default.createElement(
            "div",
            { className: "dns-domain" },
            this.props.domain
          ),
          _react2.default.createElement(
            "div",
            { className: "dns-type" },
            "IN ",
            this.props.type
          ),
          ttl,
          _react2.default.createElement(
            "div",
            { className: "dns-value" },
            this.props.value
          ),
          _react2.default.createElement("div", { style: { display: 'block', clear: 'both', float: 'none' } })
        ),
        _react2.default.createElement(
          "div",
          { className: "dns-record-hints", style: { display: 'block', clear: 'both' } },
          _react2.default.createElement(
            "ul",
            null,
            hint_items
          )
        )
      );
    }
  }]);

  return DnsRecord;
}(_react2.default.Component);

module.exports = DnsRecord;

/***/ }),

/***/ 1180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var TEAM = 'Team Members';
var SUBSCRIBERS = 'Subscribers';
var METRICS = 'Metrics';
var PAGE_ACCESS_GROUPS = 'Page Access Groups';
var TABS = [TEAM, SUBSCRIBERS, METRICS, PAGE_ACCESS_GROUPS];

var ExceedingAllocationsDashboard = function (_React$Component) {
  _inherits(ExceedingAllocationsDashboard, _React$Component);

  function ExceedingAllocationsDashboard(props) {
    _classCallCheck(this, ExceedingAllocationsDashboard);

    var _this = _possibleConstructorReturn(this, (ExceedingAllocationsDashboard.__proto__ || Object.getPrototypeOf(ExceedingAllocationsDashboard)).call(this, props));

    _this.state = { activeTab: TEAM };
    return _this;
  }

  _createClass(ExceedingAllocationsDashboard, [{
    key: '_toggleTab',
    value: function _toggleTab(tabClicked) {
      this.setState({ activeTab: tabClicked });
    }
  }, {
    key: '_displayTabs',
    value: function _displayTabs() {
      var _this2 = this;

      var tabs = [];

      _.map(TABS, function (tab) {
        tabs.push(React.createElement(
          'li',
          { key: tab, className: _this2.state.activeTab === tab ? 'active' : null, onClick: _this2._toggleTab.bind(_this2, tab) },
          React.createElement(
            'a',
            { href: '#' },
            tab
          )
        ));
      });

      return React.createElement(
        'ul',
        { className: 'cpt-tabs' },
        ' ',
        tabs,
        ' '
      );
    }
  }, {
    key: '_determineData',
    value: function _determineData() {
      if (this.state.activeTab === TEAM) {
        return this.props.team_results;
      } else if (this.state.activeTab === SUBSCRIBERS) {
        return this.props.subscriber_results;
      } else if (this.state.activeTab === METRICS) {
        return this.props.metric_results;
      } else if (this.state.activeTab === PAGE_ACCESS_GROUPS) {
        return this.props.page_access_group_results;
      }
    }
  }, {
    key: '_displayData',
    value: function _displayData() {
      var data = this._determineData();
      var rows = [];

      if (data.length > 0) {
        rows.push(React.createElement(
          'div',
          { className: 'table-row column-header' },
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'span6' },
              this.state.activeTab === TEAM ? "Organization " : "Team ",
              'Name'
            ),
            React.createElement(
              'div',
              { className: 'span3' },
              'Over By'
            )
          )
        ));

        _.map(data, function (datapoint) {
          rows.push(React.createElement(
            'div',
            { className: 'table-row' },
            React.createElement(
              'div',
              { className: 'row' },
              React.createElement(
                'div',
                { className: 'span6' },
                React.createElement(
                  'a',
                  { href: datapoint.snapshot_link },
                  datapoint.name
                )
              ),
              React.createElement(
                'div',
                { className: 'span3' },
                datapoint.over_allocation_count
              )
            )
          ));
        });
      } else {
        rows.push(React.createElement(
          'span',
          { key: this.state.activeTab },
          React.createElement(
            'em',
            null,
            'Good news! No one is over their allocations for ',
            this.state.activeTab,
            '.'
          )
        ));
      }

      return rows;
    }
  }, {
    key: 'csvRoute',
    value: function csvRoute() {
      return Routes.admin_exceeding_allocations_path({ format: 'csv' });
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'content-area' },
        React.createElement(
          'div',
          { className: 'header' },
          React.createElement(
            'a',
            { href: this.csvRoute(), className: 'cpt-button size-small style-primary pull-right' },
            ' Download as CSV '
          ),
          React.createElement(
            'h3',
            { className: 'page-header' },
            'Exceeding allocations dashboard'
          )
        ),
        this._displayTabs(),
        React.createElement(
          'div',
          { className: 'cpt-table' },
          React.createElement(
            'div',
            { className: 'content' },
            React.createElement(
              'div',
              { className: 'table-row-group' },
              this._displayData()
            )
          )
        )
      );
    }
  }]);

  return ExceedingAllocationsDashboard;
}(React.Component);

module.exports = ExceedingAllocationsDashboard;

/***/ }),

/***/ 1181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _form = __webpack_require__(250);

var _form2 = _interopRequireDefault(_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(26);

var ImportSubscriberForm = function (_React$Component) {
  _inherits(ImportSubscriberForm, _React$Component);

  function ImportSubscriberForm(props) {
    _classCallCheck(this, ImportSubscriberForm);

    var _this = _possibleConstructorReturn(this, (ImportSubscriberForm.__proto__ || Object.getPrototypeOf(ImportSubscriberForm)).call(this, props));

    _this.state = { 'filepickerId': '', 'filename': '' };
    return _this;
  }

  _createClass(ImportSubscriberForm, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'modal hide fade modal-import-subscribers', id: 'modal-import-subscribers', style: { display: 'none' } },
        React.createElement(
          'div',
          { className: 'modal-header' },
          React.createElement(
            'a',
            { href: '#', 'data-dismiss': 'modal', className: 'close' },
            '\xD7'
          ),
          React.createElement(
            'h3',
            null,
            'Import subscribers'
          )
        ),
        React.createElement(
          _form2.default,
          { method: 'POST', action: this.props.import_subscribers_page_url, onSubmit: this.onSubmit.bind(this), ref: 'input_subscribers_form' },
          React.createElement(
            'div',
            { className: 'modal-body form-horizontal' },
            React.createElement(
              'p',
              null,
              'Import many subscribers at once by uploading a ',
              React.createElement(
                'em',
                null,
                '.csv'
              ),
              ' file. Before you get started, keep the following in mind:'
            ),
            React.createElement(
              'ul',
              { className: 'styled' },
              React.createElement(
                'li',
                null,
                'The only allowed file type is a .csv (not a .numbers or .xlsx)'
              ),
              React.createElement(
                'li',
                null,
                'The file must be under 20Mb in size'
              ),
              React.createElement(
                'li',
                null,
                'The upload might take a while; we\'ll email you when it\'s done'
              ),
              React.createElement(
                'li',
                null,
                React.createElement(
                  'a',
                  { href: this.props.download_template_page_url },
                  'Download this import template'
                ),
                ' to see how to organize your .csv'
              ),
              React.createElement(
                'li',
                null,
                React.createElement(
                  'a',
                  { href: 'http://help.statuspage.io/knowledge_base/topics/importing-subscribers-via-csv' },
                  'Check out this article'
                ),
                ' for more details on specifics for each field'
              )
            ),
            this.error(),
            React.createElement(
              'div',
              { className: 'file-upload-container' },
              React.createElement('input', { type: 'file', ref: 'csv_file', accept: 'text/csv', id: 'csv_file' }),
              React.createElement('input', { type: 'hidden', name: 'filepicker_id', value: this.state.filepickerId }),
              React.createElement('input', { type: 'hidden', name: 'filename', value: this.state.filename })
            ),
            this.progress()
          ),
          React.createElement(
            'div',
            { className: 'modal-footer' },
            React.createElement(
              'button',
              { className: 'cpt-button style-primary', id: 'btn-import-subscribers' },
              'Import subscribers'
            )
          )
        )
      );
    }
  }, {
    key: 'error',
    value: function error() {
      if (!this.state.error) {
        return null;
      }

      return React.createElement(
        'div',
        { className: 'cpt-notification error in-page no-delivery-types-error', style: { 'marginBottom': '1rem' } },
        this.state.error
      );
    }
  }, {
    key: 'progress',
    value: function progress() {
      if (!this.state.progress) {
        return null;
      }
      return React.createElement(
        'div',
        { className: 'cpt-progress', style: { 'marginTop': '1rem' } },
        React.createElement('div', { className: 'bar', style: { width: this.state.progress + '%' } })
      );
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(e) {
      var _this2 = this;

      e.preventDefault();
      var fileInput = ReactDOM.findDOMNode(this.refs.csv_file);

      if (fileInput.files.length == 0) {
        this.setErrorMessage("Please provide a CSV file to import.");
        return;
      }

      var maxSize = 20 * 1024 * 1024;
      // Check the size of the file to make sure it's not too large if the browser supports the check
      if (window.FileReader && fileInput.files) {
        if (fileInput.files[0].size > maxSize) {
          // Add an error message and return
          this.setErrorMessage("You can't upload files larger than 20Mb.");
          return;
        }
      }

      filepicker.setKey(this.props.filepicker_key);
      filepicker.store(fileInput, {
        mimetype: 'text/csv'
      }, function (FPFile) {
        // Update the progress bar
        _this2.setState({ 'progress': 100 });
        // Remove the progress bar shortly after completion
        setTimeout(function () {
          _this2.setState({ 'progress': null });
        }, 150);

        // Check that the file uploaded wasn't larger than what we want to process
        if (FPFile.size && FPFile.size > maxSize) {
          _this2.setErrorMessage("You can't upload files larger than 20Mb.");
          return;
        }
        var urlsParts = FPFile.url.split("/");
        var filepickerId = urlsParts[urlsParts.length - 1];
        var filename = FPFile.filename;
        _this2.setState({ 'filepickerId': filepickerId, 'filename': filename }, function () {
          ReactDOM.findDOMNode(_this2.refs.input_subscribers_form).submit();
        });
      }, function (FPError) {
        _this2.setErrorMessage(FPError.toString());
      }, function (progress) {
        _this2.setState({ 'progress': progress });
      });
    }
  }, {
    key: 'setErrorMessage',
    value: function setErrorMessage(errorMessage) {
      var _this3 = this;

      this.setState({ 'error': errorMessage });
      // Only show the error message for 4 seconds
      setTimeout(function () {
        _this3.setState({ 'error': null });
      }, 4000);
    }
  }]);

  return ImportSubscriberForm;
}(React.Component);

module.exports = ImportSubscriberForm;

/***/ }),

/***/ 1182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _server = __webpack_require__(251);

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ESSearchField = __webpack_require__(344);
var moment = __webpack_require__(3);
var sanitizeHtml = __webpack_require__(345);

var Incident = __webpack_require__(651);

var IncidentsSearchField = function (_React$Component) {
  _inherits(IncidentsSearchField, _React$Component);

  function IncidentsSearchField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, IncidentsSearchField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IncidentsSearchField.__proto__ || Object.getPrototypeOf(IncidentsSearchField)).call.apply(_ref, [this].concat(args))), _this), _this._template = function (suggestion) {
      var view = React.createElement(IncidentTypeaheadView, { suggestion: suggestion });
      return _server2.default.renderToString(view);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // Get HTML string for how a typeahead item should be rendered


  _createClass(IncidentsSearchField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var searchRoute = Incident.searchRoute({ page_id: this.props.page.id });
      var mapResultToUiRoute = function mapResultToUiRoute(suggestion) {
        return Routes.page_incident_path(_this2.props.page, suggestion.id, { domain: null, subdomain: null });
      };
      return React.createElement(ESSearchField, { queryUrl: searchRoute + '?limit=10&q=%QUERY',
        pluralizedResultName: "incidents",
        loadResults: Incident.search,
        mapResultToUiUrl: mapResultToUiRoute,
        template: this._template
      });
    }
  }]);

  return IncidentsSearchField;
}(React.Component);

var IncidentTypeaheadView = function (_React$Component2) {
  _inherits(IncidentTypeaheadView, _React$Component2);

  function IncidentTypeaheadView() {
    _classCallCheck(this, IncidentTypeaheadView);

    return _possibleConstructorReturn(this, (IncidentTypeaheadView.__proto__ || Object.getPrototypeOf(IncidentTypeaheadView)).apply(this, arguments));
  }

  _createClass(IncidentTypeaheadView, [{
    key: '_context',
    value: function _context() {
      var timestamp = this._timestamp();
      var highlight = sanitizeHtml(this._highlightText());
      var innerHtml = timestamp + ' - ' + highlight + '&#8230;';

      return React.createElement('div', { className: 'context', dangerouslySetInnerHTML: { __html: innerHtml } });
    }
  }, {
    key: '_timestamp',
    value: function _timestamp() {
      return moment(this._mostRecentUpdate().created_at).format('l');
    }
  }, {
    key: '_highlightText',
    value: function _highlightText() {
      if (this._isUpdateHighlighted()) {
        return this.props.suggestion.highlight['incident_updates.body'][0];
      }

      return this._firstUpdate().body;
    }
  }, {
    key: '_mostRecentUpdate',
    value: function _mostRecentUpdate() {
      return this.props.suggestion.incident_updates[0];
    }
  }, {
    key: '_firstUpdate',
    value: function _firstUpdate() {
      var updates = this.props.suggestion.incident_updates;
      return updates[updates.length - 1];
    }
  }, {
    key: '_titleText',
    value: function _titleText() {
      var displayWords = this.props.suggestion.name;

      if (this._isNameHighlighted()) {
        var text = this.props.suggestion.highlight['name'];
        var highlightItems = $('<span>' + text + '</span>').find('strong');
        var tagClasses = $(highlightItems[0]).attr('class');
        var highlightedWords = _.map(highlightItems, function (t) {
          return $(t).text().toLowerCase();
        });

        displayWords = this.props.suggestion.name.split(' ').map(function (word, index) {
          var sanitizedWord = word.toLowerCase().replace(/[!?\.,]/, '');
          if (highlightedWords.indexOf(sanitizedWord) >= 0) {
            return React.createElement(
              'strong',
              { key: sanitizedWord, className: tagClasses },
              ' ',
              word,
              ' '
            );
          }
          return React.createElement(
            'span',
            { key: sanitizedWord },
            ' ',
            word,
            ' '
          );
        });
      }
      return React.createElement(
        'span',
        { className: 'name' },
        displayWords
      );
    }
  }, {
    key: '_isUpdateHighlighted',
    value: function _isUpdateHighlighted() {
      return this._checkFieldHighlight('incident_updates.body');
    }
  }, {
    key: '_isNameHighlighted',
    value: function _isNameHighlighted() {
      return this._checkFieldHighlight('name');
    }
  }, {
    key: '_checkFieldHighlight',
    value: function _checkFieldHighlight(property) {
      return this.props.suggestion.highlight && this.props.suggestion.highlight.hasOwnProperty(property);
    }
  }, {
    key: 'render',
    value: function render() {
      var suggestion = this.props.suggestion;
      var iconClass = suggestion.is_scheduled_maintenance ? "fa-calendar" : "fa-exclamation-triangle";

      return React.createElement(
        'div',
        { className: 'item search-result es-results' },
        React.createElement(
          'div',
          { className: 'icon-container' },
          React.createElement('i', { className: "fa " + iconClass })
        ),
        React.createElement(
          'div',
          { className: 'result-text-container' },
          this._titleText(),
          React.createElement('br', null),
          this._context()
        ),
        React.createElement('div', { className: 'clearfix' })
      );
    }
  }]);

  return IncidentTypeaheadView;
}(React.Component);

module.exports = IncidentsSearchField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var p=__webpack_require__(184),q=__webpack_require__(0);function aa(a,b,e,c,g,d,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var B=[e,c,g,d,h,f],A=0;a=Error(b.replace(/%s/g,function(){return B[A++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function u(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var w="function"===typeof Symbol&&Symbol.for,y=w?Symbol.for("react.portal"):60106,z=w?Symbol.for("react.fragment"):60107,C=w?Symbol.for("react.strict_mode"):60108,D=w?Symbol.for("react.profiler"):60114,E=w?Symbol.for("react.provider"):60109,F=w?Symbol.for("react.context"):60110,G=w?Symbol.for("react.concurrent_mode"):60111,H=w?Symbol.for("react.forward_ref"):60112,I=w?Symbol.for("react.suspense"):60113,J=w?Symbol.for("react.memo"):60115,L=w?Symbol.for("react.lazy"):60116;
function M(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case G:return"ConcurrentMode";case z:return"Fragment";case y:return"Portal";case D:return"Profiler";case C:return"StrictMode";case I:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case F:return"Context.Consumer";case E:return"Context.Provider";case H:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
case J:return M(a.type);case L:if(a=1===a._status?a._result:null)return M(a)}return null}var ba=q.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,ca={};function N(a,b){for(var e=a._threadCount;e<=b;e++)a[e]=a._currentValue2,a._threadCount=e+1}function da(a,b,e){var c=a.contextType;if("object"===typeof c&&null!==c)return N(c,e),c[e];if(a=a.contextTypes){e={};for(var g in a)e[g]=b[g];b=e}else b=ca;return b}for(var O=new Uint16Array(16),P=0;15>P;P++)O[P]=P+1;O[15]=0;
var ea=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,fa=Object.prototype.hasOwnProperty,ha={},ia={};
function ja(a){if(fa.call(ia,a))return!0;if(fa.call(ha,a))return!1;if(ea.test(a))return ia[a]=!0;ha[a]=!0;return!1}function ka(a,b,e,c){if(null!==e&&0===e.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(c)return!1;if(null!==e)return!e.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function la(a,b,e,c){if(null===b||"undefined"===typeof b||ka(a,b,e,c))return!0;if(c)return!1;if(null!==e)switch(e.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function Q(a,b,e,c,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=c;this.attributeNamespace=g;this.mustUseProperty=e;this.propertyName=a;this.type=b}var R={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){R[a]=new Q(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];R[b]=new Q(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){R[a]=new Q(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){R[a]=new Q(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){R[a]=new Q(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){R[a]=new Q(a,3,!0,a,null)});
["capture","download"].forEach(function(a){R[a]=new Q(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){R[a]=new Q(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){R[a]=new Q(a,5,!1,a.toLowerCase(),null)});var S=/[\-:]([a-z])/g;function T(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(S,
T);R[b]=new Q(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(S,T);R[b]=new Q(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(S,T);R[b]=new Q(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});R.tabIndex=new Q("tabIndex",1,!1,"tabindex",null);var ma=/["'&<>]/;
function U(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=ma.exec(a);if(b){var e="",c,g=0;for(c=b.index;c<a.length;c++){switch(a.charCodeAt(c)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}g!==c&&(e+=a.substring(g,c));g=c+1;e+=b}a=g!==c?e+a.substring(g,c):e}return a}var na=!1;function oa(a,b,e,c){for(;na;)na=!1,e=a(b,c);return e}
var V=0,pa={readContext:function(a){var b=V;N(a,b);return a[b]}},qa={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};function ra(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var sa={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},ta=p({menuitem:!0},sa),W={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},ua=["Webkit","ms","Moz","O"];Object.keys(W).forEach(function(a){ua.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);W[b]=W[a]})});
var va=/([A-Z])/g,wa=/^ms-/,X=q.Children.toArray,Y=ba.ReactCurrentOwner,xa={listing:!0,pre:!0,textarea:!0},ya=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,za={},Z={};function Aa(a){if(void 0===a||null===a)return a;var b="";q.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Ba=Object.prototype.hasOwnProperty,Ca={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Da(a,b){void 0===a&&u("152",M(b)||"Component")}
function Ea(a,b,e){function c(g,c){var d=da(c,b,e),f=[],h=!1,l={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===f)return null},enqueueReplaceState:function(a,b){h=!0;f=[b]},enqueueSetState:function(a,b){if(null===f)return null;f.push(b)}},k=void 0;if(c.prototype&&c.prototype.isReactComponent){if(k=new c(g.props,d,l),"function"===typeof c.getDerivedStateFromProps){var r=c.getDerivedStateFromProps.call(null,g.props,k.state);null!=r&&(k.state=p({},k.state,r))}}else if(k=c(g.props,
d,l),k=oa(c,g.props,k,d),null==k||null==k.render){a=k;Da(a,c);return}k.props=g.props;k.context=d;k.updater=l;l=k.state;void 0===l&&(k.state=l=null);if("function"===typeof k.UNSAFE_componentWillMount||"function"===typeof k.componentWillMount)if("function"===typeof k.componentWillMount&&"function"!==typeof c.getDerivedStateFromProps&&k.componentWillMount(),"function"===typeof k.UNSAFE_componentWillMount&&"function"!==typeof c.getDerivedStateFromProps&&k.UNSAFE_componentWillMount(),f.length){l=f;var m=
h;f=null;h=!1;if(m&&1===l.length)k.state=l[0];else{r=m?l[0]:k.state;var t=!0;for(m=m?1:0;m<l.length;m++){var v=l[m];v="function"===typeof v?v.call(k,r,g.props,d):v;null!=v&&(t?(t=!1,r=p({},r,v)):p(r,v))}k.state=r}}else f=null;a=k.render();Da(a,c);g=void 0;if("function"===typeof k.getChildContext&&(d=c.childContextTypes,"object"===typeof d)){g=k.getChildContext();for(var K in g)K in d?void 0:u("108",M(c)||"Unknown",K)}g&&(b=p({},b,g))}for(;q.isValidElement(a);){var g=a,d=g.type;if("function"!==typeof d)break;
c(g,d)}return{child:a,context:b}}
var Fa=function(){function a(b,e){if(!(this instanceof a))throw new TypeError("Cannot call a class as a function");q.isValidElement(b)?b.type!==z?b=[b]:(b=b.props.children,b=q.isValidElement(b)?[b]:X(b)):b=X(b);b={type:null,domNamespace:qa.html,children:b,childIndex:0,context:ca,footer:""};var c=O[0];if(0===c){var g=O;c=g.length;var d=2*c;65536>=d?void 0:u("304");var h=new Uint16Array(d);h.set(g);O=h;O[0]=c+1;for(g=c;g<d-1;g++)O[g]=g+1;O[d-1]=0}else O[0]=O[c];this.threadID=c;this.stack=[b];this.exhausted=
!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=e;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}a.prototype.destroy=function(){if(!this.exhausted){this.exhausted=!0;var a=this.threadID;O[a]=O[0];O[0]=a}};a.prototype.pushProvider=function(a){var b=++this.contextIndex,c=a.type._context,g=this.threadID;N(c,g);var d=c[g];this.contextStack[b]=c;this.contextValueStack[b]=d;c[g]=a.props.value};a.prototype.popProvider=function(){var a=
this.contextIndex,e=this.contextStack[a],c=this.contextValueStack[a];this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;e[this.threadID]=c};a.prototype.read=function(a){if(this.exhausted)return null;var b=V;V=this.threadID;var c=Y.currentDispatcher;Y.currentDispatcher=pa;try{for(var g=[""],d=!1;g[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var h=this.threadID;O[h]=O[0];O[0]=h;break}var f=this.stack[this.stack.length-1];if(d||f.childIndex>=f.children.length){var B=
f.footer;""!==B&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===f.type)this.currentSelectValue=null;else if(null!=f.type&&null!=f.type.type&&f.type.type.$$typeof===E)this.popProvider(f.type);else if(f.type===I){this.suspenseDepth--;var A=g.pop();if(d){d=!1;var n=f.fallbackFrame;n?void 0:u("303");this.stack.push(n);continue}else g[this.suspenseDepth]+=A}g[this.suspenseDepth]+=B}else{var l=f.children[f.childIndex++],k="";try{k+=this.render(l,f.context,f.domNamespace)}catch(r){throw r;
}finally{}g.length<=this.suspenseDepth&&g.push("");g[this.suspenseDepth]+=k}}return g[0]}finally{Y.currentDispatcher=c,V=b}};a.prototype.render=function(a,e,c){if("string"===typeof a||"number"===typeof a){c=""+a;if(""===c)return"";if(this.makeStaticMarkup)return U(c);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+U(c);this.previousWasTextNode=!0;return U(c)}e=Ea(a,e,this.threadID);a=e.child;e=e.context;if(null===a||!1===a)return"";if(!q.isValidElement(a)){if(null!=a&&null!=a.$$typeof){var b=a.$$typeof;
b===y?u("257"):void 0;u("258",b.toString())}a=X(a);this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:e,footer:""});return""}b=a.type;if("string"===typeof b)return this.renderDOM(a,e,c);switch(b){case C:case G:case D:case z:return a=X(a.props.children),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:e,footer:""}),"";case I:u("294")}if("object"===typeof b&&null!==b)switch(b.$$typeof){case H:var d=b.render(a.props,a.ref);d=oa(b.render,a.props,d,a.ref);
d=X(d);this.stack.push({type:null,domNamespace:c,children:d,childIndex:0,context:e,footer:""});return"";case J:return a=[q.createElement(b.type,p({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:e,footer:""}),"";case E:return b=X(a.props.children),c={type:a,domNamespace:c,children:b,childIndex:0,context:e,footer:""},this.pushProvider(a),this.stack.push(c),"";case F:b=a.type;d=a.props;var h=this.threadID;N(b,h);b=X(d.children(b[h]));this.stack.push({type:a,
domNamespace:c,children:b,childIndex:0,context:e,footer:""});return"";case L:u("295")}u("130",null==b?b:typeof b,"")};a.prototype.renderDOM=function(a,e,c){var b=a.type.toLowerCase();c===qa.html&&ra(b);za.hasOwnProperty(b)||(ya.test(b)?void 0:u("65",b),za[b]=!0);var d=a.props;if("input"===b)d=p({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===b){var h=d.value;if(null==h){h=
d.defaultValue;var f=d.children;null!=f&&(null!=h?u("92"):void 0,Array.isArray(f)&&(1>=f.length?void 0:u("93"),f=f[0]),h=""+f);null==h&&(h="")}d=p({},d,{value:void 0,children:""+h})}else if("select"===b)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=p({},d,{value:void 0});else if("option"===b){f=this.currentSelectValue;var B=Aa(d.children);if(null!=f){var A=null!=d.value?d.value+"":B;h=!1;if(Array.isArray(f))for(var n=0;n<f.length;n++){if(""+f[n]===A){h=!0;break}}else h=""+f===A;d=
p({selected:void 0,children:void 0},d,{selected:h,children:B})}}if(h=d)ta[b]&&(null!=h.children||null!=h.dangerouslySetInnerHTML?u("137",b,""):void 0),null!=h.dangerouslySetInnerHTML&&(null!=h.children?u("60"):void 0,"object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML?void 0:u("61")),null!=h.style&&"object"!==typeof h.style?u("62",""):void 0;h=d;f=this.makeStaticMarkup;B=1===this.stack.length;A="<"+a.type;for(x in h)if(Ba.call(h,x)){var l=h[x];if(null!=l){if("style"===
x){n=void 0;var k="",r="";for(n in l)if(l.hasOwnProperty(n)){var m=0===n.indexOf("--"),t=l[n];if(null!=t){var v=n;if(Z.hasOwnProperty(v))v=Z[v];else{var K=v.replace(va,"-$1").toLowerCase().replace(wa,"-ms-");v=Z[v]=K}k+=r+v+":";r=n;m=null==t||"boolean"===typeof t||""===t?"":m||"number"!==typeof t||0===t||W.hasOwnProperty(r)&&W[r]?(""+t).trim():t+"px";k+=m;r=";"}}l=k||null}n=null;b:if(m=b,t=h,-1===m.indexOf("-"))m="string"===typeof t.is;else switch(m){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":m=
!1;break b;default:m=!0}if(m)Ca.hasOwnProperty(x)||(n=x,n=ja(n)&&null!=l?n+"="+('"'+U(l)+'"'):"");else{m=x;n=l;l=R.hasOwnProperty(m)?R[m]:null;if(t="style"!==m)t=null!==l?0===l.type:!(2<m.length)||"o"!==m[0]&&"O"!==m[0]||"n"!==m[1]&&"N"!==m[1]?!1:!0;t||la(m,n,l,!1)?n="":null!==l?(m=l.attributeName,l=l.type,n=3===l||4===l&&!0===n?m+'=""':m+"="+('"'+U(n)+'"')):n=ja(m)?m+"="+('"'+U(n)+'"'):""}n&&(A+=" "+n)}}f||B&&(A+=' data-reactroot=""');var x=A;h="";sa.hasOwnProperty(b)?x+="/>":(x+=">",h="</"+a.type+
">");a:{f=d.dangerouslySetInnerHTML;if(null!=f){if(null!=f.__html){f=f.__html;break a}}else if(f=d.children,"string"===typeof f||"number"===typeof f){f=U(f);break a}f=null}null!=f?(d=[],xa[b]&&"\n"===f.charAt(0)&&(x+="\n"),x+=f):d=X(d.children);a=a.type;c=null==c||"http://www.w3.org/1999/xhtml"===c?ra(a):"http://www.w3.org/2000/svg"===c&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":c;this.stack.push({domNamespace:c,type:b,children:d,childIndex:0,context:e,footer:h});this.previousWasTextNode=
!1;return x};return a}(),Ga={renderToString:function(a){a=new Fa(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new Fa(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){u("207")},renderToStaticNodeStream:function(){u("208")},version:"16.6.3"},Ha={default:Ga},Ia=Ha&&Ga||Ha;module.exports=Ia.default||Ia;


/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var IncidentTemplateIndex = __webpack_require__(1246);

var IncidentTemplates = function (_React$Component) {
  _inherits(IncidentTemplates, _React$Component);

  function IncidentTemplates() {
    _classCallCheck(this, IncidentTemplates);

    return _possibleConstructorReturn(this, (IncidentTemplates.__proto__ || Object.getPrototypeOf(IncidentTemplates)).apply(this, arguments));
  }

  _createClass(IncidentTemplates, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'cpt-table standard-two-row' },
        React.createElement(
          'div',
          { id: 'incident-template-index', className: 'incident-template-index content' },
          React.createElement(IncidentTemplateIndex, { templates: this.props.individual_templates,
            template_groups: this.props.template_groups,
            page_param: this.props.page_param,
            new_template_url: this.props.new_template_url })
        )
      );
    }
  }]);

  return IncidentTemplates;
}(React.Component);

module.exports = IncidentTemplates;

/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var IncidentTemplateListItem = __webpack_require__(653);
var IncidentTemplateListGroup = __webpack_require__(1247);

var IncidentTemplateIndex = function (_React$Component) {
  _inherits(IncidentTemplateIndex, _React$Component);

  function IncidentTemplateIndex(props) {
    _classCallCheck(this, IncidentTemplateIndex);

    var _this = _possibleConstructorReturn(this, (IncidentTemplateIndex.__proto__ || Object.getPrototypeOf(IncidentTemplateIndex)).call(this, props));

    _this.pageParam = props.page_param;
    return _this;
  }

  _createClass(IncidentTemplateIndex, [{
    key: '_insertHeader',
    value: function _insertHeader() {
      return React.createElement(
        'div',
        { className: 'header' },
        React.createElement(
          'h4',
          null,
          'Incident Templates'
        ),
        React.createElement(
          'a',
          { href: this.props.new_template_url, className: 'cpt-button size-small style-primary' },
          '+ New Incident Template'
        )
      );
    }
  }, {
    key: '_buildTemplateItems',
    value: function _buildTemplateItems() {
      var pageParam = this.pageParam;

      return React.createElement(
        'div',
        null,
        this.props.templates.map(function (template) {
          return React.createElement(
            'div',
            { className: 'table-row', key: template.id },
            React.createElement(IncidentTemplateListItem, { template: template, pageParam: pageParam })
          );
        })
      );
    }
  }, {
    key: '_buildTemplateGroups',
    value: function _buildTemplateGroups() {
      var pageParam = this.pageParam;

      return React.createElement(
        'div',
        { className: 'template-group-items' },
        this.props.template_groups.map(function (group) {
          return React.createElement(IncidentTemplateListGroup, { key: group.param, group: group, pageParam: pageParam });
        })
      );
    }
  }, {
    key: '_tableRowGroupClass',
    value: function _tableRowGroupClass() {
      return 'table-row-group ' + (this.props.template_groups.length ? 'has-template-groups' : '');
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.templates.length > 0 || this.props.template_groups.length > 0) {
        return React.createElement(
          'div',
          null,
          this._insertHeader(),
          React.createElement(
            'div',
            { className: this._tableRowGroupClass() },
            this.props.templates.length > 0 ? this._buildTemplateItems() : null,
            this.props.template_groups.length > 0 ? this._buildTemplateGroups() : null
          )
        );
      }
      return React.createElement(
        'div',
        null,
        this._insertHeader(),
        React.createElement(
          'div',
          { className: 'table-row-group' },
          React.createElement(
            'div',
            { className: 'table-row blank-state' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'strong',
                null,
                'Proper preparation prevents poor performance!'
              )
            ),
            React.createElement(
              'small',
              null,
              'Prepare for downtime before it happens: ',
              React.createElement(
                'a',
                { href: this.props.new_template_url },
                'Create an incident template.'
              )
            )
          )
        )
      );
    }
  }]);

  return IncidentTemplateIndex;
}(React.Component);

module.exports = IncidentTemplateIndex;

/***/ }),

/***/ 1247:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(26);

var IncidentTemplateListItem = __webpack_require__(653);
var EditFieldModal = __webpack_require__(1248);

var ClosedState = "fa fa-plus-square-o";
var OpenState = "fa fa-minus-square-o";

var IncidentTemplateListGroup = function (_React$Component) {
  _inherits(IncidentTemplateListGroup, _React$Component);

  function IncidentTemplateListGroup(props) {
    _classCallCheck(this, IncidentTemplateListGroup);

    var _this = _possibleConstructorReturn(this, (IncidentTemplateListGroup.__proto__ || Object.getPrototypeOf(IncidentTemplateListGroup)).call(this, props));

    _this.state = { groupShow: OpenState };
    return _this;
  }

  _createClass(IncidentTemplateListGroup, [{
    key: '_toggleDropdown',
    value: function _toggleDropdown() {
      if (this.state.groupShow == ClosedState) {
        this.setState({ groupShow: OpenState });
      } else {
        this.setState({ groupShow: ClosedState });
      }
    }
  }, {
    key: '_showTemplateGroups',
    value: function _showTemplateGroups() {
      var pageParam = this.props.pageParam;

      return React.createElement(
        'div',
        null,
        this.props.group.templates.map(function (template) {
          return React.createElement(
            'div',
            { className: 'template-sub-item', key: template.id },
            React.createElement(IncidentTemplateListItem, { template: template, pageParam: pageParam })
          );
        })
      );
    }
  }, {
    key: '_triggerEditModal',
    value: function _triggerEditModal(event) {
      event.preventDefault();
      event.stopPropagation();
      $(ReactDOM.findDOMNode(this)).find('#modal-confirmation-edit-incident-template-group-name').modal();
    }
  }, {
    key: '_handleDelete',
    value: function _handleDelete() {
      if (window.confirm("Are you sure you want to delete this template group? Templates in this group won't be deleted, but will become \"ungrouped\" templates.")) {
        $.ajax({
          type: 'DELETE',
          url: Routes.page_incident_template_group_path(this.props.pageParam, this.props.group.param),
          dataType: 'JSON',
          success: function success(data, textStatus, xhr) {
            window.location.reload(true);
          },
          error: function error(xhr, textStatus) {
            HRB.utils.basicFailAndReload(xhr);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var group = this.props.group;

      return React.createElement(
        'div',
        { className: 'table-row' },
        React.createElement('i', { className: this.state.groupShow, onClick: this._toggleDropdown.bind(this) }),
        React.createElement(
          'div',
          { className: 'template-meta' },
          React.createElement(
            'strong',
            null,
            group.name
          )
        ),
        React.createElement(
          'a',
          { href: '#', onClick: this._triggerEditModal.bind(this) },
          'Edit'
        ),
        React.createElement(
          'a',
          { href: '#', className: 'template-delete', onClick: this._handleDelete.bind(this) },
          'Delete'
        ),
        this.state.groupShow == OpenState ? this._showTemplateGroups() : null,
        React.createElement(EditFieldModal, { id: 'edit-incident-template-group-name',
          title: "Edit " + group.name,
          putUrl: Routes.page_update_group_name_path(this.props.pageParam),
          owningEntityParam: group.param,
          label: 'Group Name',
          placeholder: group.name,
          paramName: 'group_name',
          submit_text: 'Save' })
      );
    }
  }]);

  return IncidentTemplateListGroup;
}(React.Component);

module.exports = IncidentTemplateListGroup;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var cx = __webpack_require__(20);

var Input = __webpack_require__(86);

var EditFieldModal = function (_React$Component) {
  _inherits(EditFieldModal, _React$Component);

  /**
   * A reusable modal with an input field.
   *
   * @param {object} props
   * @param {string} props.id - Id of the modal confirmation div, will be 'modal-confirmation-{{PROVIDED_ID}}'
   * @param {string} props.title - Title of the modal
   * @param {string} props.label - Label for the input
   * @param {string} props.putUrl - Where are going to send this thing?
   * @param {string} props.paramName - name of the param to send up the chain
   * @param {string} props.owningEntityParam - Param for the object that we're updating with this input
   * @param {string} props.placeholder - placeholder text for the input
   * @param {string} props.submit_text - the text used as the submit button text
   */

  function EditFieldModal(props) {
    _classCallCheck(this, EditFieldModal);

    var _this = _possibleConstructorReturn(this, (EditFieldModal.__proto__ || Object.getPrototypeOf(EditFieldModal)).call(this, props));

    _this.state = { inputValue: null };
    return _this;
  }

  _createClass(EditFieldModal, [{
    key: '_setInputValue',
    value: function _setInputValue(e) {
      this.setState({ inputValue: e.target.value });
    }
  }, {
    key: '_submitInput',
    value: function _submitInput() {
      if (this.state.inputValue != null) {
        var params = { id: this.props.owningEntityParam };
        params[this.props.paramName] = this.state.inputValue;

        $.ajax({
          type: 'PUT',
          url: this.props.putUrl,
          data: params,
          success: function success(data, textStatus, xhr) {
            window.location.reload(true);
          },
          error: function error(xhr, textStatus) {
            HRB.utils.basicFailAndReload(xhr);
          }
        });
      } else {
        alert('This field cannot be blank!');
      }
    }
  }, {
    key: '_onCancel',
    value: function _onCancel() {
      $(document).trigger('statuspage.confirm.' + this.props.id + '.canceled');
      if (this.props.onCancel) {
        this.props.onCancel();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var className = cx('modal hide fade modal-confirmation', this.props.className);

      return React.createElement(
        'div',
        { className: className, id: "modal-confirmation-" + this.props.id, style: { display: 'none' } },
        React.createElement(
          'div',
          { className: 'modal-header' },
          React.createElement(
            'a',
            { href: '#', 'data-dismiss': 'modal', className: 'close' },
            '\xD7'
          ),
          React.createElement(
            'h4',
            null,
            this.props.title
          )
        ),
        React.createElement(
          'div',
          { className: 'modal-body' },
          React.createElement(Input, { type: 'text',
            label: this.props.label,
            inputClass: 'full-width',
            name: this.props.paramName,
            placeholder: this.props.placeholder,
            onChange: this._setInputValue.bind(this) })
        ),
        React.createElement(
          'div',
          { className: 'modal-footer' },
          React.createElement(
            'button',
            { className: 'cpt-button style-primary', 'data-dismiss': 'modal', id: "btn-confirm-" + this.props.id, onClick: this._submitInput.bind(this) },
            this.props.submit_text
          ),
          React.createElement(
            'a',
            { href: '#', id: "btn-cancel-" + this.props.id, 'data-dismiss': 'modal', className: 'close', onClick: this._onCancel.bind(this) },
            'Cancel'
          )
        )
      );
    }
  }]);

  return EditFieldModal;
}(React.Component);

module.exports = EditFieldModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _formNoMutations = __webpack_require__(1250);

var _formNoMutations2 = _interopRequireDefault(_formNoMutations);

var _checkbox = __webpack_require__(193);

var _checkbox2 = _interopRequireDefault(_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var Input = __webpack_require__(86);
var InputDropdownToggle = __webpack_require__(1251);
var SelectInput = __webpack_require__(143);
var TextArea = __webpack_require__(198);
var ItemsSelector = __webpack_require__(170);

var IncidentTemplateForm = function (_React$Component) {
  _inherits(IncidentTemplateForm, _React$Component);

  function IncidentTemplateForm(props) {
    _classCallCheck(this, IncidentTemplateForm);

    var _this = _possibleConstructorReturn(this, (IncidentTemplateForm.__proto__ || Object.getPrototypeOf(IncidentTemplateForm)).call(this, props));

    _this._handleTwitterCheckboxChange = function (event) {
      _this.setState({ shouldTweet: event.target.checked });
    };

    _this._handleSendNotificationsCheckboxChange = function (event) {
      _this.setState({ shouldSendNotifications: event.target.checked });
    };

    _this.state = {
      shouldTweet: _this.props.should_tweet,
      shouldSendNotifications: _this.props.should_send_notifications
    };
    return _this;
  }

  _createClass(IncidentTemplateForm, [{
    key: '_showGroupDropdown',
    value: function _showGroupDropdown() {
      if (this.props.allow_groups) {
        return React.createElement(InputDropdownToggle, { dropdownName: 'incident_template[group_id]',
          inputName: 'group_name',
          label: 'Incident Template Group',
          helpBlockText: 'The group that this template belongs to.',
          placeholder: 'New Template Group Name',
          toggleElement: 'create',
          cancelText: 'Cancel new group creation',
          options: this.props.group_values,
          defaultValue: this.props.default_group,
          selectClass: 'full-width',
          startWithInput: this.props.startWithInput,
          inputStartValue: this.props.inputStartValue });
      } else {
        return React.createElement('input', { type: 'hidden', id: 'nil_group_selector', name: 'incident_template[group_id]', value: 'no_group' });
      }
    }
  }, {
    key: '_showComponentSelector',
    value: function _showComponentSelector() {
      if (this.props.components.length > 0) {
        return React.createElement(
          'div',
          { className: 'component-subscriptions control-group' },
          React.createElement(
            'label',
            null,
            'Components Affected'
          ),
          React.createElement(ItemsSelector, { items: this.props.components,
            className: this.props.item_selector_class_name,
            preselectedItemIds: this.props.selected_components,
            hiddenFieldName: 'incident_template[component_ids]' })
        );
      }
    }
  }, {
    key: '_showSendNotificationsCheckbox',
    value: function _showSendNotificationsCheckbox() {
      return React.createElement(
        'div',
        { className: 'send-notifications-update control-group' },
        React.createElement(
          'label',
          null,
          'Send Notifications'
        ),
        React.createElement(_checkbox2.default, { name: 'incident_template[should_send_notifications]',
          label: 'Checks the \'Send Notifications\' checkbox when using this template',
          defaultChecked: this.props.should_send_notifications,
          onChange: this._handleSendNotificationsCheckboxChange }),
        React.createElement('input', { type: 'hidden', id: 'should_send_notifications', name: 'incident_template[should_send_notifications]', value: !!this.state.shouldSendNotifications })
      );
    }
  }, {
    key: '_showTwitterCheckbox',
    value: function _showTwitterCheckbox() {
      // Checkboxes are shitty, and either return 'on' or nil.
      // Utilize a hidden input to send either true or false to the controller.
      if (this.props.allow_twitter && this.props.isTwitterAuthorized) {
        return React.createElement(
          'div',
          { className: 'twitter-update control-group' },
          React.createElement(
            'label',
            null,
            'Tweet Update'
          ),
          React.createElement(_checkbox2.default, { name: 'incident_template[should_tweet]',
            label: 'Check the \'Post to Twitter\' checkbox when using this template',
            defaultChecked: this.props.should_tweet,
            onChange: this._handleTwitterCheckboxChange }),
          React.createElement('input', { type: 'hidden', id: 'should_tweet', name: 'incident_template[should_tweet]', value: !!this.state.shouldTweet })
        );
      } else {
        return React.createElement('input', { type: 'hidden', id: 'should_tweet', name: 'incident_template[should_tweet]', value: 'false' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'incident-template-form' },
        React.createElement(
          _formNoMutations2.default,
          { 'for': 'IncidentTemplate', method: this.props.method, action: this.props.path },
          this._showGroupDropdown(),
          React.createElement(Input, { type: 'text',
            inputClass: 'full-width',
            label: 'Template Name',
            name: 'incident_template[name]',
            placeholder: 'Template Name',
            defaultValue: this.props.template ? this.props.template.name : null,
            helpBlockText: 'This is used internally so you can identify which template you\'re using.' }),
          React.createElement(SelectInput, { name: 'incident_template[update_status]',
            label: 'Incident Status',
            options: this.props.status_values,
            helpBlockText: 'The status that will be applied to the incident or scheduled maintenance.',
            defaultValue: this.props.template ? this.props.template.update_status : null,
            selectClass: 'full-width',
            groups: ["Realtime Incidents", "Scheduled Maintenances"] }),
          React.createElement(Input, { type: 'text',
            inputClass: 'full-width',
            label: 'Incident Title',
            name: 'incident_template[title]',
            placeholder: 'Incident Title',
            defaultValue: this.props.template ? this.props.template.title : null,
            helpBlockText: 'The title given to the incident or scheduled maintenance. This is only applied when creating an incident or scheduled maintenance.' }),
          React.createElement(
            'div',
            { className: 'span12 text-area-container control-group' },
            React.createElement(TextArea, { inputClass: 'full-width',
              label: 'Message Body',
              name: 'incident_template[body]',
              placeholder: 'Message Body',
              defaultValue: this.props.template ? this.props.template.body : null,
              textareaStyle: { height: 160 } })
          ),
          this._showComponentSelector(),
          this._showTwitterCheckbox(),
          this._showSendNotificationsCheckbox(),
          React.createElement(
            'div',
            { className: 'form-actions' },
            React.createElement(
              'button',
              { type: 'submit', className: 'cpt-button style-primary size-small' },
              this.props.button_text,
              ' Template'
            )
          )
        )
      );
    }
  }]);

  return IncidentTemplateForm;
}(React.Component);

IncidentTemplateForm.defaultProps = {
  shouldTweet: false
};


module.exports = IncidentTemplateForm;

/***/ }),

/***/ 1250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var FormNoMutations = /** @class */ (function (_super) {
    __extends(FormNoMutations, _super);
    function FormNoMutations() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FormNoMutations.prototype, "method", {
        get: function () {
            if (['put', 'patch'].includes(this.props.method.toLowerCase())) {
                return 'post';
            }
            return this.props.method;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormNoMutations, "authenticityToken", {
        get: function () {
            var tags = Array.from(document.getElementsByTagName('meta'));
            for (var _i = 0, tags_1 = tags; _i < tags_1.length; _i++) {
                var tag = tags_1[_i];
                if (tag.name === 'csrf-token') {
                    return tag.content;
                }
            }
            return;
        },
        enumerable: true,
        configurable: true
    });
    FormNoMutations.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("form", { ref: function (ref) { return ref && (_this.form = ref); }, action: this.props.action, method: this.method, onSubmit: this.props.onSubmit, acceptCharset: "UTF-8", className: this.props.className, id: this.props.id },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "hidden", name: "utf8", value: "\u0213" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "hidden", name: "_method", value: this.props.method }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "hidden", name: "authenticity_token", value: FormNoMutations.authenticityToken }),
            this.props.children));
    };
    FormNoMutations.defaultProps = {
        method: 'POST',
        onSubmit: function () { },
    };
    return FormNoMutations;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["default"] = (FormNoMutations);


/***/ }),

/***/ 1251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Input = __webpack_require__(86);
var SelectInput = __webpack_require__(143);

var InputDropdownToggle = function (_React$Component) {
  _inherits(InputDropdownToggle, _React$Component);

  /*
   * A combination Dropdown/Input field that allows the user to either select an existing value, or create a new one.
   * On selection of 'Create a new (template, component, etc)', the field will toggle to an input value.
   *
   * @param {object} props
   * @param {object} props.dropdownName - name tied to the Dropdown
   * @param {object} props.inputName - name tied to the Input
   * @param {object} props.label - label for the input & dropdown
   * @param {object} props.helpBlockText - helpblock text for the input & dropdown
   * @param {object} props.options - options for the dropdown box
   * @param {object} props.defaultValue - defaultValue for the text area
   * @param {object} props.toggleElement - the value in the dropdown that triggers the switch to input
   * @param {object} props.cancelText - Text and value for link that cancels new group creating
   * @param {object} props.startWithInput - boolean deciding whether to display the Input field from the start
   * @param {object} props.inputStartValue - string value to pre-populate the input field with
   */

  function InputDropdownToggle(props) {
    _classCallCheck(this, InputDropdownToggle);

    var _this = _possibleConstructorReturn(this, (InputDropdownToggle.__proto__ || Object.getPrototypeOf(InputDropdownToggle)).call(this, props));

    _this.id = 'input-dropdown-toggle-' + Math.round(Math.random() * 100000);
    _this.state = { showDropdown: !_this.props.startWithInput };
    return _this;
  }

  _createClass(InputDropdownToggle, [{
    key: '_handleGroupChange',
    value: function _handleGroupChange(event) {
      if (event.target.value === this.props.toggleElement) {
        this.setState({ showDropdown: false });
      } else if (event.target.id === this.id + '-cancel-link') {
        this.setState({ showDropdown: true });
      }
    }
  }, {
    key: '_determineFormElement',
    value: function _determineFormElement() {
      if (this.state.showDropdown) {
        return React.createElement(SelectInput, { name: this.props.dropdownName,
          label: this.props.label,
          helpBlockText: this.props.helpBlockText,
          options: this.props.options,
          defaultValue: this.props.defaultValue,
          onChange: this._handleGroupChange.bind(this),
          selectClass: this.props.selectClass });
      } else {
        return React.createElement(
          'span',
          null,
          React.createElement(Input, { type: 'text',
            inputClass: 'full-width',
            label: this.props.label,
            name: this.props.inputName,
            placeholder: this.props.placeholder,
            selectClass: this.props.selectClass,
            defaultValue: this.props.inputStartValue }),
          React.createElement(
            'span',
            { className: 'help-block' },
            React.createElement(
              'a',
              { href: '#', id: this.id + '-cancel-link', onClick: this._handleGroupChange.bind(this) },
              this.props.cancelText
            )
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'control-group' },
        this._determineFormElement()
      );
    }
  }]);

  return InputDropdownToggle;
}(React.Component);

module.exports = InputDropdownToggle;

/***/ }),

/***/ 1252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _make_owner = __webpack_require__(1253);

var _make_owner2 = _interopRequireDefault(_make_owner);

var _delete_user = __webpack_require__(1254);

var _delete_user2 = _interopRequireDefault(_delete_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModifyUser = function (_React$Component) {
  _inherits(ModifyUser, _React$Component);

  function ModifyUser(props) {
    _classCallCheck(this, ModifyUser);

    return _possibleConstructorReturn(this, (ModifyUser.__proto__ || Object.getPrototypeOf(ModifyUser)).call(this, props));
  }

  _createClass(ModifyUser, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { display: "inline" } },
        _react2.default.createElement(_make_owner2.default, this.props),
        _react2.default.createElement(_delete_user2.default, this.props)
      );
    }
  }]);

  return ModifyUser;
}(_react2.default.Component);

module.exports = ModifyUser;

/***/ }),

/***/ 1253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _confirm = __webpack_require__(84);

var _confirm2 = _interopRequireDefault(_confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(249),
    MODAL_PREFIX = _require.MODAL_PREFIX;

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(26);

var MAKE_OWNER_MODAL = 'make-owner';
var MAKE_OWNER_MODAL_TRIGGER = MODAL_PREFIX + MAKE_OWNER_MODAL;

var MakeOwner = function (_React$Component) {
  _inherits(MakeOwner, _React$Component);

  /**
   * @params props.organization
   * @params props.user
   */
  function MakeOwner(props) {
    _classCallCheck(this, MakeOwner);

    return _possibleConstructorReturn(this, (MakeOwner.__proto__ || Object.getPrototypeOf(MakeOwner)).call(this, props));
  }

  _createClass(MakeOwner, [{
    key: '_changeOwner',
    value: function _changeOwner() {
      var ownerUrl = Routes.owner_organization_user_path(this.props.organization, this.props.user);
      var email = this.props.user.email;

      $.ajax({
        type: 'POST',
        url: ownerUrl,
        data: { _method: 'PUT' },
        success: function success() {
          HRB.utils.notify("Great! " + email + " is now the new owner.");
          window.location.reload();
        },
        error: function error(xhr, textStatus, _error) {
          HRB.utils.notify("Sorry, it looks like changing the owner didn't work.", { cssClass: 'error' });
        }
      });
    }
  }, {
    key: '_openModal',
    value: function _openModal(e) {
      e.preventDefault();
      $(ReactDOM.findDOMNode(this)).find('#' + MAKE_OWNER_MODAL_TRIGGER).modal();
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { style: { display: "inline" } },
        React.createElement(
          'a',
          { className: 'make-owner', href: '#',
            onClick: this._openModal.bind(this) },
          'Make Owner'
        ),
        React.createElement(_confirm2.default, { id: MAKE_OWNER_MODAL,
          title: 'Change owner',
          message: 'This will change the owner of the organization.',
          onConfirm: this._changeOwner.bind(this),
          confirm_text: 'Yes, change owner' })
      );
    }
  }]);

  return MakeOwner;
}(React.Component);

module.exports = MakeOwner;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _confirm = __webpack_require__(84);

var _confirm2 = _interopRequireDefault(_confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(249),
    MODAL_PREFIX = _require.MODAL_PREFIX;

var React = __webpack_require__(0);

var DeleteUser = function (_React$Component) {
  _inherits(DeleteUser, _React$Component);

  /**
   * @params props.organization
   * @params props.user
   */
  function DeleteUser(props) {
    _classCallCheck(this, DeleteUser);

    return _possibleConstructorReturn(this, (DeleteUser.__proto__ || Object.getPrototypeOf(DeleteUser)).call(this, props));
  }

  _createClass(DeleteUser, [{
    key: 'render',
    value: function render() {
      var ownerUrl = Routes.delete_organization_user_path(this.props.organization, this.props.user);
      return React.createElement(
        'a',
        { href: ownerUrl, style: { display: "inline" } },
        'Delete User'
      );
    }
  }]);

  return DeleteUser;
}(React.Component);

module.exports = DeleteUser;

/***/ }),

/***/ 1255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _confirm = __webpack_require__(84);

var _confirm2 = _interopRequireDefault(_confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(26);
var UpdateBillingSubscriptionModal = __webpack_require__(655);

var Textarea = __webpack_require__(198);

var subscriptionToCancel = null;

var OrganizationPages = function (_React$Component) {
  _inherits(OrganizationPages, _React$Component);

  /**
   * @params props
   * @params props.pages
   * @params props.coupons
   * @params props.types
   * @params props.plans
   */
  function OrganizationPages(props) {
    _classCallCheck(this, OrganizationPages);

    var _this = _possibleConstructorReturn(this, (OrganizationPages.__proto__ || Object.getPrototypeOf(OrganizationPages)).call(this, props));

    _this.modalID = 'update-billing-subscription-modal';
    _this.state = {};
    return _this;
  }

  _createClass(OrganizationPages, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      $('.update-page-subscription').on('click', this.openSubscriptionModal.bind(this));
      $('.cancel').on('click', function (event) {
        var type, id;
        if (event.target.dataset.pageId) {
          type = 'page';
          id = event.target.dataset.pageId;
        } else if (event.target.dataset.organizationId) {
          type = 'organization';
          id = event.target.dataset.organizationId;
        }
        subscriptionToCancel = {
          id: id,
          type: type
        };
        _this2.cancel();
      });
      $(ReactDOM.findDOMNode(this)).find('#btn-confirm-cancel-subscription').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        _this2.onCancel().then(function () {
          $(ReactDOM.findDOMNode(_this2)).find('#modal-confirmation-cancel-subscription').modal('hide');
          window.location.reload();
        }).catch(function (error) {
          _this2.setState({ cancelError: error });
        });
      });
    }
  }, {
    key: 'cancelSubscription',
    value: function cancelSubscription(id, type, reason) {
      if (!id) alert('#cancelSubscription - You must provide a id to cancel.');
      if (!reason) alert('#cancelSubscription - You must provide a id to cancel.');
      if (type !== 'page' && type !== 'organization') alert('#cancelSubscription - You must provide a valid type.  {page|organization}');
      window.location = Routes[type + '_admin_cancel_billing_subscription_path'](id, { reason: reason });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      $('.update-page-subscription').off('click', this.openSubscriptionModal.bind(this));
    }
  }, {
    key: 'openSubscriptionModal',
    value: function openSubscriptionModal(event) {
      var _this3 = this;

      var pageId = void 0;
      if (!!$(event.target).data().pageId) {
        pageId = $(event.target).data().pageId;
      } else {
        pageId = $(event.target).parent('*[data-page-id]').data().pageId;
      }
      this.setState({ page: null }, function () {
        _this3.setState({ page: _this3.props.pages[pageId] }, function () {
          $('.modal#' + _this3.modalID).modal();
        });
      });
    }
  }, {
    key: 'onCancel',
    value: function onCancel() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var reason = $(ReactDOM.findDOMNode(_this4.refs.reason)).find('textarea').eq(0).val().trim();
        if (!reason) {
          reject('You must provide a reason for cancelling');
        } else if (!subscriptionToCancel) {
          reject('There was a problem cancelling your subscription');
        } else {
          $.ajax({
            type: 'DELETE',
            url: Routes[subscriptionToCancel.type + '_admin_cancel_billing_subscription_path'](subscriptionToCancel.id, { format: 'json' }),
            data: { reason: reason },
            success: resolve,
            error: function error(errors) {
              reject(JSON.parse(errors.responseText).errors[0]);
            }
          });
        }
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      $(ReactDOM.findDOMNode(this)).find('#modal-confirmation-cancel-subscription').modal();
    }
  }, {
    key: 'cancelError',
    value: function cancelError() {
      if (this.state.cancelError) {
        return React.createElement(
          'span',
          { className: 'error', style: { color: 'indianred' } },
          this.state.cancelError
        );
      }
    }
  }, {
    key: 'subscriptionModal',
    value: function subscriptionModal() {
      if (this.state.page) {
        return React.createElement(UpdateBillingSubscriptionModal, { id: this.modalID, page: this.state.page, plans: this.props.plans, coupons: this.props.coupons, types: this.props.types });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        this.subscriptionModal(),
        React.createElement(
          _confirm2.default,
          { id: 'cancel-subscription',
            title: 'Cancel subscription',
            onConfirm: this.onCancel.bind(this),
            confirm_text: 'Yes, cancel it' },
          React.createElement(
            'div',
            { style: { padding: '1rem 2rem' } },
            React.createElement(Textarea, { name: 'reason', ref: 'reason', label: 'Are you sure?  Why?' }),
            this.cancelError()
          )
        )
      );
    }
  }]);

  return OrganizationPages;
}(React.Component);

module.exports = OrganizationPages;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _inflection = __webpack_require__(141);

var _inflection2 = _interopRequireDefault(_inflection);

var _lodash = __webpack_require__(47);

var _lodash2 = _interopRequireDefault(_lodash);

var _select_input = __webpack_require__(143);

var _select_input2 = _interopRequireDefault(_select_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeSelector = function (_React$Component) {
  _inherits(TypeSelector, _React$Component);

  function TypeSelector() {
    _classCallCheck(this, TypeSelector);

    return _possibleConstructorReturn(this, (TypeSelector.__proto__ || Object.getPrototypeOf(TypeSelector)).apply(this, arguments));
  }

  _createClass(TypeSelector, [{
    key: 'types',
    value: function types() {
      var options = Object.keys(this.props.types).map(function (type) {
        return {
          name: _inflection2.default.titleize(_inflection2.default.underscore(type.replace('BillingSubscription', 'Subscription'))),

          value: type
        };
      });

      return _lodash2.default.sortBy(options, 'name');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_select_input2.default, { name: 'billing_subscription[type]',
        options: this.types(),
        label: 'Type',
        defaultValue: this.props.type,
        onChange: this.props.onChange.bind(this),
        helpBlockText: this.props.types[this.props.type].helpBlockText });
    }
  }]);

  return TypeSelector;
}(_react2.default.Component);

module.exports = TypeSelector;

/***/ }),

/***/ 1257:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _select_input = __webpack_require__(143);

var _select_input2 = _interopRequireDefault(_select_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CouponSelector = function (_React$Component) {
  _inherits(CouponSelector, _React$Component);

  function CouponSelector() {
    _classCallCheck(this, CouponSelector);

    return _possibleConstructorReturn(this, (CouponSelector.__proto__ || Object.getPrototypeOf(CouponSelector)).apply(this, arguments));
  }

  _createClass(CouponSelector, [{
    key: 'render',
    value: function render() {
      if (!this.props.types[this.props.type].coupon_enabled) return _react2.default.createElement('div', null);

      var noCoupon = [{ name: 'No discount', value: 'nil' }];

      var couponOptions = this.props.coupons.map(function (coupon) {
        return { name: coupon.display + ' (' + coupon.id + ')', value: coupon.id };
      });

      var coupons = noCoupon.concat(_.sortBy(couponOptions, 'name'));

      return _react2.default.createElement(_select_input2.default, { name: 'billing_subscription[coupon]',
        options: coupons,
        label: 'Coupon',
        defaultValue: this.props.coupon ? this.props.coupon.id : 'nil' });
    }
  }]);

  return CouponSelector;
}(_react2.default.Component);

module.exports = CouponSelector;

/***/ }),

/***/ 1258:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _inflection = __webpack_require__(141);

var _inflection2 = _interopRequireDefault(_inflection);

var _lodash = __webpack_require__(47);

var _lodash2 = _interopRequireDefault(_lodash);

var _select_input = __webpack_require__(143);

var _select_input2 = _interopRequireDefault(_select_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlanSelector = function (_React$Component) {
  _inherits(PlanSelector, _React$Component);

  function PlanSelector() {
    _classCallCheck(this, PlanSelector);

    return _possibleConstructorReturn(this, (PlanSelector.__proto__ || Object.getPrototypeOf(PlanSelector)).apply(this, arguments));
  }

  _createClass(PlanSelector, [{
    key: 'planOption',
    value: function planOption(plan) {
      return { name: _inflection2.default.titleize(plan.name), value: plan.id };
    }
  }, {
    key: 'plans',
    value: function plans() {
      return _lodash2.default.sortBy(this.props.plans.map(this.planOption), 'name');
    }
  }, {
    key: 'render',
    value: function render() {
      // If the current type isn't plan enabled, we'll default to the available business plan
      var businessPlan = _lodash2.default.find(this.props.plans, { name: 'business' });
      var planOptions = this.props.types[this.props.type].plan_enabled ? this.plans() : [this.planOption(businessPlan)];
      return _react2.default.createElement(_select_input2.default, { name: 'billing_subscription[plan_id]',
        id: 'plan_id',
        options: planOptions,
        defaultValue: this.props.plan.id,
        label: 'Plan',
        onChange: this.props.onChange
      });
    }
  }]);

  return PlanSelector;
}(_react2.default.Component);

module.exports = PlanSelector;

/***/ }),

/***/ 1259:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var _ = __webpack_require__(47);
var ItemSelector = __webpack_require__(170);
var Label = __webpack_require__(1260);

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  /**
   * This is a composition form that displays the ItemSelectors and subscriber checkbox for PageAccessUser creation
   * and update. It controls the logic around showing and hiding the different ItemSelectors and the subscribe
   * checkbox.
   *
   * @param {object} props
   * @param {string} props.group.items - A collection of pag items to display.  Minimum required field is `name`
   * @param {string} props.group.preselectedItemIds - A collection of preselected group item ids
   * @param {string} props.group.hiddenFieldName
   * @param {string} props.group.hiddenFieldId
   * @param {string} props.component.items - A collection of component items to display.  Minimum required field is `name`
   * @param {string} props.component.preselectedItemIds - A collection of preselected component item ids
   * @param {string} props.component.hiddenFieldName
   * @param {string} props.component.hiddenFieldId
   * @param {string} props.metric.items - A collection of metric items to display.  Minimum required field is `name`
   * @param {string} props.metric.preselectedItemIds - A collection of preselected metric item ids
   * @param {string} props.metric.hiddenFieldName
   * @param {string} props.metric.hiddenFieldId
   * @param {string} props.subscribe.include - will show the subscribe checkbox if true. We only show that checkbox
   *                                           when a new PageAccessUser is being created
   */
  function Form(props) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

    _this.state = {
      subscribeShow: false,
      componentShow: _this.props.group.preselectedItemIds.length == 0,
      metricShow: _this.props.group.preselectedItemIds.length == 0
    };
    return _this;
  }

  _createClass(Form, [{
    key: '_handlePageAccessGroupOnToggle',
    value: function _handlePageAccessGroupOnToggle(items) {
      // We don't show the component or metrics selectors if a user has selected a group in the UI
      var pageAccessGroups = _.filter(items, function (item) {
        return !!item.selected;
      });
      if (pageAccessGroups.length == 0) {
        // Show the components and metrics ItemSelectors
        this.setState({ componentShow: true });
        this.setState({ metricShow: true });
        // Don't show the subscribe checkbox, since no groups are selected the component selections will control the hide/show for that
        this.setState({ subscribeShow: false });
      } else {
        // Since at least one PAG is selected we hide the components and metrics ItemsSelectors
        this.setState({ componentShow: false });
        this.setState({ metricShow: false });

        // Check to see if we need to be showing the subscribe checkbox because of the PAG selections
        // We only show the subscribe checkbox if a selected PAG has associated components
        var pageAccessGroup = _.find(pageAccessGroups, function (pageAccessGroup) {
          return pageAccessGroup.component_ids.length > 0;
        });
        if (pageAccessGroup != null) {
          // Show the subscription checkbox
          this.setState({ subscribeShow: true });
        } else {
          // Hide the subscription checkbox
          this.setState({ subscribeShow: false });
        }
      }
    }
  }, {
    key: '_handleComponentOnToggle',
    value: function _handleComponentOnToggle(items) {
      // We want to show the subscribe checkbox if the user has selected any of the components in the UI
      var comps = _.filter(items, function (item) {
        return !!item.selected;
      });
      if (comps.length == 0) {
        this.setState({ subscribeShow: false });
      } else {
        this.setState({ subscribeShow: true });
      }
    }
  }, {
    key: '_pageAccessGroups',
    value: function _pageAccessGroups() {
      if (this.props.group.items.length > 0) {
        return React.createElement(
          'div',
          null,
          React.createElement(Label, {
            text: 'Associated Groups',
            tooltipText: 'Add the relevant page access groups that this user should be associated with' }),
          React.createElement(ItemSelector, {
            className: 'inline',
            items: this.props.group.items,
            preselectedItemIds: this.props.group.preselectedItemIds,
            hiddenFieldName: this.props.group.hiddenFieldName,
            onToggle: this._handlePageAccessGroupOnToggle.bind(this),
            hiddenFieldId: this.props.group.hiddenFieldId })
        );
      }
    }
  }, {
    key: '_components',
    value: function _components() {
      if (this.props.component.items.length > 0 && this.state.componentShow) {
        return React.createElement(
          'div',
          null,
          React.createElement(Label, {
            text: 'Associated Components',
            tooltipText: 'Add the relevant components that this user should be associated with' }),
          React.createElement(ItemSelector, {
            className: 'inline',
            items: this.props.component.items,
            preselectedItemIds: this.props.component.preselectedItemIds,
            hiddenFieldName: this.props.component.hiddenFieldName,
            onToggle: this._handleComponentOnToggle.bind(this),
            hiddenFieldId: this.props.component.hiddenFieldId })
        );
      }
    }
  }, {
    key: '_subscribe',
    value: function _subscribe() {
      if (this.props.subscribe.include && this.state.subscribeShow) {
        return React.createElement(
          'div',
          { className: 'control-group', 'data-js-hook': 'subscription-ui' },
          React.createElement(
            'label',
            null,
            'Subscribe To Notifications'
          ),
          React.createElement(
            'div',
            { className: 'controls' },
            React.createElement(
              'label',
              { className: 'checkbox' },
              'Also subscribe this user to the components they have access to ',
              React.createElement('input', { id: 'page_access_user_subscribe_to_components', name: 'page_access_user[subscribe_to_components]', type: 'checkbox', value: '1' })
            ),
            React.createElement(
              'div',
              { className: 'help-block' },
              'User will ',
              React.createElement(
                'strong',
                null,
                'not'
              ),
              ' receive a confirmation email for the subscription.'
            )
          ),
          React.createElement('br', null)
        );
      }
    }
  }, {
    key: '_metrics',
    value: function _metrics() {
      if (this.props.metric.items.length > 0 && this.state.metricShow) {
        return React.createElement(
          'div',
          null,
          React.createElement(Label, {
            text: 'Associated Metrics',
            tooltipText: 'Add the relevant metrics that this user should be associated with' }),
          React.createElement(ItemSelector, {
            className: 'inline',
            items: this.props.metric.items,
            preselectedItemIds: this.props.metric.preselectedItemIds,
            hiddenFieldName: this.props.metric.hiddenFieldName,
            hiddenFieldId: this.props.metric.hiddenFieldId })
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        this._pageAccessGroups(),
        this._components(),
        this._metrics(),
        this._subscribe()
      );
    }
  }]);

  return Form;
}(React.Component);

module.exports = Form;

/***/ }),

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

/**
 * A simple component that will render a label that can include a Statuspage style tooltip with a help icon.
 *
 **/

var Label = function (_React$Component) {
  _inherits(Label, _React$Component);

  function Label() {
    _classCallCheck(this, Label);

    return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
  }

  _createClass(Label, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      $(this.refs.tooltip).tooltip();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(this.refs.tooltip).tooltip("destroy");
    }
  }, {
    key: "_tooltip",
    value: function _tooltip() {
      if (this.props.tooltipText) {
        return React.createElement(
          "a",
          { href: "#", ref: "tooltip", className: "tooltip-base", "data-js-hook": "tooltip", "data-original-title": this.props.tooltipText },
          "?"
        );
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "label",
        null,
        this.props.text,
        this._tooltip()
      );
    }
  }]);

  return Label;
}(React.Component);

module.exports = Label;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1261:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _server = __webpack_require__(251);

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var ESSearchField = __webpack_require__(344);
var inflect = __webpack_require__(141).inflect;

var PageAccess = __webpack_require__(1262);

var PageAccessSearchField = function (_React$Component) {
  _inherits(PageAccessSearchField, _React$Component);

  function PageAccessSearchField() {
    _classCallCheck(this, PageAccessSearchField);

    return _possibleConstructorReturn(this, (PageAccessSearchField.__proto__ || Object.getPrototypeOf(PageAccessSearchField)).apply(this, arguments));
  }

  _createClass(PageAccessSearchField, [{
    key: '_template',

    // Get HTML string for how a typeahead item should be rendered
    value: function _template(suggestion) {
      var view = React.createElement(PageAccessTypeaheadView, { suggestion: suggestion });
      return _server2.default.renderToString(view);
    }
  }, {
    key: 'render',
    value: function render() {
      var searchRoute = PageAccess.searchRoute({ page_id: this.props.page.id });
      function mapResultToUiRoute(suggestion) {
        var url = suggestion.isUser() ? Routes.edit_page_page_access_user_url : Routes.edit_page_page_access_group_url;
        return url(this.props.page, suggestion.id, { domain: null, subdomain: null });
      }
      return React.createElement(ESSearchField, { queryUrl: searchRoute + '?limit=10&q=%QUERY',
        pluralizedResultName: "incidents",
        loadResults: PageAccess.search,
        mapResultToUiUrl: mapResultToUiRoute.bind(this),
        template: this._template.bind(this)
      });
    }
  }]);

  return PageAccessSearchField;
}(React.Component);

var PageAccessTypeaheadView = function (_React$Component2) {
  _inherits(PageAccessTypeaheadView, _React$Component2);

  function PageAccessTypeaheadView() {
    _classCallCheck(this, PageAccessTypeaheadView);

    return _possibleConstructorReturn(this, (PageAccessTypeaheadView.__proto__ || Object.getPrototypeOf(PageAccessTypeaheadView)).apply(this, arguments));
  }

  _createClass(PageAccessTypeaheadView, [{
    key: '_determineType',
    value: function _determineType() {
      var suggestion = this.props.suggestion;

      if (suggestion.isUser()) {
        return {
          iconClass: 'fa-user',
          matchValue: suggestion.email
        };
      } else {
        return {
          iconClass: 'fa-users',
          matchValue: suggestion.name
        };
      }
    }
  }, {
    key: '_titleText',
    value: function _titleText(displayWords) {
      if (this._isNameHighlighted()) {
        var _extractData2 = this._extractData('name'),
            highlightedWords = _extractData2.highlightedWords,
            tagClasses = _extractData2.tagClasses;

        displayWords = this.props.suggestion.name.split(' ').map(function (word, index) {
          if (highlightedWords.indexOf(word.toLowerCase().replace(/[!?\.,]/, '')) >= 0) {
            return React.createElement(
              'strong',
              { className: tagClasses, key: index },
              ' ',
              word,
              ' '
            );
          }
          return React.createElement(
            'span',
            { key: index },
            ' ',
            word,
            ' '
          );
        });
      } else if (this.props.suggestion.isUser()) {
        return React.createElement(
          'span',
          { className: 'name' },
          React.createElement(
            'strong',
            { className: 'es-highlight' },
            this.props.suggestion.email
          )
        );
      }
      return React.createElement(
        'span',
        { className: 'name' },
        displayWords
      );
    }
  }, {
    key: '_extractData',
    value: function _extractData(highlightedField) {
      var text = this.props.suggestion.highlight[highlightedField];
      var highlightItems = $('<span>' + text + '</span>').find('strong');
      var tagClasses = $(highlightItems[0]).attr('class');
      var highlightedWords = _.map(highlightItems, function (t) {
        return $(t).text().toLowerCase();
      });
      return { highlightedWords: highlightedWords, tagClasses: tagClasses };
    }
  }, {
    key: '_isNameHighlighted',
    value: function _isNameHighlighted() {
      return this._checkFieldHighlight('name');
    }
  }, {
    key: '_checkFieldHighlight',
    value: function _checkFieldHighlight(property) {
      return this.props.suggestion.highlight && this.props.suggestion.highlight.hasOwnProperty(property);
    }
  }, {
    key: '_humanizedMetadata',
    value: function _humanizedMetadata(suggestion) {
      if (suggestion.group) {
        return 'Belongs to ' + suggestion.group;
      }
      var list = [];
      _.each(['component', 'metric'], function (field) {
        if (suggestion[field + 's_list'] === undefined) return;
        var count = suggestion[field + 's_list'].length;
        if (count > 0) {
          list.push(count + ' ' + inflect(field, count));
        }
      });
      if (list.length > 0) {
        return 'Has access to ' + list.join(' and ');
      } else {
        return 'Has no access to any components or metrics';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var suggestion = this.props.suggestion;
      var suggestionData = this._determineType();

      return React.createElement(
        'div',
        { className: 'item search-result es-results' },
        React.createElement(
          'div',
          { className: 'icon-container' },
          React.createElement('i', { className: 'fa ' + suggestionData.iconClass })
        ),
        React.createElement(
          'div',
          { className: 'result-text-container' },
          this._titleText(suggestionData.matchValue),
          React.createElement(
            'div',
            null,
            React.createElement(
              'span',
              { className: 'context' },
              this._humanizedMetadata(suggestion)
            )
          )
        ),
        React.createElement('div', { className: 'clearfix' })
      );
    }
  }]);

  return PageAccessTypeaheadView;
}(React.Component);

module.exports = PageAccessSearchField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1262:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Base = __webpack_require__(257);
var request = __webpack_require__(258);

var PageAccess = function (_Base) {
  _inherits(PageAccess, _Base);

  function PageAccess(attributes) {
    _classCallCheck(this, PageAccess);

    return _possibleConstructorReturn(this, (PageAccess.__proto__ || Object.getPrototypeOf(PageAccess)).call(this, attributes));
  }

  _createClass(PageAccess, [{
    key: 'isUser',
    value: function isUser() {
      return !!this.email;
    }
  }], [{
    key: 'searchRoute',
    value: function searchRoute(options) {
      if (!options.page_id) throw new Error('You must provide a page_id');
      return Routes.access_control_search_page_url({ id: options.page_id }, { domain: null, subdomain: null });
    }
  }, {
    key: 'search',
    value: function search(queryOptions) {
      var url = void 0;
      if (queryOptions.url) {
        url = queryOptions.url;
      } else {
        url = PageAccess.searchRoute({ page_id: queryOptions.page_id });
      }

      return request.get({
        url: url,
        data: { q: queryOptions.query }
      }).then(function (response) {
        var results = response;
        return results.map(function (result) {
          var pa = new PageAccess(result);
          return pa;
        });
      });
    }
  }]);

  return PageAccess;
}(Base);

module.exports = PageAccess;

/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _inflection = __webpack_require__(141);

var _inflection2 = _interopRequireDefault(_inflection);

var _confirm = __webpack_require__(84);

var _confirm2 = _interopRequireDefault(_confirm);

var _textarea = __webpack_require__(198);

var _textarea2 = _interopRequireDefault(_textarea);

var _update_billing_subscription_modal = __webpack_require__(655);

var _update_billing_subscription_modal2 = _interopRequireDefault(_update_billing_subscription_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactDOM = __webpack_require__(26);

var Subscription = function (_React$Component) {
  _inherits(Subscription, _React$Component);

  /**
   * General subscription management and updating for pages
   * @params props
   * @params props.page
   * @params props.coupons
   * @params props.plans
   * @params props.types
   */
  function Subscription(props) {
    _classCallCheck(this, Subscription);

    var _this = _possibleConstructorReturn(this, (Subscription.__proto__ || Object.getPrototypeOf(Subscription)).call(this, props));

    _this.state = { cancelError: null };
    return _this;
  }

  _createClass(Subscription, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      $(ReactDOM.findDOMNode(this)).find('#btn-confirm-cancel-subscription').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        _this2.onCancel().then(function () {
          $(ReactDOM.findDOMNode(_this2)).find('#modal-confirmation-cancel-subscription').modal('hide');
          window.location.reload();
        }).catch(function (error) {
          _this2.setState({ cancelError: error });
        });
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      $(ReactDOM.findDOMNode(this)).find('#modal-confirmation-cancel-subscription').modal();
    }
  }, {
    key: 'update',
    value: function update() {
      $(ReactDOM.findDOMNode(this)).find('#sub-' + this.props.page.billing_subscription.id).modal();
    }
  }, {
    key: 'onCancel',
    value: function onCancel() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var reason = $('textarea[name="reason"]').val().trim();
        if (!reason) {
          reject('You must provide a reason for cancelling');
        } else {
          $.ajax({
            type: 'DELETE',
            url: Routes.page_admin_cancel_billing_subscription_path(_this3.props.page.id, { format: 'json' }),
            data: { reason: reason },
            success: resolve,
            error: function error(errors) {
              reject(JSON.parse(errors.responseText).errors[0]);
            }
          });
        }
      });
    }
  }, {
    key: 'cancelError',
    value: function cancelError() {
      if (this.state.cancelError) {
        return _react2.default.createElement(
          'span',
          { className: 'error', style: { color: 'indianred' } },
          this.state.cancelError
        );
      }
    }
  }, {
    key: 'cancelElement',
    value: function cancelElement() {
      if (this.props.cancelable && !this.props.page.billing_subscription.canceled) {
        return _react2.default.createElement(
          'a',
          { href: '#', onClick: this.cancel.bind(this) },
          _react2.default.createElement(
            'small',
            null,
            'cancel'
          )
        );
      } else {
        return _react2.default.createElement(
          'span',
          { style: { color: '#EFEFEF', cursor: 'default' } },
          '\u263A'
        );
      }
    }
  }, {
    key: 'canceled',
    value: function canceled() {
      if (this.props.page.billing_subscription.canceled) {
        return _react2.default.createElement(
          'small',
          null,
          ' (canceled)'
        );
      }
    }
  }, {
    key: 'quantity',
    value: function quantity() {
      if (this.props.page.billing_subscription.quantity > 1) {
        return _react2.default.createElement(
          'span',
          null,
          ' x ',
          this.props.page.billing_subscription.quantity
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var subscription = this.props.page.billing_subscription;
      var coupon = _.find(this.props.coupons, { id: subscription.coupon });
      return _react2.default.createElement(
        'div',
        { className: 'section row overview' },
        _react2.default.createElement('hr', { className: 'span12' }),
        _react2.default.createElement(
          'div',
          { className: 'header span3' },
          'Subscription'
        ),
        _react2.default.createElement(
          'div',
          { className: 'span9' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'span2' },
              _react2.default.createElement(
                'h6',
                null,
                'Type'
              ),
              subscription.type.replace('BillingSubscription', ''),
              this.canceled()
            ),
            _react2.default.createElement(
              'div',
              { className: 'span2' },
              _react2.default.createElement(
                'h6',
                null,
                'Plan'
              ),
              _inflection2.default.titleize(subscription.plan_name),
              ' ',
              this.quantity()
            ),
            _react2.default.createElement(
              'div',
              { className: 'span2' },
              _react2.default.createElement(
                'h6',
                null,
                'Discount'
              ),
              _inflection2.default.titleize(coupon ? coupon.display : 'None')
            ),
            _react2.default.createElement(
              'div',
              { className: 'span2' },
              _react2.default.createElement(
                'h6',
                null,
                'Note'
              ),
              _inflection2.default.titleize(subscription.note || 'None')
            ),
            _react2.default.createElement(
              'div',
              { className: 'span2' },
              _react2.default.createElement(
                'h6',
                null,
                _react2.default.createElement(
                  'a',
                  { href: '#', onClick: this.update.bind(this) },
                  'Update ',
                  _react2.default.createElement('i', { className: 'fa fa-subway' })
                )
              ),
              this.cancelElement()
            )
          )
        ),
        _react2.default.createElement(_update_billing_subscription_modal2.default, {
          types: this.props.types,
          plans: this.props.plans,
          coupons: this.props.coupons,
          page: this.props.page,
          id: 'sub-' + this.props.page.billing_subscription.id }),
        _react2.default.createElement(
          _confirm2.default,
          { id: 'cancel-subscription',
            title: 'Cancel subscription',
            onConfirm: this.onCancel.bind(this),
            confirm_text: 'Yes, cancel it' },
          _react2.default.createElement(
            'div',
            { style: { padding: '1rem 2rem' } },
            _react2.default.createElement(_textarea2.default, { name: 'reason', label: 'Are you sure?  Why?' }),
            this.cancelError()
          )
        )
      );
    }
  }]);

  return Subscription;
}(_react2.default.Component);

module.exports = Subscription;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(20);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(3);

var _moment2 = _interopRequireDefault(_moment);

var _tab_group = __webpack_require__(1265);

var _tab_group2 = _interopRequireDefault(_tab_group);

var _tab_header = __webpack_require__(659);

var _tab_header2 = _interopRequireDefault(_tab_header);

var _tab_headers = __webpack_require__(658);

var _tab_headers2 = _interopRequireDefault(_tab_headers);

var _tab_panel = __webpack_require__(657);

var _tab_panel2 = _interopRequireDefault(_tab_panel);

var _tab_panels = __webpack_require__(656);

var _tab_panels2 = _interopRequireDefault(_tab_panels);

var _notifications = __webpack_require__(362);

var _notifications2 = _interopRequireDefault(_notifications);

var _subscriber_counts = __webpack_require__(1266);

var _subscriber_counts2 = _interopRequireDefault(_subscriber_counts);

var _notifications_subscriber_type_manager = __webpack_require__(1267);

var _notifications_subscriber_type_manager2 = _interopRequireDefault(_notifications_subscriber_type_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *  The interface to browse and search lists of email, sms, and web subscribers.
 */
var NotificationsSubscriberManager = function (_Component) {
  _inherits(NotificationsSubscriberManager, _Component);

  function NotificationsSubscriberManager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotificationsSubscriberManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationsSubscriberManager.__proto__ || Object.getPrototypeOf(NotificationsSubscriberManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      updatedAt: (0, _moment2.default)().format()
    }, _this._touch = function () {
      _this.setState({ updatedAt: (0, _moment2.default)().format() });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotificationsSubscriberManager, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var beginningOfPastMonthTimestamp = (0, _moment2.default)().subtract(1, 'month').startOf('day').format();
      return (
        // These components wrap network requests, allowing us to leverage the prop system to only make network requests when the parameters change
        _react2.default.createElement(
          _subscriber_counts2.default,
          { pageCode: this.props.pageCode, updatedAt: this.state.updatedAt },
          function (allTimeHistogram) {
            return (

              // Note that in spite of this being nested, its network request is independent of the results of the outer SubscriberCounts call.
              _react2.default.createElement(
                _subscriber_counts2.default,
                {
                  pageCode: _this2.props.pageCode,
                  since: beginningOfPastMonthTimestamp,
                  updatedAt: _this2.state.updatedAt },
                function (thisMonthHistogram) {
                  return _react2.default.createElement(
                    _tab_group2.default,
                    { 'default': 'email',
                      onChange: function onChange(deliveryType) {
                        return analytics.track('Notifications Page - Clicked Tab', { deliveryType: deliveryType, source: 'Notifications Page' });
                      } },
                    _react2.default.createElement(
                      _tab_headers2.default,
                      null,
                      _notifications2.default.NOTIFICATION_TYPES.map(function (type) {
                        var countText = allTimeHistogram[type] ? ' (' + allTimeHistogram[type].total + ')' : '';
                        var label = '' + _notifications2.default.SUBSCRIBER_TITLE_DISPLAY_TYPE_BY_TYPE[type] + countText;
                        return _react2.default.createElement(
                          _tab_header2.default,
                          { key: type, name: type, className: (0, _classnames2.default)(_this2.props.enabledNotificationTypes[type] ? null : 'disabled') },
                          label
                        );
                      })
                    ),
                    _react2.default.createElement(
                      _tab_panels2.default,
                      null,
                      _notifications2.default.NOTIFICATION_TYPES.map(function (type) {
                        var enabled = _this2.props.enabledNotificationTypes[type];
                        var requiresAdvancedNotifications = _this2.props.requiresAdvancedNotifications[type];
                        var displayUpgradeForNotificationTypeMessage = !enabled && requiresAdvancedNotifications;
                        var typeTitle = _notifications2.default.SUBSCRIBER_TITLE_DISPLAY_TYPE_BY_TYPE[type];
                        var typeNoun = _notifications2.default.SUBSCRIBER_SENTENCE_DISPLAY_TYPE_BY_TYPE[type];
                        var settingsModalLink = _react2.default.createElement(
                          'a',
                          {
                            href: '#modal-settings',
                            'data-toggle': 'modal',
                            onClick: function onClick() {
                              return analytics.track('Notifications Page - Settings Modal Clicked', { source: 'Notifications Page' });
                            } },
                          'reactivate ',
                          typeNoun,
                          ' notifications now'
                        );
                        var disabledAlertBox = null;
                        if (displayUpgradeForNotificationTypeMessage) {
                          disabledAlertBox = _react2.default.createElement(
                            'div',
                            { className: 'disable-notification-type-warning' },
                            _react2.default.createElement(
                              'div',
                              { className: 'header' },
                              typeTitle,
                              ' notifications are not available for your plan.'
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'body' },
                              'To deliver notification through ',
                              typeNoun,
                              ', upgrade your plan.'
                            )
                          );
                        } else if (!enabled) {
                          disabledAlertBox = _react2.default.createElement(
                            'div',
                            { className: 'disable-notification-type-warning' },
                            _react2.default.createElement(
                              'div',
                              { className: 'header' },
                              typeTitle,
                              ' notifications are disabled.'
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'body' },
                              'To deliver notification through ',
                              typeNoun,
                              ', ',
                              settingsModalLink,
                              '.'
                            )
                          );
                        }
                        return _react2.default.createElement(
                          _tab_panel2.default,
                          { 'for': type, key: type },
                          disabledAlertBox,
                          _react2.default.createElement(_notifications_subscriber_type_manager2.default, {
                            allTimeHistogram: allTimeHistogram,
                            thisMonthHistogram: thisMonthHistogram,
                            pageCode: _this2.props.pageCode,
                            limit: _this2.props.limit,
                            type: type,
                            updatedAt: _this2.state.updatedAt,
                            touch: _this2._touch })
                        );
                      })
                    )
                  );
                }
              )
            );
          }
        )
      );
    }
  }]);

  return NotificationsSubscriberManager;
}(_react.Component);

NotificationsSubscriberManager.propTypes = {
  pageCode: _propTypes2.default.string.isRequired, // The code of the page whose subscribers to list.
  limit: _propTypes2.default.number.isRequired,
  enabledNotificationTypes: _propTypes2.default.shape({
    email: _propTypes2.default.bool.isRequired,
    sms: _propTypes2.default.bool.isRequired,
    webhook: _propTypes2.default.bool.isRequired
  }).isRequired,
  requiresAdvancedNotifications: _propTypes2.default.shape({
    email: _propTypes2.default.bool.isRequired,
    sms: _propTypes2.default.bool.isRequired,
    webhook: _propTypes2.default.bool.isRequired
  }).isRequired
};
exports.default = NotificationsSubscriberManager;


module.exports = NotificationsSubscriberManager;

/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(20);

var _classnames2 = _interopRequireDefault(_classnames);

var _tab_panels = __webpack_require__(656);

var _tab_panels2 = _interopRequireDefault(_tab_panels);

var _tab_headers = __webpack_require__(658);

var _tab_headers2 = _interopRequireDefault(_tab_headers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TabGroup: A tab widget matching views with tabs.
//
// TabGroup is designed to use React declarative style in a more idiomatic way than TabNavigationBar,
// our other tab widget, and may eventually replace it.
//
// Usage:
//
//   <TabGroup default="first">
//     <TabHeaders>
//       <TabHeader name="first">First Tab</TabHeader>
//       <TabHeader name="second">Second Tab</TabHeader>
//       <TabHeader name="third">Third Tab</TabHeader>
//     </TabHeaders>
//     <TabPanels>
//       <TabPanel for="first"><div>I am the first tab content.</div></TabPanel>
//       <TabPanel for="second"><div>I am the second tab content.</div></TabPanel>
//       <TabPanel for="third"><div>I am the third tab content.</div></TabPanel>
//     </TabPanels>
//   </TabGroup>

var TabGroup = function (_React$Component) {
  _inherits(TabGroup, _React$Component);

  function TabGroup() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TabGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabGroup.__proto__ || Object.getPrototypeOf(TabGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeName: _this.props.default
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TabGroup, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var children = _react2.default.Children.map(this.props.children, function (child) {
        if (child.type === _tab_panels2.default) {
          return _react2.default.cloneElement(child, {
            activeName: _this2.state.activeName
          });
        }
        if (child.type === _tab_headers2.default) {
          return _react2.default.cloneElement(child, {
            activeName: _this2.state.activeName,
            onActivate: function onActivate(activeName) {
              _this2.setState({ activeName: activeName });
              _this2.props.onChange(activeName);
            }
          });
        }
        return child;
      });

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('tab-group', this.props.className) },
        children
      );
    }
  }]);

  return TabGroup;
}(_react2.default.Component);

TabGroup.propTypes = {
  // Index of the active TabHeader.
  default: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.arrayOf(_propTypes2.default.shape({ type: _propTypes2.default.oneOf([_tab_headers2.default, _tab_panels2.default]) })).isRequired,
  className: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};
TabGroup.defaultProps = {
  className: '',
  onChange: function onChange(_) {}
};
exports.default = TabGroup;

/***/ }),

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cpt_alert_box = __webpack_require__(660);

var _cpt_alert_box2 = _interopRequireDefault(_cpt_alert_box);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _subscriber = __webpack_require__(199);

var _subscriber2 = _interopRequireDefault(_subscriber);

var _sentry_reporter = __webpack_require__(298);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubscriberCounts = function (_React$Component) {
  _inherits(SubscriberCounts, _React$Component);

  function SubscriberCounts() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SubscriberCounts);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubscriberCounts.__proto__ || Object.getPrototypeOf(SubscriberCounts)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      request: null, // expected type of PropTypes.shape({pageCode: PropTypes.string, since: PropTypes.string })
      error: null, // expected type of PropTypes.string
      histogram: {}
    }, _this.fetchCounts = function (props) {
      var request = _this.props.since === null ? { pageCode: props.pageCode } : { pageCode: props.pageCode, since: props.since };
      _subscriber2.default.getHistogramByState(request).then(function (histogram) {
        if (_this.mounted) {
          _this.setState(function (prevState) {
            // Only update the state if the request in `state` is the request on which this function closes.
            if (prevState.request === request) {
              return { histogram: histogram };
            }
            return {};
          });
        }
      }).catch(function (e) {
        (0, _sentry_reporter.reportError)(e, {});
        if (_this.mounted) {
          _this.setState(function (prevState) {
            // Same here: only update state if this request was the last request requested.
            if (prevState.request === request) {
              return { error: 'Failed to load subscriber counts. Please try again in a few minutes.', request: null };
            }
            return {};
          });
        }
      });

      // Set the error and request here to mark which request was last requested by the user.
      _this.setState({
        error: null,
        request: request
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SubscriberCounts, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.mounted = true;
      this.fetchCounts(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (this.props.pageCode !== props.pageCode || this.props.since !== props.since || this.props.updatedAt !== props.updatedAt) {
        this.fetchCounts(props);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // make sure we don't try to call setState on an unmounted component
      this.mounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.error) {
        return _react2.default.createElement(_cpt_alert_box2.default, {
          type: 'error',
          header: 'An error occurred while trying to fulfill your request.',
          body: this.state.error });
      }
      return this.props.children(this.state.histogram);
    }
  }]);

  return SubscriberCounts;
}(_react2.default.Component);

SubscriberCounts.propTypes = {
  pageCode: _propTypes2.default.string.isRequired,
  since: _propTypes2.default.string,
  children: _propTypes2.default.func.isRequired,
  updatedAt: _propTypes2.default.string.isRequired
};
SubscriberCounts.defaultProps = {
  since: null
};
exports.default = SubscriberCounts;

/***/ }),

/***/ 1267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(20);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _cpt_alert_box = __webpack_require__(660);

var _cpt_alert_box2 = _interopRequireDefault(_cpt_alert_box);

var _checked_list = __webpack_require__(1268);

var _checked_list2 = _interopRequireDefault(_checked_list);

var _notifications = __webpack_require__(362);

var _notifications2 = _interopRequireDefault(_notifications);

var _pagination_control = __webpack_require__(1270);

var _pagination_control2 = _interopRequireDefault(_pagination_control);

var _pill = __webpack_require__(661);

var _pill2 = _interopRequireDefault(_pill);

var _pill_group = __webpack_require__(1271);

var _pill_group2 = _interopRequireDefault(_pill_group);

var _sortable_list = __webpack_require__(1272);

var _confirm = __webpack_require__(84);

var _confirm2 = _interopRequireDefault(_confirm);

var _types = __webpack_require__(1273);

var _notifications_subscriber_row = __webpack_require__(1274);

var _notifications_subscriber_row2 = _interopRequireDefault(_notifications_subscriber_row);

var _subscriber_action = __webpack_require__(662);

var _subscriber_action2 = _interopRequireDefault(_subscriber_action);

var _subscriber_query = __webpack_require__(1275);

var _subscriber_query2 = _interopRequireDefault(_subscriber_query);

var _inflection = __webpack_require__(141);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @constant {Array} The list of subscribers states of which the front-end is aware.
 */
var SUBSCRIBER_STATES = ['active', 'quarantined', 'unconfirmed'];

/**
 *  The interface to browse and search lists of email, sms, and web subscribers.
 */

var NotificationsSubscriberTypeManager = function (_Component) {
  _inherits(NotificationsSubscriberTypeManager, _Component);

  function NotificationsSubscriberTypeManager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotificationsSubscriberTypeManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationsSubscriberTypeManager.__proto__ || Object.getPrototypeOf(NotificationsSubscriberTypeManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      subscriberState: 'active',
      sortField: 'primary',
      sortDirection: 'asc',
      total: 0,
      page: 0,
      selection: _checked_list.SelectionState.clear(),
      confirmationModal: null
    }, _this._handleClearSelection = function (shouldTrack) {
      if (shouldTrack) {
        analytics.track('Notifications Page - Clear Selection', {
          source: 'Notifications Page',
          state: _this.state.subscriberState,
          type: _this.props.type
        });
      }
      _this.setState({ selection: _checked_list.SelectionState.clear() });
    }, _this._handleSelectAll = function () {
      analytics.track('Notifications Page - Select All', {
        source: 'Notifications Page',
        state: _this.state.subscriberState,
        type: _this.props.type
      });
      _this.setState({ selection: _checked_list.SelectionState.selectAll() });
    }, _this._removeSubscriber = function (e, subscriberCode, state) {
      e.preventDefault();

      var subscriberCodes = _this.state.selection.toJSON();
      if (Array.isArray(subscriberCode)) {
        subscriberCodes = subscriberCode;
      }

      var message = 'Are you sure you want to remove ' + (subscriberCodes.length === 1 ? 'this subscriber?' : 'these subscribers?');
      var params = {
        subscribers: subscriberCodes,
        type: _this.props.type,
        state: state
      };

      var confirmationModal = _react2.default.createElement(_confirm2.default, {
        id: 'remove-subscriber-' + _this.state.subscriberState,
        confirm_text: 'Confirm Removal',
        message: message,
        title: 'Confirm Remove Subscriber',
        confirmClass: 'style-status-critical',
        onConfirm: function onConfirm() {
          analytics.track('Notifications Page - Subscriber Unsubscribed', {
            source: 'Notifications Page',
            state: _this.state.subscriberState,
            type: _this.props.type,
            count: subscriberCodes === 'all' ? -1 : subscriberCodes.length
          });
          Subscriber.unsubscribeSubscribers(_this.props.pageCode, params).then(function () {
            HRB.utils.notify('Unsubscribe succeeded.');
            _this._handleClearSelection(false);
            _this.props.touch();
            _this.setState({ confirmationModal: null });
          }, function () {
            HRB.utils.notify('Unsubscribe failed.');
          });
        },
        onCancel: function onCancel() {
          return _this.setState({ confirmationModal: null });
        } });

      _this.setState({
        confirmationModal: confirmationModal
      });
    }, _this._reactivateSubscriber = function (e, subscriberCode) {
      e.preventDefault();

      var subscriberCodes = _this.state.selection.toJSON();
      if (Array.isArray(subscriberCode)) {
        subscriberCodes = subscriberCode;
      }

      var message = 'Are you sure you want to reactivate ' + (subscriberCodes.length === 1 ? 'this subscriber?' : 'these subscribers?');

      var confirmationModal = _react2.default.createElement(_confirm2.default, {
        id: 'reactivate-subscriber-' + _this.state.subscriberState,
        confirm_text: 'Confirm Reactivate',
        message: message,
        title: 'Confirm Reactivate Subscriber',
        onConfirm: function onConfirm() {
          analytics.track('Notifications Page - Subscriber Reactivated', {
            source: 'Notifications Page',
            state: _this.state.subscriberState,
            type: _this.props.type,
            count: subscriberCodes === 'all' ? -1 : subscriberCodes.length
          });
          Subscriber.reactivateSubscribers(_this.props.pageCode, { subscribers: subscriberCodes }).then(function () {
            HRB.utils.notify('Reactivate succeeded.');
            _this._handleClearSelection(false);
            _this.props.touch();
            _this.setState({ confirmationModal: null });
          }, function () {
            HRB.utils.notify('Reactivate failed.');
          });
        },
        onCancel: function onCancel() {
          return _this.setState({ confirmationModal: null });
        } });

      _this.setState({
        confirmationModal: confirmationModal
      });
    }, _this._resendConfirmationSubscriber = function (e, subscriberCode) {
      e.preventDefault();

      var subscriberCodes = _this.state.selection.toJSON();
      if (Array.isArray(subscriberCode)) {
        subscriberCodes = subscriberCode;
      }

      var message = 'Are you sure you want to resend a confirmation message to ' + (subscriberCodes.length === 1 ? 'this subscriber?' : 'these subscribers?');

      var successMessage = 'The confirmation email was successfully sent to the ' + (0, _inflection.inflect)('subscriber', subscriberCodes.length);

      var confirmationModal = _react2.default.createElement(_confirm2.default, {
        id: 'resend-confirmation-subscriber-' + _this.state.subscriberState,
        confirm_text: 'Confirm Resend',
        message: message,
        title: 'Confirm Resend Confirmation',
        onConfirm: function onConfirm() {
          Subscriber.resendConfirmationSubscribers(_this.props.pageCode, subscriberCodes).then(function () {
            analytics.track('Notifications Page - Subscriber Confirmation Resent', {
              source: 'Notifications Page',
              state: _this.state.subscriberState, // Should always be 'unconfirmed'.
              type: _this.props.type, // Should always be 'email'.
              count: subscriberCodes === 'all' ? -1 : subscriberCodes.length
            });
            HRB.utils.notify(successMessage);
            _this._handleClearSelection(false);
            _this.setState({ confirmationModal: null });
          }, function () {
            HRB.utils.notify('Resend confirmation failed.');
          });
        },
        onCancel: function onCancel() {
          return _this.setState({ confirmationModal: null });
        } });

      _this.setState({
        confirmationModal: confirmationModal
      });
    }, _this._changedSelectedState = function (state) {
      analytics.track('Notifications Page - Change Subscriber State Filter', {
        source: 'Notifications Page',
        state: state,
        type: _this.props.type
      });
      _this.setState({ subscriberState: state, page: 0, selection: _checked_list.SelectionState.clear() });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotificationsSubscriberTypeManager, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_, oldState) {
      if (this.state.confirmationModal && oldState.confirmationModal !== this.state.confirmationModal) {
        (0, _jquery2.default)('#modal-confirmation-' + this.state.confirmationModal.props.id).modal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Compute the relevant histogram data.
      var allTimeTotal = this.props.allTimeHistogram[this.props.type] && this.props.allTimeHistogram[this.props.type].total;
      var addedThisMonth = this.props.thisMonthHistogram[this.props.type] && this.props.thisMonthHistogram[this.props.type].total;

      // Fetch the total for pagination purposes for this subscriber state.
      var paginationTotal = this.props.allTimeHistogram[this.props.type] && this.props.allTimeHistogram[this.props.type][this.state.subscriberState];

      var emptySubscriberType = allTimeTotal === 0;
      var emptySubscriberTypeInState = paginationTotal === 0;

      // The total label in the upper left of the tab pane.
      var pluralizedSubscribers = (0, _inflection.inflect)('subscriber', allTimeTotal);
      var subscriberCountLabel = allTimeTotal !== undefined && addedThisMonth !== undefined ? _react2.default.createElement(
        'div',
        { className: 'total-and-recent-subscriber-count' },
        'Total ',
        allTimeTotal,
        ' ',
        _notifications2.default.SUBSCRIBER_SENTENCE_DISPLAY_TYPE_BY_TYPE[this.props.type],
        ' ',
        pluralizedSubscribers,
        ', ',
        addedThisMonth,
        ' added this month.'
      ) : _react2.default.createElement('div', { className: 'total-and-recent-subscriber-count' });

      // Here are the state pills at the top right of the tab pane.
      // Not all types have all states; we should generate them dynamically.
      var activePillCountString = this.props.allTimeHistogram[this.props.type] ? ' (' + this.props.allTimeHistogram[this.props.type].active + ')' : '';
      var unconfirmedPillCountString = this.props.allTimeHistogram[this.props.type] ? ' (' + this.props.allTimeHistogram[this.props.type].unconfirmed + ')' : '';
      var quarantinedPillCountString = this.props.allTimeHistogram[this.props.type] ? ' (' + this.props.allTimeHistogram[this.props.type].quarantined + ')' : '';
      var unconfirmedFilterState = this.props.type === 'email' ? _react2.default.createElement(
        _pill2.default,
        { className: 'red', value: 'unconfirmed' },
        'Unconfirmed',
        unconfirmedPillCountString
      ) : null;

      // Column headers.
      // Though we rely heavily on flex, we give base widths for columns.
      var createdAtHeaderSize = this.state.subscriberState === 'quarantined' ? 'created-at-small' : 'created-at-large';

      // Quarantine is only shown in the "quarantine" state.
      var quarantineHeader = this.state.subscriberState === 'quarantined' ? _react2.default.createElement(
        _sortable_list.SortableListHeader,
        { className: 'quarantined-at', field: 'quarantined_at', key: 'quarantined_at', tooltip: 'When a subscriber has not been reactivated in 90 days of quarantine, they will be automatically unsubscribed.' },
        'Date Quarantined',
        _react2.default.createElement(
          'span',
          { className: 'tooltip-base' },
          '?'
        )
      ) : null;

      var actionsHeaderSize = this.state.subscriberState === 'unconfirmed' ? 'actions-large' : 'actions-small';

      // Links to other subscriber states that are not empty.
      var otherStatesLinks = emptySubscriberTypeInState ? SUBSCRIBER_STATES.filter(function (ss) {
        return ss !== _this2.state.subscriberState && _this2.props.allTimeHistogram[_this2.props.type] && _this2.props.allTimeHistogram[_this2.props.type][ss];
      }).map(function (ss) {
        return _react2.default.createElement(
          'button',
          { type: 'button', className: 'other-subscriber-states-btn', key: ss, onClick: function onClick() {
              return _this2._changedSelectedState(ss);
            } },
          ss
        );
      }) : [];
      var otherStatesMessage = otherStatesLinks.length ? _react2.default.createElement(
        'span',
        null,
        'Check ',
        otherStatesLinks.reduce(function (prev, curr) {
          return [prev, ' or ', curr];
        }),
        ' subscribers.'
      ) : null;

      // These are actions suitable for the header.
      var selectedCount = this.state.selection.allSelected ? paginationTotal : this.state.selection.selectedSet.size;
      var selectedLabel = selectedCount === 0 ? null : _react2.default.createElement(
        'span',
        { className: 'subtle' },
        ' (',
        selectedCount,
        ')'
      );
      var actions = [_react2.default.createElement(
        _subscriber_action2.default,
        {
          className: 'remove',
          key: 'remove',
          onClick: this._removeSubscriber,
          subscriberState: this.state.subscriberState },
        'remove',
        selectedLabel
      )];
      if (this.state.subscriberState === 'quarantined') {
        actions = Array.concat(actions, _react2.default.createElement(
          _subscriber_action2.default,
          {
            className: 'reactivate',
            key: 'reactivate',
            onClick: this._reactivateSubscriber,
            subscriberState: this.state.subscriberState },
          'reactivate',
          selectedLabel
        ));
      }
      if (this.state.subscriberState === 'unconfirmed') {
        actions = Array.concat(actions, _react2.default.createElement(
          _subscriber_action2.default,
          {
            className: 'resend-confirmation',
            key: 'resend-confirmation',
            onClick: this._resendConfirmationSubscriber,
            subscriberState: this.state.subscriberState },
          'resend confirmation',
          selectedLabel
        ));
      }

      return _react2.default.createElement(
        'div',
        { className: 'notifications-subscriber-type-manager' },
        this.state.confirmationModal,
        emptySubscriberType ? null : _react2.default.createElement(
          'div',
          { className: 'pane-heading' },
          subscriberCountLabel,
          _react2.default.createElement(
            _pill_group2.default,
            {
              className: 'pull-right colored-filters',
              onChange: this._changedSelectedState,
              value: this.state.subscriberState },
            _react2.default.createElement(
              _pill2.default,
              { className: 'green', value: 'active' },
              'Active',
              activePillCountString
            ),
            _react2.default.createElement(
              _pill2.default,
              { className: 'red', value: 'quarantined' },
              'Quarantined',
              quarantinedPillCountString
            ),
            unconfirmedFilterState
          )
        ),
        _react2.default.createElement(
          _subscriber_query2.default,
          {
            pageCode: this.props.pageCode,
            limit: this.props.limit,
            page: this.state.page,
            sortField: this.state.sortField,
            sortDirection: this.state.sortDirection,
            subscriberType: this.props.type,
            subscriberState: this.state.subscriberState,
            updatedAt: this.props.updatedAt },
          function (subscribers, loading, error) {
            var subscriberTypeQualifier = emptySubscriberType ? '' : _this2.state.subscriberState;
            var emptyListState = subscribers.length !== 0 ? null : _react2.default.createElement(
              'div',
              { className: 'pane-header' },
              _react2.default.createElement(
                'div',
                { className: 'empty-state' },
                _react2.default.createElement(
                  'div',
                  { className: 'header' },
                  'You currently don\'t have any ',
                  subscriberTypeQualifier,
                  ' ',
                  _notifications2.default.SUBSCRIBER_SENTENCE_DISPLAY_TYPE_BY_TYPE[_this2.props.type],
                  ' subscribers.'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'body' },
                  _react2.default.createElement(
                    'span',
                    null,
                    otherStatesMessage
                  )
                )
              )
            );

            // Construct the state for displaying any errors that occur inside the query component.
            var errorState = error ? _react2.default.createElement(_cpt_alert_box2.default, {
              type: 'error',
              header: 'An error occurred while trying to fulfill your request.',
              body: error }) : null;

            // Construct the list contents.
            var subscriberRows = subscribers.map(function (subscriber) {
              return _react2.default.createElement(
                _notifications_subscriber_row2.default,
                {
                  subscriber: subscriber,
                  pageCode: _this2.props.pageCode,
                  key: subscriber.id,
                  state: _this2.state.subscriberState,
                  href: '/pages/' + _this2.props.pageCode + '/subscribers/' + subscriber.id },
                _this2.state.selection.isClear() ? actions : null
              );
            });

            // And the headers.
            var headers = null;
            // If nothing is selected, the table header displays as column headers.
            if (_this2.state.selection.isClear()) {
              headers = [_react2.default.createElement(
                _sortable_list.SortableListHeader,
                { className: 'subscriber-title', field: 'primary', key: 'primary' },
                _react2.default.createElement(
                  'span',
                  null,
                  _notifications2.default.SUBSCRIBER_TITLE_DISPLAY_TYPE_BY_TYPE[_this2.props.type],
                  ' Subscribers'
                )
              ), _react2.default.createElement(
                _sortable_list.SortableListHeader,
                {
                  className: (0, _classnames2.default)("created-at", createdAtHeaderSize),
                  field: 'created_at',
                  key: 'created_at' },
                'Date Added'
              ), quarantineHeader, _react2.default.createElement(
                _sortable_list.SortableListHeader,
                {
                  className: (0, _classnames2.default)('actions', actionsHeaderSize, _this2.state.selection.isClear() ? null : 'actions'),
                  key: 'actions' },
                _this2.state.selection.isClear() ? 'Actions' : actions
              )];
            } else {
              // If something is selected, the table header displays information and actions available
              // for the selected subscribers.
              //
              // 'All Are Selected' may be encoded in two different ways:
              // 1) by the symbolic selection state "all"
              // 2) by a list of <page size> selected ids when <page size> === paginationTotal.
              // allChecked is true for both of these cases, otherwise false.
              var allChecked = selectedCount === paginationTotal;
              var selectAllHeader = allChecked ? _react2.default.createElement(
                'div',
                { className: 'select-all-prompt', key: 'select-all-prompt' },
                'All ',
                selectedCount,
                ' subscribers are selected. ',
                _react2.default.createElement(
                  'button',
                  { className: 'link-like', onClick: function onClick() {
                      return _this2._handleClearSelection(true);
                    } },
                  'Clear selection.'
                )
              ) : _react2.default.createElement(
                'div',
                { className: 'select-all-prompt', key: 'select-all-prompt' },
                _react2.default.createElement(
                  'span',
                  null,
                  selectedCount,
                  ' selected. '
                ),
                _react2.default.createElement(
                  'button',
                  { className: 'link-like', onClick: _this2._handleSelectAll },
                  'Select all ',
                  paginationTotal,
                  ' ',
                  _this2.state.subscriberState,
                  ' subscribers.'
                )
              );
              headers = [selectAllHeader, _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)("actions", actionsHeaderSize), key: 'bulk-actions' },
                actions
              )];
            }

            // Render the list itself, specifying selection state, headers, and content.
            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _checked_list2.default,
                {
                  selection: _this2.state.selection,
                  onSelect: function onSelect(selection) {
                    analytics.track('Notifications Page - Selected Subscribers', {
                      source: 'Notifications Page',
                      count: selection.getCount(),
                      state: _this2.state.subscriberState,
                      type: _this2.props.type
                    });
                    _this2.setState({ selection: selection });
                  },
                  total: paginationTotal || 0,
                  loading: loading,
                  error: errorState,
                  empty: emptyListState,
                  headers: _react2.default.createElement(
                    _sortable_list.SortableListHeaders,
                    {
                      field: _this2.state.sortField,
                      direction: _this2.state.sortDirection,
                      onClick: function onClick(sortField, sortDirection) {
                        analytics.track('Notifications Page - User Clicked Header', {
                          source: 'Notifications Page',
                          state: _this2.state.subscriberState,
                          type: _this2.props.type,
                          column: sortField,
                          direction: sortDirection
                        });
                        _this2.setState({
                          sortField: sortField,
                          sortDirection: sortDirection,
                          page: 0,
                          selection: _checked_list.SelectionState.clear()
                        });
                      } },
                    headers
                  ) },
                subscriberRows
              )
            );
          }
        ),
        paginationTotal === undefined || paginationTotal <= this.props.limit ? null : _react2.default.createElement(_pagination_control2.default, {
          page: this.state.page + 1,
          limit: this.props.limit,
          total: paginationTotal,
          onChange: function onChange(page) {
            analytics.track('Notifications Page - User Navigated To Page', {
              source: 'Notifications Page',
              state: _this2.state.subscriberState,
              type: _this2.props.type,
              page_number: page
            });
            _this2.setState({ page: page - 1 });
          } })
      );
    }
  }]);

  return NotificationsSubscriberTypeManager;
}(_react.Component);

NotificationsSubscriberTypeManager.propTypes = {
  pageCode: _propTypes2.default.string.isRequired, // The code of the page whose subscribers to list.
  limit: _propTypes2.default.number.isRequired, // The number of subscribers to display per-page.
  type: _propTypes2.default.oneOf(['email', 'sms', 'webhook']).isRequired,
  allTimeHistogram: _propTypes2.default.shape({
    email: _types.Histogram,
    sms: _types.Histogram,
    webhook: _types.Histogram
  }).isRequired,
  thisMonthHistogram: _propTypes2.default.shape({
    email: _types.Histogram,
    sms: _types.Histogram,
    webhook: _types.Histogram
  }).isRequired,
  touch: _propTypes2.default.func, // The function to call to indicate that the server should be re-queried.
  updatedAt: _propTypes2.default.string.isRequired
};
exports.default = NotificationsSubscriberTypeManager;


module.exports = NotificationsSubscriberTypeManager;

/***/ }),

/***/ 1268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectionState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _loading = __webpack_require__(625);

var _loading2 = _interopRequireDefault(_loading);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _tri_state_checkbox = __webpack_require__(1269);

var _tri_state_checkbox2 = _interopRequireDefault(_tri_state_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectionState = exports.SelectionState = function () {
  function SelectionState(allSelected, items) {
    var _this = this;

    _classCallCheck(this, SelectionState);

    this.isChecked = function (item) {
      return _this.allSelected || _this.selectedSet.has(item);
    };

    this.isClear = function () {
      return !_this.allSelected && _this.selectedSet.size === 0;
    };

    this.toJSON = function () {
      return _this.allSelected ? 'all' : [].concat(_toConsumableArray(_this.selectedSet));
    };

    this.getCount = function () {
      return _this.allSelected ? 'all' : _this.selectedSet.size;
    };

    this.selectedSet = new Set(items);
    this.allSelected = allSelected;
  }

  _createClass(SelectionState, null, [{
    key: 'clear',
    value: function clear() {
      return new SelectionState(false, []);
    }
  }, {
    key: 'selectAll',
    value: function selectAll() {
      return new SelectionState(true, []);
    }
  }, {
    key: 'selectExactly',
    value: function selectExactly(items) {
      return new SelectionState(false, items);
    }
  }]);

  return SelectionState;
}();

/**
 * This component displays a list: headers, content, and a checkbox next to every row. It also
 * implements the logic necessary to select either a subset of the current page, or "all", assuming
 * there are more pages.
 */


var CheckedList = function (_React$Component) {
  _inherits(CheckedList, _React$Component);

  function CheckedList() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, CheckedList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = CheckedList.__proto__ || Object.getPrototypeOf(CheckedList)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      keySet: new Set()
    }, _this2._handleBatchCheckbox = function () {
      var selectedKeySet = void 0;
      if (_this2.props.selection.selectedSet.size === 0 && !_this2.props.selection.allSelected) {
        selectedKeySet = new Set([].concat(_toConsumableArray(_this2.state.keySet)));
      } else {
        selectedKeySet = new Set([]);
      }
      _this2.props.onSelect(SelectionState.selectExactly(selectedKeySet));
    }, _this2._handleAnchorClick = function (e) {
      if (e.target.tagName == "INPUT") {
        // User actually clicked on a checkbox.
        // This is idiosyncratic Firefox behavior.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=62151
        e.preventDefault();
      }
    }, _this2._handleRowCheckbox = function (key) {
      // The setTimeout is a workaround for the Firefox checkbox workaround,
      // which causes React to not render the checkbox that was just clicked.
      // See: https://github.com/facebook/react/issues/3005
      window.setTimeout(function () {
        var selectedKeySet = void 0; // The working set of codes identifying selected rows.
        if (this.props.selection.allSelected) {
          // Visually, the "all" state is identical to all the visible rows selected.
          selectedKeySet = new Set([].concat(_toConsumableArray(this.state.keySet)));
        } else {
          selectedKeySet = new Set([].concat(_toConsumableArray(this.props.selection.selectedSet)));
        }

        // Update the row state itself from the computed visual display.
        if (selectedKeySet.has(key)) {
          selectedKeySet.delete(key);
        } else {
          selectedKeySet.add(key);
        }

        this.props.onSelect(SelectionState.selectExactly(selectedKeySet));
      }.bind(_this2), 0);
    }, _this2._countSelectionSize = function () {
      return _this2.props.selection.allSelected ? Number(_this2.props.total) : _this2.children.length;
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(CheckedList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.children !== this.props.children) {
        this.setState({
          keySet: new Set(props.children.map(function (child) {
            return child.key;
          }))
        });
      }
    }

    // Callback for clicking the batch checkbox.


    // Callback for clicking an individual row.


    // Callback for clicking an individual row checkbox.

  }, {
    key: '_batchCheckboxVisualState',


    /**
     * Helper function to determine visual state of batch checkbox:
     * @returns "unchecked" if no subscribers are selected, "indeterminate" if only some of the visible subscribers are
     *            checked, "checked" if either all the displayed subscribers are checked or "all" subscribers are checked,
     *            and "disabled" if the checkbox does not relate to the contents of the list.
     */
    value: function _batchCheckboxVisualState() {
      if (this.state.error || this.props.children.length === 0) {
        return 'disabled';
      }
      if (this.props.selection.allSelected || this.props.selection.selectedSet.size === this.props.children.length) {
        return 'checked';
      }
      if (this.props.selection.selectedSet.size > 0) {
        return 'indeterminate';
      }
      return 'unchecked';
    }
  }, {
    key: '_renderListContent',


    // Render everything below the header of the list--loading state, error state, empty state, or row display state.
    value: function _renderListContent() {
      var _this3 = this;

      var content = void 0;
      if (this.props.error) {
        content = this.props.error;
      } else if (this.props.empty) {
        content = this.props.empty;
      } else {
        var subscriberElements = _react2.default.Children.map(this.props.children, function (child) {
          return _react2.default.createElement(
            'a',
            {
              className: 'list-content-row',
              key: child.key,
              href: child.props.href ? child.props.href : '',
              onClick: function onClick(e) {
                return _this3._handleAnchorClick(e);
              } },
            _react2.default.createElement(
              'label',
              { className: 'checkbox-wrapper' },
              _react2.default.createElement('input', {
                type: 'checkbox',
                className: 'checked-list-checkbox list-content-row-checkbox',
                'data-list-item-code': child.key,
                onChange: function onChange() {
                  return _this3._handleRowCheckbox(child.key);
                },
                checked: _this3.props.selection.isChecked(child.key) })
            ),
            child
          );
        });
        content = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'table-rows-container' },
            subscriberElements
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'list-content' },
        _react2.default.createElement(_loading2.default, { className: 'loading-overlay', loading: this.props.loading }),
        content
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'checked-table' },
          this.props.empty ? null : _react2.default.createElement(
            'div',
            { className: 'list-header' },
            _react2.default.createElement(
              'label',
              { className: 'checkbox-wrapper' },
              _react2.default.createElement(_tri_state_checkbox2.default, {
                className: 'checked-list-checkbox list-header-checkbox',
                onChange: this._handleBatchCheckbox,
                mode: this._batchCheckboxVisualState() })
            ),
            this.props.headers
          ),
          this._renderListContent()
        )
      );
    }
  }]);

  return CheckedList;
}(_react2.default.Component);

CheckedList.propTypes = {
  // Total number of items, including those on this page.
  // Used to figure out when selecting subscriber not on the page is possible, i.e. "select all"
  // functionality.
  total: _propTypes2.default.number.isRequired,

  // The list content.
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.element]))]).isRequired,

  // Whether or not to display the content, or whether to show a "loading" icon. TODO: Move out of this component.
  loading: _propTypes2.default.bool,

  // The header row.
  headers: _propTypes2.default.element.isRequired,

  // An error to display instead of the list.
  // Populate this field if you e.g. have a connection error while populating the list children.
  error: _propTypes2.default.element,

  // What to display when the list is empty.
  empty: _propTypes2.default.element,

  // A callback when the selection state changes.
  // The sole argument is a SelectionState instance, indicating the new selection state as a
  // result of user input.
  onSelect: _propTypes2.default.func,

  selection: _propTypes2.default.instanceOf(SelectionState).isRequired
};
CheckedList.defaultProps = {
  loading: false,
  error: null,
  empty: null,
  onSelect: function onSelect() {}
};
exports.default = CheckedList;

/***/ }),

/***/ 1269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TriStateCheckbox = function (_Component) {
  _inherits(TriStateCheckbox, _Component);

  function TriStateCheckbox() {
    _classCallCheck(this, TriStateCheckbox);

    return _possibleConstructorReturn(this, (TriStateCheckbox.__proto__ || Object.getPrototypeOf(TriStateCheckbox)).apply(this, arguments));
  }

  _createClass(TriStateCheckbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._updateDOM();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.mode !== this.props.mode) {
        this._updateDOM();
      }
    }
  }, {
    key: '_updateDOM',
    value: function _updateDOM() {
      switch (this.props.mode) {
        case 'indeterminate':
          this._checkbox.indeterminate = true;
          this._checkbox.checked = false;
          break;
        case 'checked':
          this._checkbox.indeterminate = false;
          this._checkbox.checked = true;
          break;
        case 'unchecked':
        case 'disabled':
        default:
          this._checkbox.indeterminate = false;
          this._checkbox.checked = false;
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('input', {
        className: this.props.className,
        type: 'checkbox',
        ref: function ref(checkbox) {
          _this2._checkbox = checkbox;
        },
        onChange: this.props.onChange,
        disabled: this.props.mode === 'disabled'
      });
    }
  }]);

  return TriStateCheckbox;
}(_react.Component);

exports.default = TriStateCheckbox;


TriStateCheckbox.defaultProps = {
  onChange: function onChange() {},
  className: ''
};

TriStateCheckbox.propTypes = {
  mode: _propTypes2.default.oneOf(['checked', 'unchecked', 'indeterminate', 'disabled']).isRequired,
  onChange: _propTypes2.default.func, // A callback when the user clicks the checkbox.
  className: _propTypes2.default.string // The className is passed on to the wrapping element.
};

module.exports = TriStateCheckbox;

/***/ }),

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(20);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationControl = function (_Component) {
  _inherits(PaginationControl, _Component);

  function PaginationControl() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PaginationControl);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaginationControl.__proto__ || Object.getPrototypeOf(PaginationControl)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      manualEntry: _this.props.page
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PaginationControl, [{
    key: 'componentWillReceiveProps',


    // Update the text box if the prop changes.
    value: function componentWillReceiveProps(props) {
      this.setState({ manualEntry: props.page });
    }

    // An accessor for the total number of pages derived from props.

  }, {
    key: 'totalPages',
    value: function totalPages() {
      if (this.props.limit === 0) {
        return 0;
      }
      return Math.ceil(this.props.total / this.props.limit);
    }
  }, {
    key: 'prevButtonEnabled',
    value: function prevButtonEnabled() {
      return this.props.page !== 1;
    }
  }, {
    key: 'nextButtonEnabled',
    value: function nextButtonEnabled() {
      return this.props.page < this.totalPages();
    }

    // This intercepts an 'enter' keypress.
    // If the entered number is a valid page, notify the user of the component the page has changed.
    // If the entered numberis not a valid page, we go to the nearest valid page.
    // if the entered string is not a number, we reset the manual input to the current page.

  }, {
    key: 'handleManualEntryKeypress',
    value: function handleManualEntryKeypress(event) {
      if (event.key === 'Enter') {
        var page = Number(this.state.manualEntry);
        if (Number.isNaN(page)) {
          this.setState({ manualEntry: this.props.page });
        } else {
          if (page > this.totalPages()) {
            page = this.totalPages();
          }
          if (page < 1) {
            page = 1;
          }
          if (page !== this.props.page) {
            this.props.onChange(page);
          } else {
            this.setState({ manualEntry: page });
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'pagination-controls' },
        _react2.default.createElement(
          'button',
          {
            className: (0, _classnames2.default)(['pagination-button', this.prevButtonEnabled() ? 'active' : 'inactive']),
            onClick: this.prevButtonEnabled() ? function () {
              return _this2.props.onChange(_this2.props.page - 1);
            } : null },
          _react2.default.createElement('span', { className: 'fa fa-caret-left', 'aria-hidden': 'true' })
        ),
        '\xA0',
        _react2.default.createElement(
          'div',
          { className: 'manual-entry-label' },
          'Page',
          _react2.default.createElement('input', {
            type: 'text',
            className: 'manual-entry',
            value: this.state.manualEntry,
            onChange: function onChange(event) {
              return _this2.setState({ manualEntry: event.target.value });
            },
            onKeyPress: function onKeyPress(event) {
              return _this2.handleManualEntryKeypress(event);
            } }),
          '/ ',
          this.totalPages()
        ),
        _react2.default.createElement(
          'div',
          { className: 'subscriber-range-label' },
          'Subscriber No. ',
          (this.props.page - 1) * this.props.limit + 1,
          '\u2013',
          Math.min(this.props.page * this.props.limit, this.props.total)
        ),
        _react2.default.createElement(
          'button',
          {
            className: (0, _classnames2.default)(['pagination-button', this.nextButtonEnabled() ? 'active' : 'inactive']),
            onClick: this.nextButtonEnabled() ? function () {
              return _this2.props.onChange(_this2.props.page + 1);
            } : null },
          _react2.default.createElement('span', { className: 'fa fa-caret-right', 'aria-hidden': 'true' })
        )
      );
    }
  }]);

  return PaginationControl;
}(_react.Component);

PaginationControl.propTypes = {
  total: _propTypes2.default.number.isRequired,
  page: _propTypes2.default.number.isRequired,
  limit: _propTypes2.default.number.isRequired,
  onChange: _propTypes2.default.func
};
PaginationControl.defaultProps = {
  onChange: function onChange() {}
};
exports.default = PaginationControl;


module.exports = PaginationControl;

/***/ }),

/***/ 1271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(47);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(20);

var _classnames2 = _interopRequireDefault(_classnames);

var _pill = __webpack_require__(661);

var _pill2 = _interopRequireDefault(_pill);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A group of pill controls. See PropTypes below class definition for documentation on accepted props.
 */
var PillGroup = function (_Component) {
  _inherits(PillGroup, _Component);

  function PillGroup() {
    _classCallCheck(this, PillGroup);

    return _possibleConstructorReturn(this, (PillGroup.__proto__ || Object.getPrototypeOf(PillGroup)).apply(this, arguments));
  }

  _createClass(PillGroup, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var children = _lodash2.default.map(this.props.children, function (child, index) {
        return child && child.type === _pill2.default ? _react2.default.cloneElement(child, {
          onClick: function onClick(value) {
            return _this2.props.onChange(value);
          },
          active: child.props.value === _this2.props.value,
          key: index
        }) : child;
      });
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('cpt-pill-group', this.props.className) },
        children
      );
    }
  }]);

  return PillGroup;
}(_react.Component);

PillGroup.propTypes = {
  /** @callback {PillChangedCallback} onChange - called when a pill has been clicked with the clicked value. */
  onChange: _propTypes2.default.func.isRequired,
  /** The value of the pill */
  value: _propTypes2.default.string.isRequired,
  /** The pill definitions themselves, and any other dom element. */
  children: _propTypes2.default.arrayOf(_propTypes2.default.element).isRequired,
  className: _propTypes2.default.string
};
PillGroup.defaultProps = {
  className: ''
};
exports.default = PillGroup;


module.exports = PillGroup;

/***/ }),

/***/ 1272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortableListHeaders = exports.SortableListHeader = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(20);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CARET_TYPE_BY_DIRECTION = {
  none: 'fa-unsorted',
  asc: 'fa-sort-asc',
  desc: 'fa-sort-desc'
};

// This is a single column header.
// It is sortable/clickable if you specify a 'field' parameter on the header.
// If not, it's just text.
// If `field` is specified, `direction` will specify the icon to the right of the header.

var SortableListHeader = exports.SortableListHeader = function (_Component) {
  _inherits(SortableListHeader, _Component);

  function SortableListHeader() {
    _classCallCheck(this, SortableListHeader);

    return _possibleConstructorReturn(this, (SortableListHeader.__proto__ || Object.getPrototypeOf(SortableListHeader)).apply(this, arguments));
  }

  _createClass(SortableListHeader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.wrapperDiv && this.props.tooltip) {
        (0, _jquery2.default)(this.wrapperDiv).tooltip();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.wrapperDiv && this.props.tooltip) {
        (0, _jquery2.default)(this.wrapperDiv).tooltip();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var sortCaretFaClass = this.props.field ? CARET_TYPE_BY_DIRECTION[this.props.direction] : null;
      var sortCaret = sortCaretFaClass ? _react2.default.createElement('span', { className: (0, _classnames2.default)('sort-icon', 'fa', sortCaretFaClass), 'aria-hidden': 'true' }) : null;
      var headerColumnContent = this.props.field ? _react2.default.createElement(
        'button',
        { onClick: function onClick() {
            return _this2.props.onClick(_this2.props.field);
          } },
        this.props.children,
        sortCaret
      ) : _react2.default.createElement(
        'div',
        null,
        this.props.children,
        sortCaret
      );
      var tooltipProps = this.props.tooltip ? {
        'data-toggle': 'tooltip',
        'data-placement': 'bottom',
        'data-js-hook': 'tooltip',
        'data-original-title': this.props.tooltip
      } : {};

      return _react2.default.createElement(
        'div',
        _extends({
          ref: function ref(div) {
            _this2.wrapperDiv = div;
          },
          className: (0, _classnames2.default)('sortable-list-header', this.props.className, this.props.field ? 'sortable' : 'unsortable', this.props.field && this.props.direction !== 'none' ? 'sorting' : 'unsorted')
        }, tooltipProps),
        headerColumnContent
      );
    }
  }]);

  return SortableListHeader;
}(_react.Component);

SortableListHeader.propTypes = {
  className: _propTypes2.default.string,
  direction: _propTypes2.default.oneOf(['none', 'asc', 'desc']),
  field: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number]))]).isRequired,
  tooltip: _propTypes2.default.string
};

SortableListHeader.defaultProps = {
  className: '',
  direction: 'none',
  onClick: function onClick() {},
  field: null,
  tooltip: null
};

var REVERSE_SORT_DIRECTION = {
  asc: 'desc',
  desc: 'asc'
};

var SortableListHeaders = exports.SortableListHeaders = function (_Component2) {
  _inherits(SortableListHeaders, _Component2);

  function SortableListHeaders() {
    _classCallCheck(this, SortableListHeaders);

    return _possibleConstructorReturn(this, (SortableListHeaders.__proto__ || Object.getPrototypeOf(SortableListHeaders)).apply(this, arguments));
  }

  _createClass(SortableListHeaders, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      // We want to add on callbacks to propagate the click callback up.
      // It also tells the header in question what its visual state is.
      var children = _react2.default.Children.map(this.props.children, function (element) {
        if (element && element.type && element.type === SortableListHeader && element.props && element.props.field) {
          if (element.props.field === _this4.props.field) {
            return _react2.default.cloneElement(element, {
              direction: _this4.props.direction,
              onClick: function onClick() {
                return _this4.props.onClick(_this4.props.field, REVERSE_SORT_DIRECTION[_this4.props.direction]);
              }
            });
          }
          return _react2.default.cloneElement(element, {
            direction: 'none',
            onClick: function onClick() {
              return _this4.props.onClick(element.props.field, SortableListHeaders.defaultProps.direction);
            }
          });
        }
        return element;
      });
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('sortable-list-headers', this.props.className) },
        children
      );
    }
  }]);

  return SortableListHeaders;
}(_react.Component);

SortableListHeaders.propTypes = {
  children: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.oneOf([null])])),
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func, // passed with (sortField, sortDirection)
  field: _propTypes2.default.string.isRequired,
  direction: _propTypes2.default.oneOf(['none', 'asc', 'desc']).isRequired
};

SortableListHeaders.defaultProps = {
  children: [],
  className: '',
  onClick: function onClick() {},
  direction: 'asc'
};

/***/ }),

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Histogram = undefined;

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Histogram = _propTypes2.default.shape({
  active: _propTypes2.default.number.isRequired,
  unconfirmed: _propTypes2.default.number.isRequired,
  quarantined: _propTypes2.default.number.isRequired,
  total: _propTypes2.default.number.isRequired
});

var NOTIFICATION_TYPES = ['email', 'sms', 'webhook'];

exports.Histogram = Histogram; // eslint-disable-line import/prefer-default-export

/***/ }),

/***/ 1274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(3);

var _moment2 = _interopRequireDefault(_moment);

var _notifications = __webpack_require__(362);

var _notifications2 = _interopRequireDefault(_notifications);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(20);

var _classnames2 = _interopRequireDefault(_classnames);

var _subscriber_action = __webpack_require__(662);

var _subscriber_action2 = _interopRequireDefault(_subscriber_action);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This component represents a single row in the notifications subscriber list.
 */
var NotificationsSubscriberRow = function (_React$Component) {
  _inherits(NotificationsSubscriberRow, _React$Component);

  function NotificationsSubscriberRow() {
    _classCallCheck(this, NotificationsSubscriberRow);

    return _possibleConstructorReturn(this, (NotificationsSubscriberRow.__proto__ || Object.getPrototypeOf(NotificationsSubscriberRow)).apply(this, arguments));
  }

  _createClass(NotificationsSubscriberRow, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var childrenWithBoundCallbacks = _react2.default.Children.map(this.props.children, function (child) {
        if (child && child.type === _subscriber_action2.default) {
          // This onClick is the one for links that *do not* rely on the current selection.
          return _react2.default.cloneElement(child, {
            onClick: function onClick(e) {
              return child.props.onClick(e, [_this2.props.subscriber.id], child.props.subscriberState);
            }
          });
        }
        return child;
      });

      var createdAtColumnSize = this.props.state === 'quarantined' ? 'created-at-small' : 'created-at-large';
      var quarantineColumn = this.props.state === 'quarantined' ? _react2.default.createElement(
        'div',
        { className: 'subscriber-content-column quarantined-at' },
        (0, _moment2.default)(this.props.subscriber.quarantined_at).format('ll'),
        '\xA0/\xA0',
        (0, _moment2.default)(this.props.subscriber.purge_at).format('ll')
      ) : null;
      var actionsColumnSize = this.props.state === 'unconfirmed' ? 'actions-large' : 'actions-small';

      return _react2.default.createElement(
        'div',
        { className: 'subscriber-content-columns' },
        _react2.default.createElement(
          'div',
          { className: 'subscriber-content-column subscriber-title' },
          this.props.subscriber[_notifications2.default.SUBSCRIBER_DISPLAY_FIELD_BY_TYPE[this.props.subscriber.mode]]
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('subscriber-content-column', 'created-at', createdAtColumnSize) },
          (0, _moment2.default)(this.props.subscriber.created_at).format('ll')
        ),
        quarantineColumn,
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('subscriber-content-column', 'actions', actionsColumnSize) },
          childrenWithBoundCallbacks
        )
      );
    }
  }]);

  return NotificationsSubscriberRow;
}(_react2.default.Component);

NotificationsSubscriberRow.propTypes = {
  // The expected subscriber shape from the api.
  subscriber: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    created_at: _propTypes2.default.string.isRequired,
    quarantined_at: _propTypes2.default.string,
    purge_at: _propTypes2.default.string,
    mode: _propTypes2.default.oneOf(['email', 'sms', 'webhook']).isRequired,
    email: _propTypes2.default.string,
    endpoint: _propTypes2.default.string,
    phone_number: _propTypes2.default.string
  }).isRequired,
  state: _propTypes2.default.oneOf(['active', 'unconfirmed', 'quarantined']).isRequired,
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]))]),
  href: _propTypes2.default.string
};
NotificationsSubscriberRow.defaultProps = {
  children: null,
  href: null
};
exports.default = NotificationsSubscriberRow;

/***/ }),

/***/ 1275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _subscriber = __webpack_require__(199);

var _subscriber2 = _interopRequireDefault(_subscriber);

var _sentry_reporter = __webpack_require__(298);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubscriberQuery = function (_Component) {
  _inherits(SubscriberQuery, _Component);

  function SubscriberQuery() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SubscriberQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubscriberQuery.__proto__ || Object.getPrototypeOf(SubscriberQuery)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      subscribers: [],
      request: null,
      error: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SubscriberQuery, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.mounted = true;
      this._fetchSubscribers(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.pageCode !== this.props.pageCode || props.limit !== this.props.limit || props.updatedAt !== this.props.updatedAt || props.page !== this.props.page || props.sortDirection !== this.props.sortDirection || props.sortField !== this.props.sortField || props.subscriberType !== this.props.subscriberType || props.subscriberState !== this.props.subscriberState) {
        this._fetchSubscribers(props);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // make sure we don't try to call setState on an unmounted component
      this.mounted = false;
    }
  }, {
    key: '_fetchSubscribers',
    value: function _fetchSubscribers(propsAtFetchTime) {
      var _this2 = this;

      // Store the request promise to identify THIS instance of fetching subscribers.
      var request = _subscriber2.default.getPage({
        pageCode: propsAtFetchTime.pageCode,
        page: propsAtFetchTime.page,
        limit: propsAtFetchTime.limit,
        sort_direction: propsAtFetchTime.sortDirection,
        sort_field: propsAtFetchTime.sortField,
        type: propsAtFetchTime.subscriberType,
        state: propsAtFetchTime.subscriberState
      }).then(function (subscribers) {
        if (_this2.mounted) {
          _this2.setState(function (prevState) {
            var newState = {
              subscribers: subscribers,
              request: null,
              error: null
            };

            // Only update the state if the request in `state` is the request on which this function closes.
            if (prevState.request === request) {
              return newState;
            }

            // Otherwise update nothing.
            return {};
          });
        }
      }).catch(function (e) {
        (0, _sentry_reporter.reportError)(e, {});
        if (_this2.mounted) {
          _this2.setState(function (prevState) {
            // Same here: only update state if this request was the last request requested.
            if (prevState.request === request) {
              return { error: 'Please try again in a few minutes.', request: null };
            }
            return {};
          });
        }
      });

      // Set the error and request here to mark which request was last requested by the user.
      this.setState({
        error: null,
        request: request
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children(this.state.subscribers, this.state.request !== null, this.state.error);
    }
  }]);

  return SubscriberQuery;
}(_react.Component);

SubscriberQuery.propTypes = {
  pageCode: _propTypes2.default.string.isRequired,
  limit: _propTypes2.default.number.isRequired,
  children: _propTypes2.default.func.isRequired,
  updatedAt: _propTypes2.default.string.isRequired,

  page: _propTypes2.default.number,
  sortDirection: _propTypes2.default.oneOf(['asc', 'desc']),
  sortField: _propTypes2.default.oneOf(['primary', 'created_at', 'quarantined_at']),
  subscriberType: _propTypes2.default.oneOf(['email', 'sms', 'webhook']),
  subscriberState: _propTypes2.default.oneOf(['active', 'unconfirmed', 'quarantined'])
};
SubscriberQuery.defaultProps = {
  page: 0,
  sortDirection: 'asc',
  sortField: 'primary',
  subscriberType: 'email',
  subscriberState: 'active'
};
exports.default = SubscriberQuery;


module.exports = SubscriberQuery;

/***/ }),

/***/ 1276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _subscriber = __webpack_require__(199);

var _subscriber2 = _interopRequireDefault(_subscriber);

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResendConfirmationLink = function (_React$Component) {
  _inherits(ResendConfirmationLink, _React$Component);

  function ResendConfirmationLink() {
    _classCallCheck(this, ResendConfirmationLink);

    return _possibleConstructorReturn(this, (ResendConfirmationLink.__proto__ || Object.getPrototypeOf(ResendConfirmationLink)).apply(this, arguments));
  }

  _createClass(ResendConfirmationLink, [{
    key: '_success',
    value: function _success() {
      HRB.utils.notify('Sent confirmation link to: ' + this.props.email + '.');
    }
  }, {
    key: '_failure',
    value: function _failure() {
      HRB.utils.notify('Unable to send confirmation link. Try again soon.');
    }
  }, {
    key: '_resendSubscriberConfirmation',
    value: function _resendSubscriberConfirmation() {
      if (this.props.destination === 'manage') {
        _subscriber2.default.resendConfirmation(this.props.pageCode, this.props.subscriberCode).then(this._success.bind(this), this._failure);
      } else {
        _jquery2.default.post('/resend_confirmation/' + this.props.subscriberCode).done(this._success.bind(this)).fail(this._failure);
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'a',
        { href: '#',
          onClick: function onClick() {
            return _this2._resendSubscriberConfirmation();
          },
          ref: 'anchor' },
        this.props.text
      );
    }
  }]);

  return ResendConfirmationLink;
}(_react2.default.Component);

ResendConfirmationLink.propTypes = {
  pageCode: _propTypes2.default.string.isRequired, // Page of the subscriber
  subscriberCode: _propTypes2.default.string.isRequired, // The subscriber code itself
  text: _propTypes2.default.string.isRequired, // The text to display with the link
  email: _propTypes2.default.string.isRequired, // The email to display in the success prompt
  destination: _propTypes2.default.oneOf(['status', 'manage']).isRequired // There are two API endpoints to simplify calling from admin and subscriber contexts.
};

module.exports = ResendConfirmationLink;

/***/ }),

/***/ 1277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _confirm = __webpack_require__(84);

var _confirm2 = _interopRequireDefault(_confirm);

var _form = __webpack_require__(250);

var _form2 = _interopRequireDefault(_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(249),
    MODAL_PREFIX = _require.MODAL_PREFIX;

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(26);

var Input = __webpack_require__(86);
var TextArea = __webpack_require__(198);

var DELETE_MODAL = 'delete-provider';
var DELETE_MODAL_TRIGGER = MODAL_PREFIX + DELETE_MODAL;

var SAVE_MODAL = 'save-provider';
var SAVE_MODAL_TRIGGER = MODAL_PREFIX + SAVE_MODAL;

var SingleSignOnForm = function (_React$Component) {
  _inherits(SingleSignOnForm, _React$Component);

  function SingleSignOnForm() {
    _classCallCheck(this, SingleSignOnForm);

    return _possibleConstructorReturn(this, (SingleSignOnForm.__proto__ || Object.getPrototypeOf(SingleSignOnForm)).apply(this, arguments));
  }

  _createClass(SingleSignOnForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      HRB.utils.djshook('tooltip').tooltip();
    }
  }, {
    key: '_entityId',
    value: function _entityId() {
      return 'https://' + this.props.entity_uuid + '.' + this.props.domain + '/';
    }
  }, {
    key: '_emailNodeField',
    value: function _emailNodeField() {
      if (this.props.access_controlled_page) {
        return React.createElement(
          'div',
          { className: 'span12' },
          React.createElement(Input, { type: 'text',
            inputClass: 'full-width',
            label: 'Page Access User Email Node',
            name: 'email_node_name',
            placeholder: 'Page Access User Email Node',
            defaultValue: this.props.provider.email_node_name,
            helpBlockText: 'This is the attribute we\'ll use to set an email address for your Page Access Users. We suggest you use \'email\'' })
        );
      }
    }
  }, {
    key: '_handleDelete',
    value: function _handleDelete() {
      $.ajax({
        type: 'DELETE',
        url: this.props.path,
        dataType: 'JSON',
        success: function success(data, textStatus, xhr) {
          window.location.reload(true);
        },
        error: function error(xhr, textStatus, errorThrown) {
          HRB.utils.notify("Sorry, it looks like deleting your SSO configuration failed", { cssClass: 'error' });
        }
      });
    }
  }, {
    key: '_deleteButton',
    value: function _deleteButton() {
      if (this.props.ownerHasRestriction) {
        return React.createElement(
          'a',
          { href: '#', method: 'DELETE', onClick: this._triggerModal.bind(this, DELETE_MODAL_TRIGGER), className: 'small' },
          'Remove SSO restriction'
        );
      }
    }
  }, {
    key: '_triggerModal',
    value: function _triggerModal(modalId, e) {
      e.preventDefault();
      e.stopPropagation();
      $(ReactDOM.findDOMNode(this)).find('#' + modalId).modal();
    }
  }, {
    key: '_submitForm',
    value: function _submitForm() {
      $(ReactDOM.findDOMNode(this)).find('#sso-idp-form').submit();
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'h5',
          { className: 'step-header' },
          'Step 1: Add The Statuspage Application In Your Identity Provider'
        ),
        React.createElement(
          'table',
          { className: 'cpt-tabular-table' },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                null,
                'ACS URL / Consumer URL ',
                React.createElement(
                  'span',
                  { className: 'tooltip-base', 'data-js-hook': 'tooltip', 'data-original-title': 'This is the URL is where your Identity Provider will send SAML assertions, and will be required in your Identity Provider\'s admin when setting up a Statuspage app.' },
                  '?'
                )
              ),
              React.createElement(
                'th',
                null,
                'EntityID / Audience URI ',
                React.createElement(
                  'span',
                  { className: 'tooltip-base', 'data-js-hook': 'tooltip', 'data-original-title': 'This is the value you\'ll need to enter in the \'Entity ID\' field in your Identity Provider\'s configuration. This may also be referred to as \'Audience Restriction\' or \'Audience URI\'.' },
                  '?'
                )
              )
            )
          ),
          React.createElement(
            'tbody',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'td',
                { className: 'consumeURL' },
                ' ',
                this.props.sso_saml_consume_url,
                ' '
              ),
              React.createElement(
                'td',
                { className: 'entityID' },
                ' ',
                this._entityId(),
                ' '
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'align-center', style: { marginTop: '8px' } },
          React.createElement(
            'small',
            null,
            'You can also view the entire ',
            React.createElement(
              'a',
              { href: this.props.metadata_path, target: '_blank' },
              'service provider metadata XML file for this ',
              this.props.ownerType
            )
          )
        ),
        React.createElement(
          'h5',
          { className: 'step-header' },
          'Step 2: Paste In The SSO Target URL And Certificate Returned By Your IDP'
        ),
        React.createElement(
          _form2.default,
          { 'for': 'SsoIdentityProvider', id: 'sso-idp-form', onSubmit: this._triggerModal.bind(this, SAVE_MODAL_TRIGGER), method: this.props.ownerHasRestriction ? 'PUT' : 'POST', action: this.props.path },
          React.createElement('input', { type: 'hidden', name: 'entity_uuid', value: this.props.entity_uuid }),
          React.createElement('input', { type: 'hidden', name: 'owner_type', value: this.props.ownerType }),
          React.createElement('input', { type: 'hidden', name: 'owner_id', value: this.props.owner.id }),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'span12' },
              React.createElement(Input, { type: 'text',
                inputClass: 'full-width',
                label: 'SSO target URL',
                name: 'sso_target_url_text',
                placeholder: 'SSO Target URL',
                defaultValue: this.props.provider.sso_target_url_text,
                helpBlockText: 'ACS URL used to log in to your SSO provider.' })
            ),
            this._emailNodeField(),
            React.createElement(
              'div',
              { className: 'span12 text-area-container' },
              React.createElement(TextArea, { inputClass: 'full-width',
                label: 'Certificate',
                name: 'certificate',
                placeholder: 'Paste in x.509 encoded certificate exactly as it\'s given by your Identity Provider, including the header and footer line.',
                defaultValue: this.props.provider.certificate,
                textareaStyle: { height: 460 } })
            )
          ),
          React.createElement(
            'div',
            { className: 'form-actions' },
            React.createElement(
              'button',
              { type: 'submit', className: 'cpt-button style-primary size-small' },
              this.props.ownerHasRestriction ? 'Update' : 'Save',
              ' SSO configuration'
            ),
            React.createElement(
              'span',
              { className: 'remove-link' },
              this._deleteButton()
            )
          )
        ),
        React.createElement(_confirm2.default, { id: SAVE_MODAL,
          title: 'Hey! Just so you know...',
          message: 'By saving this record, you\'re making changes to your authentication flow, and the way your users can access our site. Just in case something is wrong, we\'ll still allow you to login with your username and password until we see a successful SAML authentication request. After that, you\'ll only be able to authenticate via SAML until you change your record again.',
          onConfirm: this._submitForm.bind(this),
          confirm_text: 'Got it, save the record.' }),
        React.createElement(_confirm2.default, { id: DELETE_MODAL,
          title: 'Hey! Just so you know...',
          message: 'Warning! This will cause your SSO configuration to be completely removed. This will force your users to login using Statuspage credentials only. This action is permanent and cannot be undone.',
          onConfirm: this._handleDelete.bind(this),
          confirm_text: 'Permanently delete',
          cancel_text: 'Don\'t Delete' })
      );
    }
  }]);

  return SingleSignOnForm;
}(React.Component);

module.exports = SingleSignOnForm;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SsoMetrics = function (_Component) {
  _inherits(SsoMetrics, _Component);

  function SsoMetrics() {
    _classCallCheck(this, SsoMetrics);

    return _possibleConstructorReturn(this, (SsoMetrics.__proto__ || Object.getPrototypeOf(SsoMetrics)).apply(this, arguments));
  }

  _createClass(SsoMetrics, [{
    key: "_failureRreasons",
    value: function _failureRreasons() {
      if (this.props.presenter.has_failures) {
        return _react2.default.createElement(
          "span",
          null,
          _react2.default.createElement(
            "h6",
            null,
            "Reason for last Failure:"
          ),
          _react2.default.createElement(
            "span",
            null,
            this.props.presenter.reason_for_last_failure
          )
        );
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "span12" },
            _react2.default.createElement(
              "h6",
              null,
              "Total Unique Visitors: ",
              this.props.presenter.total_unique_visitors
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "span12" },
            _react2.default.createElement(
              "h6",
              null,
              "Admin Visitors: ",
              this.props.presenter.admin_visitors_count
            ),
            _react2.default.createElement(
              "p",
              null,
              this.props.presenter.admin_visitors
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "span12" },
            _react2.default.createElement(
              "h6",
              null,
              "Page Visitors: ",
              this.props.presenter.page_visitors_count
            ),
            _react2.default.createElement(
              "p",
              null,
              this.props.presenter.page_visitors
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "span12" },
            _react2.default.createElement(
              "h6",
              null,
              "Issuing Sources"
            ),
            _react2.default.createElement(
              "p",
              null,
              this.props.presenter.issuing_sources
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "span12" },
            _react2.default.createElement(
              "h6",
              null,
              "Successful Auth Attempts: ",
              this.props.presenter.success_count
            ),
            _react2.default.createElement(
              "h6",
              null,
              "Failed Auth Attempts: ",
              this.props.presenter.fail_count
            ),
            this._failureRreasons()
          )
        )
      );
    }
  }]);

  return SsoMetrics;
}(_react.Component);

module.exports = SsoMetrics;

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StrideConversationListItem = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StrideConversationListItem = exports.StrideConversationListItem = function StrideConversationListItem(_ref) {
  var name = _ref.name,
      cloudId = _ref.cloudId,
      conversationId = _ref.conversationId;
  return _react2.default.createElement(
    'div',
    { className: 'table-row' },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        { className: 'name' },
        name
      ),
      _react2.default.createElement(
        'span',
        { className: 'actions' },
        _react2.default.createElement(
          'a',
          { href: 'https://app.stride.com/' + cloudId + '/chat/' + conversationId },
          'Manage'
        )
      )
    )
  );
};

StrideConversationListItem.propTypes = {
  name: _propTypes2.default.string.isRequired,
  cloudId: _propTypes2.default.string.isRequired,
  conversationId: _propTypes2.default.string.isRequired,
  code: _propTypes2.default.string.isRequired
};

var StrideConversations = function StrideConversations(_ref2) {
  var conversations = _ref2.conversations;
  return _react2.default.createElement(
    'div',
    { className: 'cpt-table standard-two-row' },
    _react2.default.createElement(
      'div',
      { id: 'stride-conversations', className: 'stride-conversations content' },
      _react2.default.createElement(
        'div',
        { className: 'header' },
        'Connected conversations'
      ),
      conversations.map(function (conversation) {
        return _react2.default.createElement(StrideConversationListItem, _extends({ key: conversation.code, id: conversation.code }, conversation));
      })
    )
  );
};

StrideConversations.propTypes = {
  conversations: _propTypes2.default.arrayOf(_propTypes2.default.shape(StrideConversationListItem.propTypes)).isRequired
};

exports.default = StrideConversations;

/***/ }),

/***/ 1280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StrideConversationListItem = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StrideConversationListItem = exports.StrideConversationListItem = function StrideConversationListItem(_ref) {
  var name = _ref.name,
      cloudId = _ref.cloudId,
      conversationId = _ref.conversationId;
  return _react2.default.createElement(
    'div',
    { className: 'table-row' },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        { className: 'name' },
        name
      ),
      _react2.default.createElement(
        'span',
        { className: 'actions' },
        _react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { scope: 'col' },
                'Cloud ID'
              ),
              _react2.default.createElement(
                'td',
                null,
                cloudId
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { scope: 'col' },
                'Conversation ID'
              ),
              _react2.default.createElement(
                'td',
                null,
                conversationId
              )
            )
          )
        )
      )
    )
  );
};

StrideConversationListItem.propTypes = {
  name: _propTypes2.default.string.isRequired,
  cloudId: _propTypes2.default.string.isRequired,
  conversationId: _propTypes2.default.string.isRequired,
  code: _propTypes2.default.string.isRequired
};

var StrideConversationsAdminInfo = function StrideConversationsAdminInfo(_ref2) {
  var conversations = _ref2.conversations;
  return _react2.default.createElement(
    'div',
    { className: 'cpt-admin-callout' },
    _react2.default.createElement(
      'div',
      { className: 'cpt-admin-callout-title' },
      _react2.default.createElement('i', { className: 'fa fa-info-circle' }),
      ' Admin Info'
    ),
    _react2.default.createElement(
      'div',
      { className: 'cpt-admin-callout-display' },
      _react2.default.createElement(
        'div',
        { className: 'cpt-table standard-two-row' },
        _react2.default.createElement(
          'div',
          { id: 'stride-conversations', className: 'stride-conversations content admin-info' },
          _react2.default.createElement(
            'div',
            { className: 'table-row-group' },
            conversations.map(function (conversation) {
              return _react2.default.createElement(StrideConversationListItem, _extends({ key: conversation.code }, conversation));
            })
          )
        )
      )
    )
  );
};

StrideConversationsAdminInfo.propTypes = {
  conversations: _propTypes2.default.arrayOf(_propTypes2.default.shape(StrideConversationListItem.propTypes)).isRequired
};

exports.default = StrideConversationsAdminInfo;

/***/ }),

/***/ 1281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _server = __webpack_require__(251);

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var ESSearchField = __webpack_require__(344);
var moment = __webpack_require__(3);

var Subscriber = __webpack_require__(199);

var SubscribersSearchField = function (_React$Component) {
  _inherits(SubscribersSearchField, _React$Component);

  function SubscribersSearchField() {
    _classCallCheck(this, SubscribersSearchField);

    return _possibleConstructorReturn(this, (SubscribersSearchField.__proto__ || Object.getPrototypeOf(SubscribersSearchField)).apply(this, arguments));
  }

  _createClass(SubscribersSearchField, [{
    key: '_template',

    // Get HTML string for how a typeahead item should be rendered
    value: function _template(suggestion) {
      var view = React.createElement(SubscriberTypeaheadView, { suggestion: suggestion });
      return _server2.default.renderToString(view);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var searchRoute = ApiRoutes.page_subscribers_url({ pageCode: this.props.page.id });
      var mapResultToUiRoute = function mapResultToUiRoute(suggestion) {
        return Routes.page_subscriber_url(_this2.props.page, suggestion.id, { domain: null, subdomain: null });
      };
      return React.createElement(
        'div',
        { className: 'subscriber-search-field-wrapper' },
        React.createElement(ESSearchField, { queryUrl: searchRoute + '?limit=10&state=all&q=%QUERY',
          pluralizedResultName: "subscribers",
          loadResults: Subscriber.search,
          mapResultToUiUrl: mapResultToUiRoute,
          template: this._template.bind(this)
        })
      );
    }
  }]);

  return SubscribersSearchField;
}(React.Component);

var SubscriberTypeaheadView = function (_React$Component2) {
  _inherits(SubscriberTypeaheadView, _React$Component2);

  function SubscriberTypeaheadView() {
    _classCallCheck(this, SubscriberTypeaheadView);

    return _possibleConstructorReturn(this, (SubscriberTypeaheadView.__proto__ || Object.getPrototypeOf(SubscriberTypeaheadView)).apply(this, arguments));
  }

  _createClass(SubscriberTypeaheadView, [{
    key: '_determineType',
    value: function _determineType(suggestion) {

      if (suggestion.hasOwnProperty('endpoint')) {
        return {
          iconClass: 'fa-share-alt',
          matchValue: suggestion.endpoint
        };
      } else if (suggestion.hasOwnProperty('email')) {
        return {
          iconClass: 'fa-envelope',
          matchValue: suggestion.email
        };
      } else if (suggestion.hasOwnProperty('phone_number')) {
        return {
          iconClass: 'fa-phone',
          matchValue: suggestion.phone_display
        };
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var suggestion = this.props.suggestion;
      var subscriberData = this._determineType(suggestion);

      var itemClasses = "item search-result es-results";
      if (suggestion.quarantined_at) {
        itemClasses = itemClasses + " es-result-quarantined-subscriber";
      }

      return React.createElement(
        'div',
        { className: itemClasses },
        React.createElement(
          'div',
          { className: 'icon-container' },
          React.createElement('i', { className: 'fa ' + subscriberData.iconClass })
        ),
        React.createElement(
          'div',
          { className: 'result-text-container' },
          subscriberData.matchValue
        ),
        React.createElement('div', { className: 'clearfix' })
      );
    }
  }]);

  return SubscriberTypeaheadView;
}(React.Component);

module.exports = SubscribersSearchField;

/***/ }),

/***/ 1282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var cx = __webpack_require__(20);

var UnsubscribeButton = function (_React$Component) {
  _inherits(UnsubscribeButton, _React$Component);

  function UnsubscribeButton() {
    _classCallCheck(this, UnsubscribeButton);

    return _possibleConstructorReturn(this, (UnsubscribeButton.__proto__ || Object.getPrototypeOf(UnsubscribeButton)).apply(this, arguments));
  }

  _createClass(UnsubscribeButton, [{
    key: '_unsubscribe',
    value: function _unsubscribe() {
      var _this2 = this;

      $.ajax({
        type: "DELETE",
        url: Routes.page_deactivate_subscribers_url(this.props.page, this.props.subscriber)
      }).success(function (msg) {
        HRB.utils.notify('Subscriber successfully unsubscribed.', { method: 'deferred' });
        window.location = Routes.notifications_page_url(_this2.props.page, { domain: null, subdomain: null });
      }).fail(function () {
        HRB.utils.basicFailAndReload();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'a',
        { className: 'cpt-button style-primary size-small pull-right',
          onClick: this._unsubscribe.bind(this) },
        'UNSUBSCRIBE'
      );
    }
  }]);

  return UnsubscribeButton;
}(React.Component);

module.exports = UnsubscribeButton;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 1283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_tooltip__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_items_selector_items_selector__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_items_selector_items_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_items_selector_items_selector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_resources_types__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__unsubscribe_confirmation_modal__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_notify__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__heading__ = __webpack_require__(1285);








var tooltipTitle = function (subscriber, page) {
    return "This page allows you to fine-tune which components matter to you. You will receive " + __WEBPACK_IMPORTED_MODULE_4_resources_types__["a" /* Subscriber */].displayMode(subscriber) + " notifications when " + page.name + " is having an issue that affects any of the selected components.";
};
var unsubscribe = function (page, subscriber) {
    $('#modal-confirmation-confirmationModalId').modal();
};
var onConfirmUnsubscribe = function (page, subscriber) {
    $.ajax({
        url: "/unsubscribe/" + subscriber.id + ".json",
        type: 'DELETE',
        dataType: 'json',
        complete: function (response) {
            Object(__WEBPACK_IMPORTED_MODULE_6_utils_notify__["c" /* default */])('You have been unsubscribed!', { method: __WEBPACK_IMPORTED_MODULE_6_utils_notify__["b" /* Method */].DEFERRED });
            window.location.href = window.location.origin;
        },
        error: function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_6_utils_notify__["c" /* default */])('You could not be unsubscribed. Contact support if this problem persists.', { method: __WEBPACK_IMPORTED_MODULE_6_utils_notify__["b" /* Method */].SHOW });
            console.error('Failed to unsubscribe subscriber.', error);
        },
    });
};
var ManageSubscription = function (_a) {
    var page = _a.page, subscriber = _a.subscriber, components = _a.components, selectedComponentIds = _a.selectedComponentIds;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__heading__["a" /* default */], { subscriber: subscriber, onUnsubscribe: function () { return unsubscribe(page, subscriber); } }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components_form__["default"], { action: window.Routes.manage_path(subscriber.id), method: "PATCH" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { display: 'flex', justifyContent: 'space-between' } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Components"),
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null,
                        "(",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", style: { cursor: 'pointer' }, "data-js-hook": "toggle-all", id: "component-selector-toggle" }, "Toggle all"),
                        ")")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_tooltip__["default"], { title: tooltipTitle(subscriber, page) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null, "What's this?"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components_items_selector_items_selector__, { className: "inline", items: components, preselectedItemIds: selectedComponentIds, showHeader: false, showFooter: false, hiddenFieldName: "subscriber[component_ids]", toggleAllclickTargetId: "component-selector-toggle", showTooltipDescriptions: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-actions" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "flat-button", type: "submit" }, "Update Preferences"))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__unsubscribe_confirmation_modal__["a" /* default */], { page: page, subscriber: subscriber, onConfirm: function () { return onConfirmUnsubscribe(page, subscriber); } })));
};
/* harmony default export */ __webpack_exports__["default"] = (ManageSubscription);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),

/***/ 1284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resources_types__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_confirm__ = __webpack_require__(84);



var UnsubscribeConfirmationModal = function (_a) {
    var page = _a.page, subscriber = _a.subscriber, onConfirm = _a.onConfirm;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components_confirm__["default"], { id: "confirmationModalId", title: "Confirm Unsubscribe", onConfirm: onConfirm, confirm_text: "Unsubscribe from updates", confirmClass: "style-warning" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { padding: '1em' } },
            "Click the confirm button below to unsubscribe",
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, __WEBPACK_IMPORTED_MODULE_1_resources_types__["a" /* Subscriber */].identifier(subscriber)),
            " from all",
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, page.name),
            " updates.")));
};
/* harmony default export */ __webpack_exports__["a"] = (UnsubscribeConfirmationModal);


/***/ }),

/***/ 1285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resources_types__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_page_colors__ = __webpack_require__(663);



var pageColors = new __WEBPACK_IMPORTED_MODULE_2_page_colors__["default"](window.pageColorData);
var styles = __webpack_require__(1286);
var Header = function (_a) {
    var children = _a.children;
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { color: pageColors.font.hex } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, children));
};
var Heading = function (_a) {
    var subscriber = _a.subscriber, onUnsubscribe = _a.onUnsubscribe;
    var mode = __WEBPACK_IMPORTED_MODULE_1_resources_types__["a" /* Subscriber */].displayMode(subscriber);
    var identifier = __WEBPACK_IMPORTED_MODULE_1_resources_types__["a" /* Subscriber */].identifier(subscriber);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.subscriberHeading },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header, null, "Subscriber"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styles.border, style: { borderColor: pageColors.border.hex } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: styles.mode, style: { color: pageColors.font.hex } }, mode),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: styles.identifier, style: { color: pageColors.font.hex } }, identifier),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: styles.unsubscribeButton, style: { color: pageColors.red.hex }, onClick: onUnsubscribe }, "Cancel Subscription"))));
};
/* harmony default export */ __webpack_exports__["a"] = (Heading);


/***/ }),

/***/ 1286:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"border":"_1d5QtSwZOwprVdjPssPV8u","mode":"_33zOGaZ4e38U43m3lIR4bD","identifier":"_1g2BQlJ4RmQzO7sH0D5AxW","unsubscribeButton":"_3JWHwui2MHYxH82VbMXz43"};

/***/ }),

/***/ 1287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_time_picker__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_date_picker__ = __webpack_require__(259);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var DateTimePicker = /** @class */ (function (_super) {
    __extends(DateTimePicker, _super);
    function DateTimePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.updateDate = function (date) {
            _this.setState({ date: date.tz(_this.props.timezone) });
        };
        var now = __WEBPACK_IMPORTED_MODULE_1_moment_timezone__().tz(props.timezone);
        _this.state = { date: now };
        return _this;
    }
    DateTimePicker.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "date-time-picker row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "backfill-date-picker span6" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components_date_picker__["a" /* default */], { onChange: this.updateDate, selectedDate: this.state.date, disabled: false })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "backfill-time-picker span6" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components_time_picker__["a" /* default */], { onChange: this.updateDate, selectedDate: this.state.date, disabled: false })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "hidden", name: "incident[backfill_date]", value: this.state.date.toISOString() })));
    };
    DateTimePicker.defaultProps = {
        timezone: 'UTC',
        timezoneDisplay: 'UTC',
    };
    return DateTimePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["default"] = (DateTimePicker);


/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * inflection
 * Copyright(c) 2011 Ben Lin <ben@dreamerslab.com>
 * MIT Licensed
 *
 * @fileoverview
 * A port of inflection-js to node.js module.
 */

( function ( root, factory ){
  if( true ){
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }else if( typeof exports === 'object' ){
    module.exports = factory();
  }else{
    root.inflection = factory();
  }
}( this, function (){

  /**
   * @description This is a list of nouns that use the same form for both singular and plural.
   *              This list should remain entirely in lower case to correctly match Strings.
   * @private
   */
  var uncountable_words = [
    // 'access',
    'accommodation',
    'adulthood',
    'advertising',
    'advice',
    'aggression',
    'aid',
    'air',
    'aircraft',
    'alcohol',
    'anger',
    'applause',
    'arithmetic',
    // 'art',
    'assistance',
    'athletics',
    // 'attention',

    'bacon',
    'baggage',
    // 'ballet',
    // 'beauty',
    'beef',
    // 'beer',
    // 'behavior',
    'biology',
    // 'billiards',
    'blood',
    'botany',
    // 'bowels',
    'bread',
    // 'business',
    'butter',

    'carbon',
    'cardboard',
    'cash',
    'chalk',
    'chaos',
    'chess',
    'crossroads',
    'countryside',

    // 'damage',
    'dancing',
    // 'danger',
    'deer',
    // 'delight',
    // 'dessert',
    'dignity',
    'dirt',
    // 'distribution',
    'dust',

    'economics',
    'education',
    'electricity',
    // 'employment',
    // 'energy',
    'engineering',
    'enjoyment',
    // 'entertainment',
    'envy',
    'equipment',
    'ethics',
    'evidence',
    'evolution',

    // 'failure',
    // 'faith',
    'fame',
    'fiction',
    // 'fish',
    'flour',
    'flu',
    'food',
    // 'freedom',
    // 'fruit',
    'fuel',
    'fun',
    // 'funeral',
    'furniture',

    'gallows',
    'garbage',
    'garlic',
    // 'gas',
    'genetics',
    // 'glass',
    'gold',
    'golf',
    'gossip',
    'grammar',
    // 'grass',
    'gratitude',
    'grief',
    // 'ground',
    'guilt',
    'gymnastics',

    // 'hair',
    'happiness',
    'hardware',
    'harm',
    'hate',
    'hatred',
    'health',
    'heat',
    // 'height',
    'help',
    'homework',
    'honesty',
    'honey',
    'hospitality',
    'housework',
    'humour',
    'hunger',
    'hydrogen',

    'ice',
    'importance',
    'inflation',
    'information',
    // 'injustice',
    'innocence',
    // 'intelligence',
    'iron',
    'irony',

    'jam',
    // 'jealousy',
    // 'jelly',
    'jewelry',
    // 'joy',
    'judo',
    // 'juice',
    // 'justice',

    'karate',
    // 'kindness',
    'knowledge',

    // 'labour',
    'lack',
    // 'land',
    'laughter',
    'lava',
    'leather',
    'leisure',
    'lightning',
    'linguine',
    'linguini',
    'linguistics',
    'literature',
    'litter',
    'livestock',
    'logic',
    'loneliness',
    // 'love',
    'luck',
    'luggage',

    'macaroni',
    'machinery',
    'magic',
    // 'mail',
    'management',
    'mankind',
    'marble',
    'mathematics',
    'mayonnaise',
    'measles',
    // 'meat',
    // 'metal',
    'methane',
    'milk',
    'minus',
    'money',
    // 'moose',
    'mud',
    'music',
    'mumps',

    'nature',
    'news',
    'nitrogen',
    'nonsense',
    'nurture',
    'nutrition',

    'obedience',
    'obesity',
    // 'oil',
    'oxygen',

    // 'paper',
    // 'passion',
    'pasta',
    'patience',
    // 'permission',
    'physics',
    'poetry',
    'pollution',
    'poverty',
    // 'power',
    'pride',
    // 'production',
    // 'progress',
    // 'pronunciation',
    'psychology',
    'publicity',
    'punctuation',

    // 'quality',
    // 'quantity',
    'quartz',

    'racism',
    // 'rain',
    // 'recreation',
    'relaxation',
    'reliability',
    'research',
    'respect',
    'revenge',
    'rice',
    'rubbish',
    'rum',

    'safety',
    // 'salad',
    // 'salt',
    // 'sand',
    // 'satire',
    'scenery',
    'seafood',
    'seaside',
    'series',
    'shame',
    'sheep',
    'shopping',
    // 'silence',
    'sleep',
    // 'slang'
    'smoke',
    'smoking',
    'snow',
    'soap',
    'software',
    'soil',
    // 'sorrow',
    // 'soup',
    'spaghetti',
    // 'speed',
    'species',
    // 'spelling',
    // 'sport',
    'steam',
    // 'strength',
    'stuff',
    'stupidity',
    // 'success',
    // 'sugar',
    'sunshine',
    'symmetry',

    // 'tea',
    'tennis',
    'thirst',
    'thunder',
    'timber',
    // 'time',
    // 'toast',
    // 'tolerance',
    // 'trade',
    'traffic',
    'transportation',
    // 'travel',
    'trust',

    // 'understanding',
    'underwear',
    'unemployment',
    'unity',
    // 'usage',

    'validity',
    'veal',
    'vegetation',
    'vegetarianism',
    'vengeance',
    'violence',
    // 'vision',
    'vitality',

    'warmth',
    // 'water',
    'wealth',
    'weather',
    // 'weight',
    'welfare',
    'wheat',
    // 'whiskey',
    // 'width',
    'wildlife',
    // 'wine',
    'wisdom',
    // 'wood',
    // 'wool',
    // 'work',

    // 'yeast',
    'yoga',

    'zinc',
    'zoology'
  ];

  /**
   * @description These rules translate from the singular form of a noun to its plural form.
   * @private
   */

  var regex = {
    plural : {
      men       : new RegExp( '^(m|wom)en$'                    , 'gi' ),
      people    : new RegExp( '(pe)ople$'                      , 'gi' ),
      children  : new RegExp( '(child)ren$'                    , 'gi' ),
      tia       : new RegExp( '([ti])a$'                       , 'gi' ),
      analyses  : new RegExp( '((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$','gi' ),
      hives     : new RegExp( '(hi|ti)ves$'                    , 'gi' ),
      curves    : new RegExp( '(curve)s$'                      , 'gi' ),
      lrves     : new RegExp( '([lr])ves$'                     , 'gi' ),
      aves      : new RegExp( '([a])ves$'                      , 'gi' ),
      foves     : new RegExp( '([^fo])ves$'                    , 'gi' ),
      movies    : new RegExp( '(m)ovies$'                      , 'gi' ),
      aeiouyies : new RegExp( '([^aeiouy]|qu)ies$'             , 'gi' ),
      series    : new RegExp( '(s)eries$'                      , 'gi' ),
      xes       : new RegExp( '(x|ch|ss|sh)es$'                , 'gi' ),
      mice      : new RegExp( '([m|l])ice$'                    , 'gi' ),
      buses     : new RegExp( '(bus)es$'                       , 'gi' ),
      oes       : new RegExp( '(o)es$'                         , 'gi' ),
      shoes     : new RegExp( '(shoe)s$'                       , 'gi' ),
      crises    : new RegExp( '(cris|ax|test)es$'              , 'gi' ),
      octopi    : new RegExp( '(octop|vir)i$'                  , 'gi' ),
      aliases   : new RegExp( '(alias|canvas|status|campus)es$', 'gi' ),
      summonses : new RegExp( '^(summons)es$'                  , 'gi' ),
      oxen      : new RegExp( '^(ox)en'                        , 'gi' ),
      matrices  : new RegExp( '(matr)ices$'                    , 'gi' ),
      vertices  : new RegExp( '(vert|ind)ices$'                , 'gi' ),
      feet      : new RegExp( '^feet$'                         , 'gi' ),
      teeth     : new RegExp( '^teeth$'                        , 'gi' ),
      geese     : new RegExp( '^geese$'                        , 'gi' ),
      quizzes   : new RegExp( '(quiz)zes$'                     , 'gi' ),
      whereases : new RegExp( '^(whereas)es$'                  , 'gi' ),
      criteria  : new RegExp( '^(criteri)a$'                   , 'gi' ),
      genera    : new RegExp( '^genera$'                       , 'gi' ),
      ss        : new RegExp( 'ss$'                            , 'gi' ),
      s         : new RegExp( 's$'                             , 'gi' )
    },

    singular : {
      man       : new RegExp( '^(m|wom)an$'                  , 'gi' ),
      person    : new RegExp( '(pe)rson$'                    , 'gi' ),
      child     : new RegExp( '(child)$'                     , 'gi' ),
      ox        : new RegExp( '^(ox)$'                       , 'gi' ),
      axis      : new RegExp( '(ax|test)is$'                 , 'gi' ),
      octopus   : new RegExp( '(octop|vir)us$'               , 'gi' ),
      alias     : new RegExp( '(alias|status|canvas|campus)$', 'gi' ),
      summons   : new RegExp( '^(summons)$'                  , 'gi' ),
      bus       : new RegExp( '(bu)s$'                       , 'gi' ),
      buffalo   : new RegExp( '(buffal|tomat|potat)o$'       , 'gi' ),
      tium      : new RegExp( '([ti])um$'                    , 'gi' ),
      sis       : new RegExp( 'sis$'                         , 'gi' ),
      ffe       : new RegExp( '(?:([^f])fe|([lr])f)$'        , 'gi' ),
      hive      : new RegExp( '(hi|ti)ve$'                   , 'gi' ),
      aeiouyy   : new RegExp( '([^aeiouy]|qu)y$'             , 'gi' ),
      x         : new RegExp( '(x|ch|ss|sh)$'                , 'gi' ),
      matrix    : new RegExp( '(matr)ix$'                    , 'gi' ),
      vertex    : new RegExp( '(vert|ind)ex$'                , 'gi' ),
      mouse     : new RegExp( '([m|l])ouse$'                 , 'gi' ),
      foot      : new RegExp( '^foot$'                       , 'gi' ),
      tooth     : new RegExp( '^tooth$'                      , 'gi' ),
      goose     : new RegExp( '^goose$'                      , 'gi' ),
      quiz      : new RegExp( '(quiz)$'                      , 'gi' ),
      whereas   : new RegExp( '^(whereas)$'                  , 'gi' ),
      criterion : new RegExp( '^(criteri)on$'                , 'gi' ),
      genus     : new RegExp( '^genus$'                      , 'gi' ),
      s         : new RegExp( 's$'                           , 'gi' ),
      common    : new RegExp( '$'                            , 'gi' )
    }
  };

  var plural_rules = [

    // do not replace if its already a plural word
    [ regex.plural.men       ],
    [ regex.plural.people    ],
    [ regex.plural.children  ],
    [ regex.plural.tia       ],
    [ regex.plural.analyses  ],
    [ regex.plural.hives     ],
    [ regex.plural.curves    ],
    [ regex.plural.lrves     ],
    [ regex.plural.foves     ],
    [ regex.plural.aeiouyies ],
    [ regex.plural.series    ],
    [ regex.plural.movies    ],
    [ regex.plural.xes       ],
    [ regex.plural.mice      ],
    [ regex.plural.buses     ],
    [ regex.plural.oes       ],
    [ regex.plural.shoes     ],
    [ regex.plural.crises    ],
    [ regex.plural.octopi    ],
    [ regex.plural.aliases   ],
    [ regex.plural.summonses ],
    [ regex.plural.oxen      ],
    [ regex.plural.matrices  ],
    [ regex.plural.feet      ],
    [ regex.plural.teeth     ],
    [ regex.plural.geese     ],
    [ regex.plural.quizzes   ],
    [ regex.plural.whereases ],
    [ regex.plural.criteria  ],
    [ regex.plural.genera    ],

    // original rule
    [ regex.singular.man      , '$1en' ],
    [ regex.singular.person   , '$1ople' ],
    [ regex.singular.child    , '$1ren' ],
    [ regex.singular.ox       , '$1en' ],
    [ regex.singular.axis     , '$1es' ],
    [ regex.singular.octopus  , '$1i' ],
    [ regex.singular.alias    , '$1es' ],
    [ regex.singular.summons  , '$1es' ],
    [ regex.singular.bus      , '$1ses' ],
    [ regex.singular.buffalo  , '$1oes' ],
    [ regex.singular.tium     , '$1a' ],
    [ regex.singular.sis      , 'ses' ],
    [ regex.singular.ffe      , '$1$2ves' ],
    [ regex.singular.hive     , '$1ves' ],
    [ regex.singular.aeiouyy  , '$1ies' ],
    [ regex.singular.matrix   , '$1ices' ],
    [ regex.singular.vertex   , '$1ices' ],
    [ regex.singular.x        , '$1es' ],
    [ regex.singular.mouse    , '$1ice' ],
    [ regex.singular.foot     , 'feet' ],
    [ regex.singular.tooth    , 'teeth' ],
    [ regex.singular.goose    , 'geese' ],
    [ regex.singular.quiz     , '$1zes' ],
    [ regex.singular.whereas  , '$1es' ],
    [ regex.singular.criterion, '$1a' ],
    [ regex.singular.genus    , 'genera' ],

    [ regex.singular.s     , 's' ],
    [ regex.singular.common, 's' ]
  ];

  /**
   * @description These rules translate from the plural form of a noun to its singular form.
   * @private
   */
  var singular_rules = [

    // do not replace if its already a singular word
    [ regex.singular.man     ],
    [ regex.singular.person  ],
    [ regex.singular.child   ],
    [ regex.singular.ox      ],
    [ regex.singular.axis    ],
    [ regex.singular.octopus ],
    [ regex.singular.alias   ],
    [ regex.singular.summons ],
    [ regex.singular.bus     ],
    [ regex.singular.buffalo ],
    [ regex.singular.tium    ],
    [ regex.singular.sis     ],
    [ regex.singular.ffe     ],
    [ regex.singular.hive    ],
    [ regex.singular.aeiouyy ],
    [ regex.singular.x       ],
    [ regex.singular.matrix  ],
    [ regex.singular.mouse   ],
    [ regex.singular.foot    ],
    [ regex.singular.tooth   ],
    [ regex.singular.goose   ],
    [ regex.singular.quiz    ],
    [ regex.singular.whereas ],
    [ regex.singular.criterion ],
    [ regex.singular.genus ],

    // original rule
    [ regex.plural.men      , '$1an' ],
    [ regex.plural.people   , '$1rson' ],
    [ regex.plural.children , '$1' ],
    [ regex.plural.genera   , 'genus'],
    [ regex.plural.criteria , '$1on'],
    [ regex.plural.tia      , '$1um' ],
    [ regex.plural.analyses , '$1$2sis' ],
    [ regex.plural.hives    , '$1ve' ],
    [ regex.plural.curves   , '$1' ],
    [ regex.plural.lrves    , '$1f' ],
    [ regex.plural.aves     , '$1ve' ],
    [ regex.plural.foves    , '$1fe' ],
    [ regex.plural.movies   , '$1ovie' ],
    [ regex.plural.aeiouyies, '$1y' ],
    [ regex.plural.series   , '$1eries' ],
    [ regex.plural.xes      , '$1' ],
    [ regex.plural.mice     , '$1ouse' ],
    [ regex.plural.buses    , '$1' ],
    [ regex.plural.oes      , '$1' ],
    [ regex.plural.shoes    , '$1' ],
    [ regex.plural.crises   , '$1is' ],
    [ regex.plural.octopi   , '$1us' ],
    [ regex.plural.aliases  , '$1' ],
    [ regex.plural.summonses, '$1' ],
    [ regex.plural.oxen     , '$1' ],
    [ regex.plural.matrices , '$1ix' ],
    [ regex.plural.vertices , '$1ex' ],
    [ regex.plural.feet     , 'foot' ],
    [ regex.plural.teeth    , 'tooth' ],
    [ regex.plural.geese    , 'goose' ],
    [ regex.plural.quizzes  , '$1' ],
    [ regex.plural.whereases, '$1' ],

    [ regex.plural.ss, 'ss' ],
    [ regex.plural.s , '' ]
  ];

  /**
   * @description This is a list of words that should not be capitalized for title case.
   * @private
   */
  var non_titlecased_words = [
    'and', 'or', 'nor', 'a', 'an', 'the', 'so', 'but', 'to', 'of', 'at','by',
    'from', 'into', 'on', 'onto', 'off', 'out', 'in', 'over', 'with', 'for'
  ];

  /**
   * @description These are regular expressions used for converting between String formats.
   * @private
   */
  var id_suffix         = new RegExp( '(_ids|_id)$', 'g' );
  var underbar          = new RegExp( '_', 'g' );
  var space_or_underbar = new RegExp( '[\ _]', 'g' );
  var uppercase         = new RegExp( '([A-Z])', 'g' );
  var underbar_prefix   = new RegExp( '^_' );

  var inflector = {

  /**
   * A helper method that applies rules based replacement to a String.
   * @private
   * @function
   * @param {String} str String to modify and return based on the passed rules.
   * @param {Array: [RegExp, String]} rules Regexp to match paired with String to use for replacement
   * @param {Array: [String]} skip Strings to skip if they match
   * @param {String} override String to return as though this method succeeded (used to conform to APIs)
   * @returns {String} Return passed String modified by passed rules.
   * @example
   *
   *     this._apply_rules( 'cows', singular_rules ); // === 'cow'
   */
    _apply_rules : function ( str, rules, skip, override ){
      if( override ){
        str = override;
      }else{
        var ignore = ( inflector.indexOf( skip, str.toLowerCase()) > -1 );

        if( !ignore ){
          var i = 0;
          var j = rules.length;

          for( ; i < j; i++ ){
            if( str.match( rules[ i ][ 0 ])){
              if( rules[ i ][ 1 ] !== undefined ){
                str = str.replace( rules[ i ][ 0 ], rules[ i ][ 1 ]);
              }
              break;
            }
          }
        }
      }

      return str;
    },



  /**
   * This lets us detect if an Array contains a given element.
   * @public
   * @function
   * @param {Array} arr The subject array.
   * @param {Object} item Object to locate in the Array.
   * @param {Number} from_index Starts checking from this position in the Array.(optional)
   * @param {Function} compare_func Function used to compare Array item vs passed item.(optional)
   * @returns {Number} Return index position in the Array of the passed item.
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.indexOf([ 'hi','there' ], 'guys' ); // === -1
   *     inflection.indexOf([ 'hi','there' ], 'hi' ); // === 0
   */
    indexOf : function ( arr, item, from_index, compare_func ){
      if( !from_index ){
        from_index = -1;
      }

      var index = -1;
      var i     = from_index;
      var j     = arr.length;

      for( ; i < j; i++ ){
        if( arr[ i ]  === item || compare_func && compare_func( arr[ i ], item )){
          index = i;
          break;
        }
      }

      return index;
    },



  /**
   * This function adds pluralization support to every String object.
   * @public
   * @function
   * @param {String} str The subject string.
   * @param {String} plural Overrides normal output with said String.(optional)
   * @returns {String} Singular English language nouns are returned in plural form.
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.pluralize( 'person' ); // === 'people'
   *     inflection.pluralize( 'octopus' ); // === 'octopi'
   *     inflection.pluralize( 'Hat' ); // === 'Hats'
   *     inflection.pluralize( 'person', 'guys' ); // === 'guys'
   */
    pluralize : function ( str, plural ){
      return inflector._apply_rules( str, plural_rules, uncountable_words, plural );
    },



  /**
   * This function adds singularization support to every String object.
   * @public
   * @function
   * @param {String} str The subject string.
   * @param {String} singular Overrides normal output with said String.(optional)
   * @returns {String} Plural English language nouns are returned in singular form.
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.singularize( 'people' ); // === 'person'
   *     inflection.singularize( 'octopi' ); // === 'octopus'
   *     inflection.singularize( 'Hats' ); // === 'Hat'
   *     inflection.singularize( 'guys', 'person' ); // === 'person'
   */
    singularize : function ( str, singular ){
      return inflector._apply_rules( str, singular_rules, uncountable_words, singular );
    },


  /**
   * This function will pluralize or singularlize a String appropriately based on an integer value
   * @public
   * @function
   * @param {String} str The subject string.
   * @param {Number} count The number to base pluralization off of.
   * @param {String} singular Overrides normal output with said String.(optional)
   * @param {String} plural Overrides normal output with said String.(optional)
   * @returns {String} English language nouns are returned in the plural or singular form based on the count.
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.inflect( 'people' 1 ); // === 'person'
   *     inflection.inflect( 'octopi' 1 ); // === 'octopus'
   *     inflection.inflect( 'Hats' 1 ); // === 'Hat'
   *     inflection.inflect( 'guys', 1 , 'person' ); // === 'person'
   *     inflection.inflect( 'person', 2 ); // === 'people'
   *     inflection.inflect( 'octopus', 2 ); // === 'octopi'
   *     inflection.inflect( 'Hat', 2 ); // === 'Hats'
   *     inflection.inflect( 'person', 2, null, 'guys' ); // === 'guys'
   */
    inflect : function ( str, count, singular, plural ){
      count = parseInt( count, 10 );

      if( isNaN( count )) return str;

      if( count === 0 || count > 1 ){
        return inflector._apply_rules( str, plural_rules, uncountable_words, plural );
      }else{
        return inflector._apply_rules( str, singular_rules, uncountable_words, singular );
      }
    },



  /**
   * This function adds camelization support to every String object.
   * @public
   * @function
   * @param {String} str The subject string.
   * @param {Boolean} low_first_letter Default is to capitalize the first letter of the results.(optional)
   *                                 Passing true will lowercase it.
   * @returns {String} Lower case underscored words will be returned in camel case.
   *                  additionally '/' is translated to '::'
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.camelize( 'message_properties' ); // === 'MessageProperties'
   *     inflection.camelize( 'message_properties', true ); // === 'messageProperties'
   */
    camelize : function ( str, low_first_letter ){
      var str_path = str.split( '/' );
      var i        = 0;
      var j        = str_path.length;
      var str_arr, init_x, k, l, first;

      for( ; i < j; i++ ){
        str_arr = str_path[ i ].split( '_' );
        k       = 0;
        l       = str_arr.length;

        for( ; k < l; k++ ){
          if( k !== 0 ){
            str_arr[ k ] = str_arr[ k ].toLowerCase();
          }

          first = str_arr[ k ].charAt( 0 );
          first = low_first_letter && i === 0 && k === 0
            ? first.toLowerCase() : first.toUpperCase();
          str_arr[ k ] = first + str_arr[ k ].substring( 1 );
        }

        str_path[ i ] = str_arr.join( '' );
      }

      return str_path.join( '::' );
    },



  /**
   * This function adds underscore support to every String object.
   * @public
   * @function
   * @param {String} str The subject string.
   * @param {Boolean} all_upper_case Default is to lowercase and add underscore prefix.(optional)
   *                  Passing true will return as entered.
   * @returns {String} Camel cased words are returned as lower cased and underscored.
   *                  additionally '::' is translated to '/'.
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.underscore( 'MessageProperties' ); // === 'message_properties'
   *     inflection.underscore( 'messageProperties' ); // === 'message_properties'
   *     inflection.underscore( 'MP', true ); // === 'MP'
   */
    underscore : function ( str, all_upper_case ){
      if( all_upper_case && str === str.toUpperCase()) return str;

      var str_path = str.split( '::' );
      var i        = 0;
      var j        = str_path.length;

      for( ; i < j; i++ ){
        str_path[ i ] = str_path[ i ].replace( uppercase, '_$1' );
        str_path[ i ] = str_path[ i ].replace( underbar_prefix, '' );
      }

      return str_path.join( '/' ).toLowerCase();
    },



  /**
   * This function adds humanize support to every String object.
   * @public
   * @function
   * @param {String} str The subject string.
   * @param {Boolean} low_first_letter Default is to capitalize the first letter of the results.(optional)
   *                                 Passing true will lowercase it.
   * @returns {String} Lower case underscored words will be returned in humanized form.
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.humanize( 'message_properties' ); // === 'Message properties'
   *     inflection.humanize( 'message_properties', true ); // === 'message properties'
   */
    humanize : function ( str, low_first_letter ){
      str = str.toLowerCase();
      str = str.replace( id_suffix, '' );
      str = str.replace( underbar, ' ' );

      if( !low_first_letter ){
        str = inflector.capitalize( str );
      }

      return str;
    },



  /**
   * This function adds capitalization support to every String object.
   * @public
   * @function
   * @param {String} str The subject string.
   * @returns {String} All characters will be lower case and the first will be upper.
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.capitalize( 'message_properties' ); // === 'Message_properties'
   *     inflection.capitalize( 'message properties', true ); // === 'Message properties'
   */
    capitalize : function ( str ){
      str = str.toLowerCase();

      return str.substring( 0, 1 ).toUpperCase() + str.substring( 1 );
    },



  /**
   * This function replaces underscores with dashes in the string.
   * @public
   * @function
   * @param {String} str The subject string.
   * @returns {String} Replaces all spaces or underscores with dashes.
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.dasherize( 'message_properties' ); // === 'message-properties'
   *     inflection.dasherize( 'Message Properties' ); // === 'Message-Properties'
   */
    dasherize : function ( str ){
      return str.replace( space_or_underbar, '-' );
    },



  /**
   * This function adds titleize support to every String object.
   * @public
   * @function
   * @param {String} str The subject string.
   * @returns {String} Capitalizes words as you would for a book title.
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.titleize( 'message_properties' ); // === 'Message Properties'
   *     inflection.titleize( 'message properties to keep' ); // === 'Message Properties to Keep'
   */
    titleize : function ( str ){
      str         = str.toLowerCase().replace( underbar, ' ' );
      var str_arr = str.split( ' ' );
      var i       = 0;
      var j       = str_arr.length;
      var d, k, l;

      for( ; i < j; i++ ){
        d = str_arr[ i ].split( '-' );
        k = 0;
        l = d.length;

        for( ; k < l; k++){
          if( inflector.indexOf( non_titlecased_words, d[ k ].toLowerCase()) < 0 ){
            d[ k ] = inflector.capitalize( d[ k ]);
          }
        }

        str_arr[ i ] = d.join( '-' );
      }

      str = str_arr.join( ' ' );
      str = str.substring( 0, 1 ).toUpperCase() + str.substring( 1 );

      return str;
    },



  /**
   * This function adds demodulize support to every String object.
   * @public
   * @function
   * @param {String} str The subject string.
   * @returns {String} Removes module names leaving only class names.(Ruby style)
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.demodulize( 'Message::Bus::Properties' ); // === 'Properties'
   */
    demodulize : function ( str ){
      var str_arr = str.split( '::' );

      return str_arr[ str_arr.length - 1 ];
    },



  /**
   * This function adds tableize support to every String object.
   * @public
   * @function
   * @param {String} str The subject string.
   * @returns {String} Return camel cased words into their underscored plural form.
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.tableize( 'MessageBusProperty' ); // === 'message_bus_properties'
   */
    tableize : function ( str ){
      str = inflector.underscore( str );
      str = inflector.pluralize( str );

      return str;
    },



  /**
   * This function adds classification support to every String object.
   * @public
   * @function
   * @param {String} str The subject string.
   * @returns {String} Underscored plural nouns become the camel cased singular form.
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.classify( 'message_bus_properties' ); // === 'MessageBusProperty'
   */
    classify : function ( str ){
      str = inflector.camelize( str );
      str = inflector.singularize( str );

      return str;
    },



  /**
   * This function adds foreign key support to every String object.
   * @public
   * @function
   * @param {String} str The subject string.
   * @param {Boolean} drop_id_ubar Default is to seperate id with an underbar at the end of the class name,
                                 you can pass true to skip it.(optional)
   * @returns {String} Underscored plural nouns become the camel cased singular form.
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.foreign_key( 'MessageBusProperty' ); // === 'message_bus_property_id'
   *     inflection.foreign_key( 'MessageBusProperty', true ); // === 'message_bus_propertyid'
   */
    foreign_key : function ( str, drop_id_ubar ){
      str = inflector.demodulize( str );
      str = inflector.underscore( str ) + (( drop_id_ubar ) ? ( '' ) : ( '_' )) + 'id';

      return str;
    },



  /**
   * This function adds ordinalize support to every String object.
   * @public
   * @function
   * @param {String} str The subject string.
   * @returns {String} Return all found numbers their sequence like '22nd'.
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.ordinalize( 'the 1 pitch' ); // === 'the 1st pitch'
   */
    ordinalize : function ( str ){
      var str_arr = str.split( ' ' );
      var i       = 0;
      var j       = str_arr.length;

      for( ; i < j; i++ ){
        var k = parseInt( str_arr[ i ], 10 );

        if( !isNaN( k )){
          var ltd = str_arr[ i ].substring( str_arr[ i ].length - 2 );
          var ld  = str_arr[ i ].substring( str_arr[ i ].length - 1 );
          var suf = 'th';

          if( ltd != '11' && ltd != '12' && ltd != '13' ){
            if( ld === '1' ){
              suf = 'st';
            }else if( ld === '2' ){
              suf = 'nd';
            }else if( ld === '3' ){
              suf = 'rd';
            }
          }

          str_arr[ i ] += suf;
        }
      }

      return str_arr.join( ' ' );
    },

  /**
   * This function performs multiple inflection methods on a string
   * @public
   * @function
   * @param {String} str The subject string.
   * @param {Array} arr An array of inflection methods.
   * @returns {String}
   * @example
   *
   *     var inflection = require( 'inflection' );
   *
   *     inflection.transform( 'all job', [ 'pluralize', 'capitalize', 'dasherize' ]); // === 'All-jobs'
   */
    transform : function ( str, arr ){
      var i = 0;
      var j = arr.length;

      for( ;i < j; i++ ){
        var method = arr[ i ];

        if( inflector.hasOwnProperty( method )){
          str = inflector[ method ]( str );
        }
      }

      return str;
    }
  };

/**
 * @public
 */
  inflector.version = '1.12.0';

  return inflector;
}));


/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

module.exports = {
		contextContent: function contextContent() {
				if (this.props.page_type == '503') {
						if (this.props.has_status_page == 'no') {
								return React.createElement(
										'p',
										null,
										'Go back to the previous page and try again.',
										React.createElement('br', null),
										'If you think something is broken, report a problem.'
								);
						} else if (this.props.has_status_page == 'non-customer') {
								return React.createElement(
										'p',
										null,
										'Check our status page for more information. Report a problem if you think we are unaware of the issue.'
								);
						} else {
								return React.createElement(
										'p',
										null,
										'Our status page is currently reporting a status of ',
										React.createElement(
												'strong',
												{ id: 'replace-with-fetched-data' },
												React.createElement(
														'em',
														null,
														'will fetch from status page...'
												)
										),
										'.'
								);
						}
				} else if (this.props.page_type == 'maintenance') {
						if (this.props.has_status_page == 'no') {
								return React.createElement(
										'p',
										null,
										'Sorry for the inconvenience. We\u2019ll be back up and running as fast as possible.'
								);
						} else if (this.props.has_status_page == 'non-customer') {
								return React.createElement(
										'div',
										null,
										React.createElement(
												'p',
												null,
												'Sorry for the inconvenience. We\u2019ll be back up and running as fast as possible.'
										),
										React.createElement(
												'p',
												null,
												'Check our status page for more information.'
										)
								);
						} else {
								return React.createElement(
										'div',
										null,
										React.createElement(
												'p',
												null,
												'This scheduled maintenance period is for ',
												React.createElement('br', null),
												React.createElement(
														'span',
														{ id: 'replace-with-fetched-data' },
														React.createElement(
																'em',
																null,
																'will fetch maintenance period...'
														)
												)
										),
										React.createElement(
												'p',
												null,
												'Check our status page for more information.'
										)
								);
						}
				}
		}
};

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var cx = __webpack_require__(20);
var _ = __webpack_require__(47);
var ControlGroup = __webpack_require__(654);

var label = __webpack_require__(248).label;

var TextArea = function (_React$Component) {
  _inherits(TextArea, _React$Component);

  function TextArea(props) {
    _classCallCheck(this, TextArea);

    var _this = _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call(this, props));

    _this.displayName = 'TextArea';
    return _this;
  }

  _createClass(TextArea, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        ControlGroup,
        { className: this.props.className, style: this.props.style, label: this.props.label, helpBlockText: this.props.helpBlockText },
        React.createElement('textarea', { className: this.props.textareaClass,
          name: this.props.name,
          value: this.props.value,
          defaultValue: this.props.defaultValue,
          onChange: this.props.onChange,
          required: this.props.required,
          placeholder: this.props.placeholder,
          style: _.merge({ width: '100%' }, this.props.textareaStyle) })
      );
    }
  }]);

  return TextArea;
}(React.Component);

TextArea.defaultProps = {
  required: false,
  placeholder: null
};

module.exports = TextArea;

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  MODAL_PREFIX: 'modal-confirmation-'
};

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./app/javascript/utils/string_utils.ts
function underScore(input) {
    var result = input.replace(/([A-Z])/g, function ($1) { return ("_" + $1).toLowerCase(); });
    if (result.startsWith('_')) {
        result = result.substr(1);
    }
    return result;
}

// CONCATENATED MODULE: ./app/javascript/components/form.tsx
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var form_Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Form.prototype, "method", {
        get: function () {
            if (['put', 'patch'].includes(this.props.method.toLowerCase())) {
                return 'post';
            }
            return this.props.method;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Form, "authenticityToken", {
        get: function () {
            var tags = document.getElementsByTagName('meta');
            for (var i = 0; i < tags.length; i += 1) {
                var tag = tags[i];
                if (tag.name === 'csrf-token') {
                    return tag.content;
                }
            }
            return;
        },
        enumerable: true,
        configurable: true
    });
    Form.prototype.appendFor = function (inputs) {
        var form_for = underScore(this.props.for);
        Array.from(inputs).forEach(function (input) {
            if (!['utf8', '_method', 'authenticity_token'].includes(input.name) &&
                input.type !== 'submit') {
                input.name = form_for + "[" + input.name + "]";
            }
        });
    };
    Form.prototype.updateInputNames = function () {
        if (this.props.skipPrepend || !this.props.for || !this.form) {
            return;
        }
        this.appendFor(this.form.getElementsByTagName('input'));
        this.appendFor(this.form.getElementsByTagName('select'));
        this.appendFor(this.form.getElementsByTagName('textarea'));
    };
    Form.prototype.componentDidMount = function () {
        this.updateInputNames();
    };
    Form.prototype.render = function () {
        var _this = this;
        return (react["createElement"]("form", { ref: function (ref) { return ref && (_this.form = ref); }, action: this.props.action, method: this.method, onSubmit: this.props.onSubmit, acceptCharset: "UTF-8", className: this.props.className, id: this.props.id },
            react["createElement"]("input", { type: "hidden", name: "utf8", value: "\u0213" }),
            react["createElement"]("input", { type: "hidden", name: "_method", value: this.props.method }),
            react["createElement"]("input", { type: "hidden", name: "authenticity_token", value: Form.authenticityToken }),
            this.props.children));
    };
    Form.defaultProps = {
        method: 'POST',
        onSubmit: function () { },
    };
    return Form;
}(react["Component"]));
/* harmony default export */ var components_form = __webpack_exports__["default"] = (form_Form);


/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1183);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _color = __webpack_require__(342);

var _color2 = _interopRequireDefault(_color);

var _lodash = __webpack_require__(47);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createReactClass = __webpack_require__(51);
module.exports = createReactClass({
  displayName: 'exports',
  componentDidMount: function componentDidMount() {
    var initialized = false;
    this.$input = $(this.refs.input);
    this.$input.minicolors({
      theme: 'bootstrap',
      position: this.props.position || 'left',
      opacity: this.props.opacity ? this.props.opacity : false,
      letterCase: 'uppercase',
      change: function () {
        if (!initialized) return;
        var color = new _color2.default(this.$input.minicolors('rgbObject'));
        if (color) {
          this.props.onChange({ target: { value: color.toRgba() }, preventDefault: function preventDefault() {}
          });
        }
      }.bind(this)
    });
    var defaultValue = new _color2.default(this.props.defaultValue);
    this.$input.minicolors('opacity', defaultValue.a);
    this.$input.minicolors('value', defaultValue.toHex());
    initialized = true;
  },
  componentWillUnmount: function componentWillUnmount() {
    this.$input.minicolors('destroy');
  },
  manualEntry: function manualEntry(event) {
    this.lazyUpdate(event.target.value);
    event.preventDefault();
  },


  lazyUpdate: _lodash2.default.debounce(function (value) {
    var color = new _color2.default(value);
    if (color) {
      this.$input.minicolors('opacity', color.a);
      this.$input.minicolors('value', color.toHex());
    }
  }, 600),

  render: function render() {
    var classes = ['control-group color-control'];
    if (this.props.className) {
      classes.push(this.props.className);
    }
    return _react2.default.createElement(
      'div',
      { className: classes.join(' '), style: this.props.style },
      _react2.default.createElement(
        'label',
        null,
        this.props.label
      ),
      _react2.default.createElement(
        'div',
        { className: 'controls' },
        _react2.default.createElement('input', { ref: 'input', type: 'text', name: this.props.name, onChange: this.manualEntry, defaultValue: this.props.defaultValue })
      )
    );
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(26);
var ReactDOMServer = __webpack_require__(251);

var cx = __webpack_require__(20);
var Loading = __webpack_require__(625);

var MIN_SEARCH_LENGTH = 3;

var ESSearchField = function (_React$Component) {
  _inherits(ESSearchField, _React$Component);

  /**
   * @param props See PropTypes for optional and required properties.
   */
  function ESSearchField(props) {
    _classCallCheck(this, ESSearchField);

    var _this = _possibleConstructorReturn(this, (ESSearchField.__proto__ || Object.getPrototypeOf(ESSearchField)).call(this, props));

    _this.searchSource = _this._createSearchSource(props.queryUrl);
    _this.state = {
      error: false,
      inputActive: false,
      menuOpen: false,
      commandKeyPressed: false,
      showDeleteButton: false
    };
    return _this;
  }

  // Create search source based on url


  _createClass(ESSearchField, [{
    key: '_createSearchSource',
    value: function _createSearchSource(url) {
      return new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
          url: url,
          wildcard: '%QUERY',
          transport: this._transport.bind(this)
        } });
    }
  }, {
    key: '_transport',
    value: function _transport(options, onSuccess, onError) {
      var _this2 = this;

      var done = function done(data, textStatus, request) {
        if (_this2.state.error) {
          _this2.setState({ error: false }, onSuccess.bind(_this2, data));
        } else {
          onSuccess(data);
        }
      };

      var fail = function fail(request, textStatus, errorThrown) {
        _this2.setState({ error: true }, onError.bind(_this2, errorThrown));
      };

      this._request(options, done, fail);
    }
  }, {
    key: '_request',
    value: function _request(options, done, fail) {
      this.props.loadResults({ url: options.url }).then(done).catch(fail);
    }
  }, {
    key: '_getTypeahead',
    value: function _getTypeahead() {
      return $(ReactDOM.findDOMNode(this)).find('#es-search-field');
    }
  }, {
    key: '_clearField',
    value: function _clearField() {
      var $typeahead = this._getTypeahead();
      $typeahead.typeahead('val', '');
    }

    // HTML string for a loading screen

  }, {
    key: '_loadingScreen',
    value: function _loadingScreen() {
      return ReactDOMServer.renderToString(React.createElement(Loading, { loading: true }));
    }
  }, {
    key: '_noResultOrError',
    value: function _noResultOrError() {
      if (this.state.error) {
        return this._onError();
      } else {
        return this._noResults();
      }
    }

    // HTML string for when no results are found

  }, {
    key: '_noResults',
    value: function _noResults() {
      return ReactDOMServer.renderToString(React.createElement(NoResults, null));
    }

    // HTML string for errors

  }, {
    key: '_onError',
    value: function _onError() {
      return ReactDOMServer.renderToString(React.createElement(ErrorState, null));
    }

    // Typeahead "open" event is not realiable
    // Check the num characters someone has typed in and
    // add "open" class when min search length has been met

  }, {
    key: '_checkInputField',
    value: function _checkInputField(event) {
      var showDeleteButton = event.target.value.length > 0;
      var menuOpen = event.target.value.length >= MIN_SEARCH_LENGTH;
      this.setState({ showDeleteButton: showDeleteButton, menuOpen: menuOpen });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      var $typeahead = this._getTypeahead();

      $typeahead.typeahead({
        minLength: MIN_SEARCH_LENGTH,
        highlight: false,
        classNames: {
          hint: "es-hint",
          highlight: "es-highlight",
          menu: "es-menu",
          cursor: "es-cursor"
        }
      }, {
        // HACK bug in typeahead causes limit rendering issues, PR opened but maintainer unresponsive
        limit: 1000,

        name: this.props.pluralizedResultName,
        source: this.searchSource,
        display: function display(suggestion) {
          return $typeahead.typeahead('val');
        },
        templates: {
          suggestion: this.props.template,
          pending: this._loadingScreen(),
          notFound: this._noResultOrError.bind(this)
        }
      }).on('typeahead:select', function (event, suggestion) {
        var url = _this3.props.mapResultToUiUrl(suggestion);
        if (_this3.state.commandKeyPressed) {
          window.open(url, '_blank');
          $('.es-menu').show();
        } else {
          window.location = url;
        }
      })

      // Style typeahead when active
      .on('typeahead:active', function () {
        _this3.setState({ inputActive: true });
      }).on('typeahead:idle', function () {
        _this3.setState({ inputActive: false });
      }).on('typeahead:close', function () {
        if (_this3.state.commandKeyPressed) {
          $('.es-menu').show();
        }
        _this3.setState({ menuOpen: false });
      });

      // Forward slash search focus
      $(window).keyup(function (event) {
        if (_this3._getCharCode(event) === 191 && event.target.type !== "text") {
          $('#es-search-field').focus();
        }
      });
    }
  }, {
    key: '_captureKeyDown',
    value: function _captureKeyDown(event) {
      if (this._isCommandClick(event)) {
        this.setState({ commandKeyPressed: true });
      }
    }
  }, {
    key: '_captureKeyUp',
    value: function _captureKeyUp(event) {
      if (this._isCommandClick(event)) {
        this.setState({ commandKeyPressed: false });
      }
    }
  }, {
    key: '_isCommandClick',
    value: function _isCommandClick(event) {
      var code = this._getCharCode(event);
      return code === 91 || code === 17;
    }
  }, {
    key: '_loseFocus',
    value: function _loseFocus(event) {
      $('.es-menu').hide();
      this.setState({ menuOpen: false });
    }

    // Cross browser supported key code getter

  }, {
    key: '_getCharCode',
    value: function _getCharCode(e) {
      return typeof e.which == "number" ? e.which : e.keyCode;
    }
  }, {
    key: 'render',
    value: function render() {
      var activeClass = this.state.inputActive ? "active" : "";
      var openClass = this.state.menuOpen ? "open" : "";

      var magClass = cx("mag-glass fa fa-search", activeClass);
      var inputClass = cx("typeahead form-control full-width", activeClass, openClass);

      return React.createElement(
        'div',
        { className: 'search-bar', style: { position: 'relative' },
          onKeyDown: this._captureKeyDown.bind(this),
          onKeyUp: this._captureKeyUp.bind(this),
          onBlur: this._loseFocus.bind(this) },
        React.createElement('i', { className: magClass }),
        React.createElement('i', { className: 'fa fa-times', onClick: this._clearField.bind(this), style: { display: this.state.showDeleteButton ? 'inline' : 'none' } }),
        React.createElement('input', { type: 'text',
          ref: 'input',
          id: 'es-search-field',
          className: inputClass,
          onKeyUp: this._checkInputField.bind(this),
          placeholder: 'Search' })
      );
    }
  }]);

  return ESSearchField;
}(React.Component);

ESSearchField.propTypes = {
  // The URL that will be hit to load search results. "%QUERY" will be replaced with the URL-escaped query string.
  // E.g. "/v1/pages/73nfvx10lnbd/subscribers.json?q=%QUERY&limit=10"
  queryUrl: _propTypes2.default.string.isRequired,

  // Pluralized lowercased name of the thing being searched for, used to apply CSS class for styling. E.g. "subscribers"
  pluralizedResultName: _propTypes2.default.string.isRequired,

  // Takes in an object of arguments and returns a promise which resolves to search results. Required options are:
  // * .url: specifies the URL which this function should hit to load search results.
  loadResults: _propTypes2.default.func.isRequired,

  // Takes in a search result and returns the URL for the UI view of that result
  mapResultToUiUrl: _propTypes2.default.func.isRequired,

  // Takes in a search result and returns the HTML string for how a search result should be rendered
  template: _propTypes2.default.func.isRequired
};

var ErrorState = function (_React$Component2) {
  _inherits(ErrorState, _React$Component2);

  function ErrorState() {
    _classCallCheck(this, ErrorState);

    return _possibleConstructorReturn(this, (ErrorState.__proto__ || Object.getPrototypeOf(ErrorState)).apply(this, arguments));
  }

  _createClass(ErrorState, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'no-results-area' },
        React.createElement(
          'p',
          null,
          '\uD83D\uDC79'
        ),
        React.createElement(
          'p',
          { className: 'error-text' },
          'There was an error completing your search.  Please try again later.'
        )
      );
    }
  }]);

  return ErrorState;
}(React.Component);

var NoResults = function (_React$Component3) {
  _inherits(NoResults, _React$Component3);

  function NoResults() {
    _classCallCheck(this, NoResults);

    return _possibleConstructorReturn(this, (NoResults.__proto__ || Object.getPrototypeOf(NoResults)).apply(this, arguments));
  }

  _createClass(NoResults, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'no-results-area' },
        React.createElement(
          'p',
          null,
          'No results found. Try keeping your search phrase more generic to get more results.'
        )
      );
    }
  }]);

  return NoResults;
}(React.Component);

module.exports = ESSearchField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @constant {Object} The map of fields to display indexed by the type of subscriber.
 */
var SUBSCRIBER_DISPLAY_FIELD_BY_TYPE = {
  sms: 'display_phone_number',
  email: 'email',
  webhook: 'endpoint'
};

/**
 * @constant {Array} The list of subscribers types of which the front-end is aware.
 */
var NOTIFICATION_TYPES = ['email', 'sms', 'webhook'];

/**
 * @constant {Object} The map of title-cased display strings indexed by the type of subscriber.
 */
var SUBSCRIBER_TITLE_DISPLAY_TYPE_BY_TYPE = {
  email: 'Email',
  sms: 'SMS',
  webhook: 'Webhook'
};

/**
 * @constant {Object} The map of sentence-cased display strings indexed by the type of subscriber.
 */
var SUBSCRIBER_SENTENCE_DISPLAY_TYPE_BY_TYPE = {
  email: 'email',
  sms: 'SMS',
  webhook: 'webhook'
};

/**
 * @constant {Object} The map of messages to display for an empty list of subscribers indexed by the type.
 */
var QUARANTINE_EMPTY_LIST_MESSAGE_BY_TYPE = {
  email: _react2.default.createElement(
    'span',
    null,
    'If we have any reason to believe an email address cannot be contacted, that subscriber will be put into a quarantine and can be found here.'
  ),
  sms: _react2.default.createElement(
    'span',
    null,
    'If we have any reason to believe a phone number cannot be reached by SMS, that subscriber will be put into a quarantine and can be found here.'
  ),
  webhook: _react2.default.createElement(
    'span',
    null,
    'If we have any reason to believe an endpoint is not reachable or is not successfully processing your webhook, the subscriber will be put into a quarantine and can be found here.'
  )
};

/**
 * Formats a subscriber type and a histogram of counts by type into a styled span.
 *
 * @example
 * // returns <span>Email <span class="subtle">(101)</span></span>
 * renderSubscriberTypeAndCount("email", "active", {"email":{"active":101,"unconfirmed":100,"quarantined":99,"total":300}});
 * @example
 * // returns <span>Webhook</span>
 * renderSubscriberTypeAndCount("webhook");
 * @param   {string} type The type of the subscriber to render.
 * @param   {Object} [counts] The histogram of counts by subscriber type.
 * @returns {ReactElement} The subscriber type and count rendered to displayable HTML.
 */

function renderSubscriberCount(type, state, counts) {
  if (counts && counts[type] !== undefined && counts[type][state] !== undefined) {
    return _react2.default.createElement(
      'span',
      { className: 'subtle' },
      ' (',
      counts[type][state],
      ')'
    );
  }
  return null;
}

var Notifications = {
  NOTIFICATION_TYPES: NOTIFICATION_TYPES,
  QUARANTINE_EMPTY_LIST_MESSAGE_BY_TYPE: QUARANTINE_EMPTY_LIST_MESSAGE_BY_TYPE,
  SUBSCRIBER_DISPLAY_FIELD_BY_TYPE: SUBSCRIBER_DISPLAY_FIELD_BY_TYPE,
  SUBSCRIBER_TITLE_DISPLAY_TYPE_BY_TYPE: SUBSCRIBER_TITLE_DISPLAY_TYPE_BY_TYPE,
  SUBSCRIBER_SENTENCE_DISPLAY_TYPE_BY_TYPE: SUBSCRIBER_SENTENCE_DISPLAY_TYPE_BY_TYPE,
  renderSubscriberCount: renderSubscriberCount
};

exports.default = Notifications;


module.exports = Notifications;

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscriber; });
var Subscriber;
(function (Subscriber) {
    function displayMode(subscriber) {
        switch (subscriber.mode) {
            case 'email':
                return 'Email';
            case 'sms':
                return 'SMS';
            case 'webhook':
                return 'Webhook';
        }
    }
    Subscriber.displayMode = displayMode;
    function identifier(subscriber) {
        switch (subscriber.mode) {
            case 'email':
                return subscriber.email;
            case 'sms':
                return subscriber.display_phone_number;
            case 'webhook':
                return subscriber.endpoint;
        }
    }
    Subscriber.identifier = identifier;
})(Subscriber || (Subscriber = {}));


/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(1140);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

function ErrorPage(container, pageType, templateName) {
  this.$container = $(container);
  this.$contentContainer = this.$container.find(templateName == 'sign' ? '.sign-container' : '.content-container');
  this.pageType = pageType;
  this.templateName = templateName;
}

ErrorPage.prototype.centerContent = function () {
  var containerHeight = this.$container.outerHeight(),
      contentContainerHeight = this.$contentContainer.outerHeight(),
      top = (containerHeight - contentContainerHeight) / 2,
      offset = this.templateName == 'sign' ? -100 : 0;

  // // console.log(this.$contentContainer[0]);
  // // console.log('containerHeight = ' + containerHeight)
  // // console.log('contentContainerHeight = ' + contentContainerHeight)
  // // console.log('top = ' + top)

  this.$contentContainer.css('top', top + offset);
};

ErrorPage.prototype.initialize = function () {
  var self = this;

  this.centerContent();
  this.$container.on('resize', function (e) {
    e.preventDefault();
    e.stopPropagation();
    self.centerContent();
  });

  // fades in content on the plain template
  if (this.templateName == 'plain') {
    window.setTimeout(function () {
      self.$contentContainer.addClass('in');
    }, 500);
  }

  // swings sign in on the sign template
  if (this.templateName == 'sign') {
    $('.sign-container').animate({ textIndent: 0 }, {
      step: function step(now) {
        $(this).css({
          transform: 'rotate(' + now + 'deg)',
          'transform-origin': 'top center'
        });
      },

      duration: 1000,
      easing: 'easeOutBounce'
    });
  }
};

ErrorPage.prototype.createTimeRangeTag = function (start, end) {
  return '<time utime=' + start + ' simple_format="MMM DD, YYYY HH:mm">' + start + '</time> - <time utime=' + end + ' simple_format="MMM DD, YYYY HH:mm">' + end + '</time>.';
};

ErrorPage.prototype.handleStatusFetchSuccess = function (pageType, data) {
  if (pageType == '503') {
    $('#replace-with-fetched-data').html(data.status.description);
  } else if (data.scheduled_maintenances.length) {
    var maint = data.scheduled_maintenances[0];
    $('#replace-with-fetched-data').html(this.createTimeRangeTag(maint.scheduled_for, maint.scheduled_until));
    $.fn.localizeTime();
  } else {
    $('#replace-with-fetched-data').html('<em>(there are no active scheduled maintenances)</em>');
  }
};

ErrorPage.prototype.handleStatusFetchFail = function (pageType) {
  $('#replace-with-fetched-data').html('<em>(enter a valid Statuspage url)</em>');
};

ErrorPage.prototype.fetchStatus = function (pageUrl, pageType) {
  // console.log('in app.js fetch');
  if (!pageUrl || !pageType || pageType == '404') return;

  var url = '',
      self = this;

  if (pageType == '503') {
    url = pageUrl + '/api/v2/status.json';
  } else {
    url = pageUrl + '/api/v2/scheduled-maintenances/active.json';
  }

  $.ajax({
    type: 'GET',
    url: url
  }).success(function (data, status) {
    // console.log('success');
    self.handleStatusFetchSuccess(pageType, data);
  }).fail(function (xhr, msg) {
    // console.log('fail');
    self.handleStatusFetchFail(pageType);
  });
};

if (true) {
  module.exports = ErrorPage;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var cssKeywords = __webpack_require__(622);

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in cssKeywords) {
	if (cssKeywords.hasOwnProperty(key)) {
		reverseKeywords[cssKeywords[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var v;

	if (max === 0) {
		s = 0;
	} else {
		s = (delta / max * 1000) / 10;
	}

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	v = ((max / 255) * 1000) / 10;

	return [h, s, v];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in cssKeywords) {
		if (cssKeywords.hasOwnProperty(keyword)) {
			var value = cssKeywords[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};


/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Loading;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Displays an animated SVG as a loading icon.
function Loading(props) {
  return _react2.default.createElement(
    'div',
    { className: props.className, style: { display: props.loading ? 'block' : 'none' } },
    _react2.default.createElement(
      'div',
      { className: 'loading-circle' },
      _react2.default.createElement(
        'div',
        { className: 'loader' },
        _react2.default.createElement(
          'svg',
          { className: 'circular', viewBox: '25 25 50 50' },
          _react2.default.createElement('circle', { className: 'path', cx: '50', cy: '50', r: '10', fill: 'none', strokeWidth: '2', strokeMiterlimit: '10' })
        )
      )
    )
  );
}

Loading.propTypes = {
  className: _propTypes2.default.string,
  loading: _propTypes2.default.bool
};

Loading.defaultProps = {
  className: '',
  loading: false
};

module.exports = Loading;

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var IncidentTemplateListItem = function (_React$Component) {
  _inherits(IncidentTemplateListItem, _React$Component);

  function IncidentTemplateListItem() {
    _classCallCheck(this, IncidentTemplateListItem);

    return _possibleConstructorReturn(this, (IncidentTemplateListItem.__proto__ || Object.getPrototypeOf(IncidentTemplateListItem)).apply(this, arguments));
  }

  _createClass(IncidentTemplateListItem, [{
    key: '_editLink',
    value: function _editLink() {
      return Routes.edit_page_incident_template_path(this.props.pageParam, this.props.template.id);
    }
  }, {
    key: '_handleDelete',
    value: function _handleDelete() {
      if (window.confirm('Are you sure you want to delete this template?')) {
        $.ajax({
          type: 'DELETE',
          url: Routes.page_incident_template_path(this.props.pageParam, this.props.template.id),
          dataType: 'JSON',
          success: function success(data, textStatus, xhr) {
            window.location.reload(true);
          },
          error: function error(xhr, textStatus) {
            HRB.utils.basicFailAndReload(xhr);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var template = this.props.template;

      return React.createElement(
        'div',
        null,
        React.createElement(
          'strong',
          null,
          template.name
        ),
        React.createElement(
          'span',
          { className: 'actions' },
          React.createElement(
            'a',
            { href: '#', method: 'DELETE', onClick: this._handleDelete.bind(this) },
            'Delete'
          ),
          React.createElement(
            'a',
            { href: this._editLink() },
            'Edit'
          )
        )
      );
    }
  }]);

  return IncidentTemplateListItem;
}(React.Component);

module.exports = IncidentTemplateListItem;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _inflection = __webpack_require__(141);

var _inflection2 = _interopRequireDefault(_inflection);

var _select_input = __webpack_require__(143);

var _select_input2 = _interopRequireDefault(_select_input);

var _input = __webpack_require__(86);

var _input2 = _interopRequireDefault(_input);

var _form = __webpack_require__(250);

var _form2 = _interopRequireDefault(_form);

var _textarea = __webpack_require__(198);

var _textarea2 = _interopRequireDefault(_textarea);

var _type_selector = __webpack_require__(1256);

var _type_selector2 = _interopRequireDefault(_type_selector);

var _coupon_selector = __webpack_require__(1257);

var _coupon_selector2 = _interopRequireDefault(_coupon_selector);

var _plan_selector = __webpack_require__(1258);

var _plan_selector2 = _interopRequireDefault(_plan_selector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UpdateBillingSubscriptionModal = function (_React$Component) {
  _inherits(UpdateBillingSubscriptionModal, _React$Component);

  /**
   * A billing subscription tuning dialog.  Takes a billing subscription and hits the Manage::Admin::BillingSubscriptionController#create endpoint.
   *
   * @param props
   * @param props.coupons {Array}
   * @param props.plans {Array}
   * @param props.page
   * @param props.page.id
   * @param props.page.billing_subscription
   * @param props.page.billing_subscription.type
   * @param props.page.billing_subscription.effective_plan
   * @param props.page.billing_subscription.coupon_enabled
   * @param props.page.billing_subscription.plan_enabled
   * @param props.page.billing_subscription.quantity
   * @param props.page.billing_subscription.note
   * @param props.onClose {Function} Function to call when the modal is closed
   */
  function UpdateBillingSubscriptionModal(props) {
    _classCallCheck(this, UpdateBillingSubscriptionModal);

    var _this = _possibleConstructorReturn(this, (UpdateBillingSubscriptionModal.__proto__ || Object.getPrototypeOf(UpdateBillingSubscriptionModal)).call(this, props));

    _this.state = _this.props.page.billing_subscription;
    return _this;
  }

  _createClass(UpdateBillingSubscriptionModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.setState(newProps.page.billing_subscription);
    }
  }, {
    key: 'disableSubmitButton',
    value: function disableSubmitButton() {
      var $button = $(this.refs.submitButton);
      $button.text('Updating...');
      $button.addClass('disabled').attr('disabled', true);
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      if (event.target.name === 'billing_subscription[type]') {
        var newState = { type: event.target.value };
        // If the the new, selected type is NOT plan enabled,
        // We need to set the current plan to business.
        if (!this.props.types[event.target.value].plan_enabled) {
          // Fine the business plan, and add it to the new state object
          newState.plan = _.find(this.props.plans, { name: 'business' });
        }
        // set the new state
        this.setState(newState);
      } else if (event.target.name === 'billing_subscription[coupon]') {
        this.setState({ coupon: event.target.value });
      } else if (event.target.name === 'billing_subscription[plan_id]') {
        var plan_id = event.target.value;
        // Lookup the plan from the plans array
        this.setState({ plan: _.find(this.props.plans, { id: plan_id }) });
      }
    }
  }, {
    key: 'subscriptionIdInput',
    value: function subscriptionIdInput() {
      if (this.state.type !== 'StripeBillingSubscription') return;
      return _react2.default.createElement(_input2.default, { name: 'billing_subscription[subscription_id]',
        label: 'Subscription ID',
        helpBlockText: 'If you can\'t find an appropriate plan and discount, you can create a subscription in Stripe and apply it here.' });
    }
  }, {
    key: 'quantityInput',
    value: function quantityInput() {
      if (this.state.plan.cost !== 100) return;
      return _react2.default.createElement(_input2.default, { name: 'billing_subscription[quantity]',
        label: 'Quantity',
        defaultValue: this.state.quantity
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'modal hide fade', id: this.props.id },
        _react2.default.createElement(
          _form2.default,
          { ref: 'form', 'for': 'billing_subscription', action: Routes.page_admin_billing_subscriptions_path(this.props.page), method: 'POST', className: 'form-horizontal', skipPrepend: true, onSubmit: this.disableSubmitButton.bind(this) },
          _react2.default.createElement(
            'div',
            { className: 'modal-header' },
            _react2.default.createElement(
              'a',
              { href: '#', className: 'close', 'data-dismiss': 'modal' },
              'x'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Update billing subscription'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'modal-body', style: { maxHeight: 470 } },
            _react2.default.createElement(_type_selector2.default, { types: this.props.types,
              type: this.state.type,
              plan: this.state.plan,
              onChange: this.onChange.bind(this) }),
            _react2.default.createElement(_plan_selector2.default, { types: this.props.types,
              type: this.state.type,
              plan: this.state.plan,
              plans: this.props.plans,
              onChange: this.onChange.bind(this) }),
            this.quantityInput(),
            _react2.default.createElement(_coupon_selector2.default, { types: this.props.types,
              type: this.state.type,
              coupons: this.props.coupons,
              coupon: this.state.coupon,
              onChange: this.onChange.bind(this) }),
            this.subscriptionIdInput(),
            _react2.default.createElement(_textarea2.default, { name: 'billing_subscription[note]',
              label: 'Note',
              required: true,
              defaultValue: this.state.note })
          ),
          _react2.default.createElement(
            'div',
            { className: 'modal-footer' },
            _react2.default.createElement(
              'button',
              { className: 'cpt-button style-primary', ref: 'submitButton' },
              'Update Subscription'
            ),
            _react2.default.createElement(
              'a',
              { href: '#', id: this.props.id, 'data-dismiss': 'modal', className: 'close' },
              'Cancel'
            )
          )
        )
      );
    }
  }]);

  return UpdateBillingSubscriptionModal;
}(_react2.default.Component);

module.exports = UpdateBillingSubscriptionModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabPanels;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tab_panel = __webpack_require__(657);

var _tab_panel2 = _interopRequireDefault(_tab_panel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Virtual container for the tab content area.
// Exactly one of the child tab content areas is rendered.
function TabPanels(_ref) {
  var children = _ref.children,
      activeName = _ref.activeName;

  var clonedChildren = _react2.default.Children.map(children, function (child) {
    return _react2.default.cloneElement(child, { activeName: activeName });
  });
  return _react2.default.createElement(
    'div',
    null,
    clonedChildren
  );
}

TabPanels.propTypes = {
  activeName: _propTypes2.default.string,
  children: _propTypes2.default.arrayOf(_tab_panel2.default).isRequired
};

TabPanels.defaultProps = {
  activeName: null
};

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabPanel;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(20);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Tab content area.
/* Cannot desctructure the for keyword here, unfortunately. */
function TabPanel(props) {
  var activeName = props.activeName,
      className = props.className,
      children = props.children;

  return _react2.default.createElement(
    'div',
    { style: { display: props.for === activeName ? 'block' : 'none' }, className: (0, _classnames2.default)('tab-panel', className) },
    children
  );
}

TabPanel.propTypes = {
  activeName: _propTypes2.default.node,
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  for: _propTypes2.default.string.isRequired
};

TabPanel.defaultProps = {
  className: '',
  activeName: null
};

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabHeaders;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(20);

var _classnames2 = _interopRequireDefault(_classnames);

var _tab_header = __webpack_require__(659);

var _tab_header2 = _interopRequireDefault(_tab_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// An ordered group of clickable headers, one of which is active.
function TabHeaders(_ref) {
  var children = _ref.children,
      activeName = _ref.activeName,
      className = _ref.className,
      onActivate = _ref.onActivate;

  var clonedChildren = _react2.default.Children.map(children, function (child) {
    return _react2.default.cloneElement(child, {
      activeName: activeName,
      onClick: function onClick() {
        return onActivate(child.props.name);
      }
    });
  });

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('tab-headers', className) },
    clonedChildren
  );
}

TabHeaders.propTypes = {
  children: _propTypes2.default.arrayOf(_propTypes2.default.shape({ type: _propTypes2.default.oneOf([_tab_header2.default]) })).isRequired,
  activeName: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onActivate: _propTypes2.default.func
};

TabHeaders.defaultProps = {
  className: '',
  activeName: null,
  onActivate: function onActivate() {}
};

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabHeader;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(20);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// One clickable header for a tab group.
function TabHeader(_ref) {
  var name = _ref.name,
      activeName = _ref.activeName,
      onClick = _ref.onClick,
      className = _ref.className,
      children = _ref.children;

  return _react2.default.createElement(
    'div',
    {
      onClick: onClick,
      className: (0, _classnames2.default)('tab-header', name === activeName ? 'active' : 'inactive', className) },
    children
  );
}

TabHeader.propTypes = {
  activeName: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  // On click, calls this callback.
  onClick: _propTypes2.default.func,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired
};

TabHeader.defaultProps = {
  activeName: null,
  onClick: function onClick() {},
  className: ''
};

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CptAlertBox;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(20);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_CLASSES = {
  info: 'fa-info-circle',
  warning: 'fa-warning',
  error: 'fa-exclamation-circle',
  success: 'fa-check-circle'
};

// Displays a header and body in a box.
// The box is formatted according to the type prop.
function CptAlertBox(props) {
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('alert-box', 'cpt-notification', props.type, 'in-page') },
    _react2.default.createElement(
      'div',
      { className: 'header' },
      _react2.default.createElement('span', { className: (0, _classnames2.default)('fa', ICON_CLASSES[props.type]), style: { marginRight: '4px' } }),
      props.header
    ),
    _react2.default.createElement(
      'div',
      { className: 'body' },
      props.body
    )
  );
}

CptAlertBox.propTypes = {
  type: _propTypes2.default.oneOf(['info', 'error', 'warning', 'success']).isRequired, // Dictating the display type
  // The larger, heading message
  header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]).isRequired,
  // The larger, heading message
  body: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]).isRequired
};

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(20);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pill = function (_Component) {
  _inherits(Pill, _Component);

  function Pill() {
    _classCallCheck(this, Pill);

    return _possibleConstructorReturn(this, (Pill.__proto__ || Object.getPrototypeOf(Pill)).apply(this, arguments));
  }

  _createClass(Pill, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'button',
        {
          className: (0, _classnames2.default)('pill', this.props.active ? 'active' : 'inactive', this.props.className),
          onClick: function onClick() {
            return _this2.props.onClick(_this2.props.value);
          } },
        this.props.children
      );
    }
  }]);

  return Pill;
}(_react.Component);

Pill.propTypes = {
  // `value` declares the value identifying this pill in the pill group.
  value: _propTypes2.default.string.isRequired,

  // `active` declares whether or not the pill is clickable.
  active: _propTypes2.default.bool,

  // On click, calls this callback with this component's `value` as the only arguemnt.
  onClick: _propTypes2.default.func,

  // The label/content of the pill group
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]))]).isRequired,
  className: _propTypes2.default.string
};
Pill.defaultProps = {
  active: false,
  onClick: function onClick() {},
  className: ''
};
exports.default = Pill;


module.exports = Pill;

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var SubscriberState;
(function (SubscriberState) {
    SubscriberState["ACTIVE"] = "active";
    SubscriberState["QUARANTINED"] = "quarantined";
    SubscriberState["UNCONFIRMED"] = "unconfirmed";
})(SubscriberState || (SubscriberState = {}));
var SubscriberAction = /** @class */ (function (_super) {
    __extends(SubscriberAction, _super);
    function SubscriberAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubscriberAction.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "subscriber-action link-like foobar " + this.props.className, onClick: function (e) {
                return _this.props.onClick(e, undefined, _this.props.subscriberState);
            } }, this.props.children));
    };
    SubscriberAction.defaultProps = {
        className: '',
        children: null,
        onClick: function () { },
        subscriberState: 'active',
    };
    return SubscriberAction;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["default"] = (SubscriberAction);


/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _color2 = __webpack_require__(342);

var _color3 = _interopRequireDefault(_color2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  background: function background() {
    if (this.props.template === 'background') {
      if (this.props.background_image) {
        return this.background_image(this.props.background_image);
      }
      return {};
    }
    if (this.props.background_color) {
      return this.background_color(this.props.background_color);
    }
    return {};
  },
  background_color: function background_color(color) {
    if (color) {
      return { backgroundColor: new _color3.default(color).toRgba() };
    }
    return {};
  },
  background_image: function background_image(url) {
    if (url) {
      return { backgroundImage: 'url("' + url + '")' };
    }
    return {};
  },
  borderColor: function borderColor(color) {
    if (color) {
      return { borderColor: new _color3.default(color).toRgba() };
    }
    return {};
  },
  color: function color(_color) {
    if (_color) {
      return { color: new _color3.default(_color).toRgba() };
    }
    return {};
  },
  primary_text_color: function primary_text_color() {
    return this.color(this.props.primary_text_color);
  },
  primaryBorderColor: function primaryBorderColor() {
    return this.borderColor(this.props.primary_text_color);
  },
  secondary_text_color: function secondary_text_color() {
    return this.color(this.props.secondary_text_color);
  },
  hrBackgroundColor: function hrBackgroundColor() {
    return this.background_color(this.props.secondary_text_color);
  },
  button: function button() {
    if (this.props.button_color && this.props.button_text_color) {
      return {
        background: new _color3.default(this.props.button_color).toRgba(),
        color: new _color3.default(this.props.button_text_color).toRgba()
      };
    }
    return {};
  },
  borderButton: function borderButton() {
    if (this.props.button_color) {
      return {
        color: new _color3.default(this.props.button_color).toRgba(),
        borderColor: new _color3.default(this.props.button_color).toRgba()
      };
    }
    return {};
  },


  /**
   * Shadow distance takes a max integer of 100, min of 0
   * the strength should be the inverse of the value divided by 100
   * We also need to normalize any color input, so that can happen here too.
   * @returns {{boxShadow: string}}
   */
  shadow: function shadow() {
    if (this.props.shadow_distance) {
      var distance = this.props.shadow_distance;
      var strength = (100 - distance) / 100.0;
      var color = new _color3.default(this.props.shadow_color);
      color.a = strength;
      return { boxShadow: '0 0 ' + distance + 'px ' + color.toRgba() };
    }
    return {};
  },


  /**
   * We should probably do a more descriptive name here, something relating to hiding.
   * @returns {*}
   */
  has_status_page: function has_status_page() {
    if (this.props.has_status_page === 'no') {
      return { display: 'none' };
    }
    return {};
  },


  /**
   * This is a simple multi object merge.  Takes an arbitrary number of objects
   * @returns {Object} single object with all the attributes of the inputed
   */
  mergeStyles: function mergeStyles() {
    var newObj = {};
    for (var i = 0; i < arguments.length; i++) {
      for (var attrname in arguments[i]) {
        newObj[attrname] = arguments[i][attrname];
      }
    }
    return newObj;
  },
  support_email_address: function support_email_address() {
    if (this.props.support_email_address) {
      if (this.props.support_email_address.indexOf('@') != -1) {
        return 'mailto:' + this.props.support_email_address;
      }

      return this.props.support_email_address;
    }
    return 'javascript:alert("Looks like you didn\'t add a Support URL on the previous step.")';
  },
  href: function href(url) {
    if (url) {
      // We need to add http to urls so the links work and aren't relative
      return url.toLowerCase().indexOf('http') < 0 ? 'http://' + url : url;
    }
    return '#';
  }
};

/***/ })

},[1133]);


// WEBPACK FOOTER //
// components-b2673cbdd7a90085b163.js